export var AnnualRentIncreaseEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "PERCENTAGE",
      value: "0",
      label: "%",
      abbreviation: "PERCENTAGE",
      order: 1
    },
    "1": {
      name: "DOLLAR",
      value: "1",
      label: "Cash",
      abbreviation: "DOLLAR",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "PERCENTAGE": {
    name: "PERCENTAGE",
    value: "0",
    label: "%",
    abbreviation: "PERCENTAGE",
    order: 1
  },
  "DOLLAR": {
    name: "DOLLAR",
    value: "1",
    label: "Cash",
    abbreviation: "DOLLAR",
    order: 2
  }
};
export var BuildOutStateEnum = {
  values: {
    "pursuit": {
      name: "PURSUIT",
      value: "pursuit",
      label: "Pursuit",
      abbreviation: "PURSUIT",
      order: 0
    },
    "active": {
      name: "ACTIVE",
      value: "active",
      label: "Active",
      abbreviation: "ACTIVE",
      order: 1
    },
    "completed": {
      name: "COMPLETED",
      value: "completed",
      label: "Completed",
      abbreviation: "COMPLETED",
      order: 2
    },
    "lost_pursuit": {
      name: "LOST_PURSUIT",
      value: "lost_pursuit",
      label: "Lost Pursuit",
      abbreviation: "LOST_PURSUIT",
      order: 3
    },
    "lost_active": {
      name: "LOST_ACTIVE",
      value: "lost_active",
      label: "Lost Active",
      abbreviation: "LOST_ACTIVE",
      order: 4
    }
  },
  "PURSUIT": {
    name: "PURSUIT",
    value: "pursuit",
    label: "Pursuit",
    abbreviation: "PURSUIT",
    order: 0
  },
  "ACTIVE": {
    name: "ACTIVE",
    value: "active",
    label: "Active",
    abbreviation: "ACTIVE",
    order: 1
  },
  "COMPLETED": {
    name: "COMPLETED",
    value: "completed",
    label: "Completed",
    abbreviation: "COMPLETED",
    order: 2
  },
  "LOST_PURSUIT": {
    name: "LOST_PURSUIT",
    value: "lost_pursuit",
    label: "Lost Pursuit",
    abbreviation: "LOST_PURSUIT",
    order: 3
  },
  "LOST_ACTIVE": {
    name: "LOST_ACTIVE",
    value: "lost_active",
    label: "Lost Active",
    abbreviation: "LOST_ACTIVE",
    order: 4
  }
};
export var FreeRentEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "MONTHS",
      value: "0",
      label: "Months",
      abbreviation: "MONTHS",
      order: 1
    },
    "1": {
      name: "DOLLAR",
      value: "1",
      label: "Cash",
      abbreviation: "DOLLAR",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "MONTHS": {
    name: "MONTHS",
    value: "0",
    label: "Months",
    abbreviation: "MONTHS",
    order: 1
  },
  "DOLLAR": {
    name: "DOLLAR",
    value: "1",
    label: "Cash",
    abbreviation: "DOLLAR",
    order: 2
  }
};
export var TIExpensesEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "PER_SQFT",
      value: "0",
      label: "sqft",
      abbreviation: "PER_SQFT",
      order: 1
    },
    "1": {
      name: "DOLLAR",
      value: "1",
      label: "$",
      abbreviation: "DOLLAR",
      order: 2
    },
    "2": {
      name: "PER_SQFT_YR",
      value: "2",
      label: "sqft/yr",
      abbreviation: "PER_SQFT_YR",
      order: 3
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "PER_SQFT": {
    name: "PER_SQFT",
    value: "0",
    label: "sqft",
    abbreviation: "PER_SQFT",
    order: 1
  },
  "DOLLAR": {
    name: "DOLLAR",
    value: "1",
    label: "$",
    abbreviation: "DOLLAR",
    order: 2
  },
  "PER_SQFT_YR": {
    name: "PER_SQFT_YR",
    value: "2",
    label: "sqft/yr",
    abbreviation: "PER_SQFT_YR",
    order: 3
  }
};
export var ListingStateEnum = {
  values: {
    "predicted": {
      name: "PREDICTED",
      value: "predicted",
      label: "Predicted",
      abbreviation: "PREDICTED",
      order: 0
    },
    "on_market": {
      name: "ON_MARKET",
      value: "on_market",
      label: "On Market",
      abbreviation: "ON_MARKET",
      order: 1
    },
    "proposals": {
      name: "IN_PROPOSALS",
      value: "proposals",
      label: "In Proposals",
      abbreviation: "IN_PROPOSALS",
      order: 2
    },
    "leases": {
      name: "IN_LEASES",
      value: "leases",
      label: "In Leases",
      abbreviation: "IN_LEASES",
      order: 3
    },
    "leased": {
      name: "LEASED",
      value: "leased",
      label: "Leased",
      abbreviation: "LEASED",
      order: 4
    },
    "dead": {
      name: "DEAD",
      value: "dead",
      label: "Pulled From Market",
      abbreviation: "DEAD",
      order: 5
    },
    "not_available": {
      name: "NOT_AVAILABLE",
      value: "not_available",
      label: "Not Available",
      abbreviation: "NOT_AVAILABLE",
      order: 6
    }
  },
  "PREDICTED": {
    name: "PREDICTED",
    value: "predicted",
    label: "Predicted",
    abbreviation: "PREDICTED",
    order: 0
  },
  "ON_MARKET": {
    name: "ON_MARKET",
    value: "on_market",
    label: "On Market",
    abbreviation: "ON_MARKET",
    order: 1
  },
  "IN_PROPOSALS": {
    name: "IN_PROPOSALS",
    value: "proposals",
    label: "In Proposals",
    abbreviation: "IN_PROPOSALS",
    order: 2
  },
  "IN_LEASES": {
    name: "IN_LEASES",
    value: "leases",
    label: "In Leases",
    abbreviation: "IN_LEASES",
    order: 3
  },
  "LEASED": {
    name: "LEASED",
    value: "leased",
    label: "Leased",
    abbreviation: "LEASED",
    order: 4
  },
  "DEAD": {
    name: "DEAD",
    value: "dead",
    label: "Pulled From Market",
    abbreviation: "DEAD",
    order: 5
  },
  "NOT_AVAILABLE": {
    name: "NOT_AVAILABLE",
    value: "not_available",
    label: "Not Available",
    abbreviation: "NOT_AVAILABLE",
    order: 6
  }
};
export var ExpenseTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "FULL_SERVICE",
      value: "0",
      label: "Full Service",
      abbreviation: "FSG",
      order: 1
    },
    "1": {
      name: "INDUSTRIAL_GROSS",
      value: "1",
      label: "Industrial Gross",
      abbreviation: "IG",
      order: 2
    },
    "2": {
      name: "MODIFIED_GROSS",
      value: "2",
      label: "Modified Gross",
      abbreviation: "MG",
      order: 3
    },
    "3": {
      name: "NET_OF_JANITORIAL",
      value: "3",
      label: "Net of Janitorial",
      abbreviation: "NJ",
      order: 4
    },
    "4": {
      name: "NET_OF_ELECTRIC",
      value: "4",
      label: "Net of Electric",
      abbreviation: "NE",
      order: 5
    },
    "5": {
      name: "NNN",
      value: "5",
      label: "NNN",
      abbreviation: "NNN",
      order: 6
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "FULL_SERVICE": {
    name: "FULL_SERVICE",
    value: "0",
    label: "Full Service",
    abbreviation: "FSG",
    order: 1
  },
  "INDUSTRIAL_GROSS": {
    name: "INDUSTRIAL_GROSS",
    value: "1",
    label: "Industrial Gross",
    abbreviation: "IG",
    order: 2
  },
  "MODIFIED_GROSS": {
    name: "MODIFIED_GROSS",
    value: "2",
    label: "Modified Gross",
    abbreviation: "MG",
    order: 3
  },
  "NET_OF_JANITORIAL": {
    name: "NET_OF_JANITORIAL",
    value: "3",
    label: "Net of Janitorial",
    abbreviation: "NJ",
    order: 4
  },
  "NET_OF_ELECTRIC": {
    name: "NET_OF_ELECTRIC",
    value: "4",
    label: "Net of Electric",
    abbreviation: "NE",
    order: 5
  },
  "NNN": {
    name: "NNN",
    value: "5",
    label: "NNN",
    abbreviation: "NNN",
    order: 6
  }
};
export var ExpenseTypeDefaultExpensesEnum = {
  values: {
    "1_sqft_mo": {
      name: "INDUSTRIAL_GROSS_SQFT_MO",
      value: "1_sqft_mo",
      label: "0.35",
      abbreviation: "0.35",
      order: 0
    },
    "1_sqft_yr": {
      name: "INDUSTRIAL_GROSS_SQFT_YR",
      value: "1_sqft_yr",
      label: "4",
      abbreviation: "4",
      order: 1
    },
    "2_sqft_mo": {
      name: "MODIFIED_GROSS_SQFT_MO",
      value: "2_sqft_mo",
      label: "0.35",
      abbreviation: "0.35",
      order: 2
    },
    "2_sqft_yr": {
      name: "MODIFIED_GROSS_SQFT_YR",
      value: "2_sqft_yr",
      label: "4",
      abbreviation: "4",
      order: 3
    },
    "3_sqft_mo": {
      name: "NET_OF_JANITORIAL_SQFT_MO",
      value: "3_sqft_mo",
      label: "0.1",
      abbreviation: "0.1",
      order: 4
    },
    "3_sqft_yr": {
      name: "NET_OF_JANITORIAL_SQFT_YR",
      value: "3_sqft_yr",
      label: "2",
      abbreviation: "2",
      order: 5
    },
    "4_sqft_mo": {
      name: "NET_OF_ELECTRIC_SQFT_MO",
      value: "4_sqft_mo",
      label: "0.25",
      abbreviation: "0.25",
      order: 6
    },
    "4_sqft_yr": {
      name: "NET_OF_ELECTRIC_SQFT_YR",
      value: "4_sqft_yr",
      label: "3",
      abbreviation: "3",
      order: 7
    }
  },
  "INDUSTRIAL_GROSS_SQFT_MO": {
    name: "INDUSTRIAL_GROSS_SQFT_MO",
    value: "1_sqft_mo",
    label: "0.35",
    abbreviation: "0.35",
    order: 0
  },
  "INDUSTRIAL_GROSS_SQFT_YR": {
    name: "INDUSTRIAL_GROSS_SQFT_YR",
    value: "1_sqft_yr",
    label: "4",
    abbreviation: "4",
    order: 1
  },
  "MODIFIED_GROSS_SQFT_MO": {
    name: "MODIFIED_GROSS_SQFT_MO",
    value: "2_sqft_mo",
    label: "0.35",
    abbreviation: "0.35",
    order: 2
  },
  "MODIFIED_GROSS_SQFT_YR": {
    name: "MODIFIED_GROSS_SQFT_YR",
    value: "2_sqft_yr",
    label: "4",
    abbreviation: "4",
    order: 3
  },
  "NET_OF_JANITORIAL_SQFT_MO": {
    name: "NET_OF_JANITORIAL_SQFT_MO",
    value: "3_sqft_mo",
    label: "0.1",
    abbreviation: "0.1",
    order: 4
  },
  "NET_OF_JANITORIAL_SQFT_YR": {
    name: "NET_OF_JANITORIAL_SQFT_YR",
    value: "3_sqft_yr",
    label: "2",
    abbreviation: "2",
    order: 5
  },
  "NET_OF_ELECTRIC_SQFT_MO": {
    name: "NET_OF_ELECTRIC_SQFT_MO",
    value: "4_sqft_mo",
    label: "0.25",
    abbreviation: "0.25",
    order: 6
  },
  "NET_OF_ELECTRIC_SQFT_YR": {
    name: "NET_OF_ELECTRIC_SQFT_YR",
    value: "4_sqft_yr",
    label: "3",
    abbreviation: "3",
    order: 7
  }
};
export var LeaseTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "direct": {
      name: "DIRECT",
      value: "direct",
      label: "Direct",
      abbreviation: "DIRECT",
      order: 1
    },
    "sublease": {
      name: "SUBLEASE",
      value: "sublease",
      label: "Sublease",
      abbreviation: "SUBLEASE",
      order: 2
    },
    "shared": {
      name: "SHARED",
      value: "shared",
      label: "Shared",
      abbreviation: "SHARED",
      order: 3
    },
    "cowork": {
      name: "COWORKING",
      value: "cowork",
      label: "Coworking",
      abbreviation: "COWORKING",
      order: 4
    },
    "ent_cowork": {
      name: "ENTERPRISE_COWORKING",
      value: "ent_cowork",
      label: "Agile",
      abbreviation: "ENTERPRISE_COWORKING",
      order: 5
    },
    "sale": {
      name: "SALE",
      value: "sale",
      label: "Sale",
      abbreviation: "SALE",
      order: 6
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "DIRECT": {
    name: "DIRECT",
    value: "direct",
    label: "Direct",
    abbreviation: "DIRECT",
    order: 1
  },
  "SUBLEASE": {
    name: "SUBLEASE",
    value: "sublease",
    label: "Sublease",
    abbreviation: "SUBLEASE",
    order: 2
  },
  "SHARED": {
    name: "SHARED",
    value: "shared",
    label: "Shared",
    abbreviation: "SHARED",
    order: 3
  },
  "COWORKING": {
    name: "COWORKING",
    value: "cowork",
    label: "Coworking",
    abbreviation: "COWORKING",
    order: 4
  },
  "ENTERPRISE_COWORKING": {
    name: "ENTERPRISE_COWORKING",
    value: "ent_cowork",
    label: "Agile",
    abbreviation: "ENTERPRISE_COWORKING",
    order: 5
  },
  "SALE": {
    name: "SALE",
    value: "sale",
    label: "Sale",
    abbreviation: "SALE",
    order: 6
  }
};
export var SpaceTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "OFFICE",
      value: "0",
      label: "Office",
      abbreviation: "OFFICE",
      order: 1
    },
    "1": {
      name: "RETAIL",
      value: "1",
      label: "Retail",
      abbreviation: "RETAIL",
      order: 2
    },
    "2": {
      name: "LIVE_WORK",
      value: "2",
      label: "Live/Work",
      abbreviation: "LIVE_WORK",
      order: 3
    },
    "3": {
      name: "INDUSTRIAL",
      value: "3",
      label: "Industrial",
      abbreviation: "INDUSTRIAL",
      order: 4
    },
    "4": {
      name: "PDR",
      value: "4",
      label: "PDR",
      abbreviation: "PDR",
      order: 5
    },
    "5": {
      name: "CLASSROOM",
      value: "5",
      label: "Classroom",
      abbreviation: "CLASSROOM",
      order: 6
    },
    "6": {
      name: "MEDICAL",
      value: "6",
      label: "Medical",
      abbreviation: "MEDICAL",
      order: 7
    },
    "7": {
      name: "LIFE_SCIENCE",
      value: "7",
      label: "Life Science",
      abbreviation: "LIFE_SCIENCE",
      order: 8
    },
    "8": {
      name: "RESEARCH_AND_DEVELOPMENT",
      value: "8",
      label: "R&D",
      abbreviation: "RESEARCH_AND_DEVELOPMENT",
      order: 9
    },
    "9": {
      name: "FLEX",
      value: "9",
      label: "Flex",
      abbreviation: "FLEX",
      order: 10
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "OFFICE": {
    name: "OFFICE",
    value: "0",
    label: "Office",
    abbreviation: "OFFICE",
    order: 1
  },
  "RETAIL": {
    name: "RETAIL",
    value: "1",
    label: "Retail",
    abbreviation: "RETAIL",
    order: 2
  },
  "LIVE_WORK": {
    name: "LIVE_WORK",
    value: "2",
    label: "Live/Work",
    abbreviation: "LIVE_WORK",
    order: 3
  },
  "INDUSTRIAL": {
    name: "INDUSTRIAL",
    value: "3",
    label: "Industrial",
    abbreviation: "INDUSTRIAL",
    order: 4
  },
  "PDR": {
    name: "PDR",
    value: "4",
    label: "PDR",
    abbreviation: "PDR",
    order: 5
  },
  "CLASSROOM": {
    name: "CLASSROOM",
    value: "5",
    label: "Classroom",
    abbreviation: "CLASSROOM",
    order: 6
  },
  "MEDICAL": {
    name: "MEDICAL",
    value: "6",
    label: "Medical",
    abbreviation: "MEDICAL",
    order: 7
  },
  "LIFE_SCIENCE": {
    name: "LIFE_SCIENCE",
    value: "7",
    label: "Life Science",
    abbreviation: "LIFE_SCIENCE",
    order: 8
  },
  "RESEARCH_AND_DEVELOPMENT": {
    name: "RESEARCH_AND_DEVELOPMENT",
    value: "8",
    label: "R&D",
    abbreviation: "RESEARCH_AND_DEVELOPMENT",
    order: 9
  },
  "FLEX": {
    name: "FLEX",
    value: "9",
    label: "Flex",
    abbreviation: "FLEX",
    order: 10
  }
};
export var FloorTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "FULL",
      value: "0",
      label: "Full",
      abbreviation: "FULL",
      order: 1
    },
    "1": {
      name: "PARTIAL",
      value: "1",
      label: "Partial",
      abbreviation: "PARTIAL",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "FULL": {
    name: "FULL",
    value: "0",
    label: "Full",
    abbreviation: "FULL",
    order: 1
  },
  "PARTIAL": {
    name: "PARTIAL",
    value: "1",
    label: "Partial",
    abbreviation: "PARTIAL",
    order: 2
  }
};
export var OccupancyTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "30_days": {
      name: "THIRTY_DAYS",
      value: "30_days",
      label: "30 Days",
      abbreviation: "30 d",
      order: 1
    },
    "60_days": {
      name: "SIXTY_DAYS",
      value: "60_days",
      label: "60 Days",
      abbreviation: "60 d",
      order: 2
    },
    "90_days": {
      name: "NINTY_DAYS",
      value: "90_days",
      label: "90 Days",
      abbreviation: "90 d",
      order: 3
    },
    "120_days": {
      name: "ONE_TWENTY_DAYS",
      value: "120_days",
      label: "120 Days",
      abbreviation: "120 d",
      order: 4
    },
    "now": {
      name: "NOW",
      value: "now",
      label: "Now",
      abbreviation: "Now",
      order: 5
    },
    "q1": {
      name: "Q1",
      value: "q1",
      label: "Q1 of ...",
      abbreviation: "Q1",
      order: 6
    },
    "q2": {
      name: "Q2",
      value: "q2",
      label: "Q2 of ...",
      abbreviation: "Q2",
      order: 7
    },
    "q3": {
      name: "Q3",
      value: "q3",
      label: "Q3 of ...",
      abbreviation: "Q3",
      order: 8
    },
    "q4": {
      name: "Q4",
      value: "q4",
      label: "Q4 of ...",
      abbreviation: "Q4",
      order: 9
    },
    "date": {
      name: "DATE",
      value: "date",
      label: "Date",
      abbreviation: "Date",
      order: 10
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "THIRTY_DAYS": {
    name: "THIRTY_DAYS",
    value: "30_days",
    label: "30 Days",
    abbreviation: "30 d",
    order: 1
  },
  "SIXTY_DAYS": {
    name: "SIXTY_DAYS",
    value: "60_days",
    label: "60 Days",
    abbreviation: "60 d",
    order: 2
  },
  "NINTY_DAYS": {
    name: "NINTY_DAYS",
    value: "90_days",
    label: "90 Days",
    abbreviation: "90 d",
    order: 3
  },
  "ONE_TWENTY_DAYS": {
    name: "ONE_TWENTY_DAYS",
    value: "120_days",
    label: "120 Days",
    abbreviation: "120 d",
    order: 4
  },
  "NOW": {
    name: "NOW",
    value: "now",
    label: "Now",
    abbreviation: "Now",
    order: 5
  },
  "Q1": {
    name: "Q1",
    value: "q1",
    label: "Q1 of ...",
    abbreviation: "Q1",
    order: 6
  },
  "Q2": {
    name: "Q2",
    value: "q2",
    label: "Q2 of ...",
    abbreviation: "Q2",
    order: 7
  },
  "Q3": {
    name: "Q3",
    value: "q3",
    label: "Q3 of ...",
    abbreviation: "Q3",
    order: 8
  },
  "Q4": {
    name: "Q4",
    value: "q4",
    label: "Q4 of ...",
    abbreviation: "Q4",
    order: 9
  },
  "DATE": {
    name: "DATE",
    value: "date",
    label: "Date",
    abbreviation: "Date",
    order: 10
  }
};
export var TermFormatEnum = {
  values: {
    "0": {
      name: "EXPIRATION_DATE",
      value: "0",
      label: "Expiration Date",
      abbreviation: "EXPIRATION_DATE",
      order: 0
    },
    "1": {
      name: "TERM_RANGE",
      value: "1",
      label: "Term Range",
      abbreviation: "TERM_RANGE",
      order: 1
    },
    "2": {
      name: "NEGOTIABLE",
      value: "2",
      label: "Negotiable",
      abbreviation: "NEGOTIABLE",
      order: 2
    }
  },
  "EXPIRATION_DATE": {
    name: "EXPIRATION_DATE",
    value: "0",
    label: "Expiration Date",
    abbreviation: "EXPIRATION_DATE",
    order: 0
  },
  "TERM_RANGE": {
    name: "TERM_RANGE",
    value: "1",
    label: "Term Range",
    abbreviation: "TERM_RANGE",
    order: 1
  },
  "NEGOTIABLE": {
    name: "NEGOTIABLE",
    value: "2",
    label: "Negotiable",
    abbreviation: "NEGOTIABLE",
    order: 2
  }
};
export var TermTypeEnum = {
  values: {
    "0": {
      name: "YEARS",
      value: "0",
      label: "years",
      abbreviation: "YEARS",
      order: 0
    },
    "1": {
      name: "MONTHS",
      value: "1",
      label: "months",
      abbreviation: "MONTHS",
      order: 1
    }
  },
  "YEARS": {
    name: "YEARS",
    value: "0",
    label: "years",
    abbreviation: "YEARS",
    order: 0
  },
  "MONTHS": {
    name: "MONTHS",
    value: "1",
    label: "months",
    abbreviation: "MONTHS",
    order: 1
  }
};
export var CeilingTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "exposed": {
      name: "EXPOSED",
      value: "exposed",
      label: "Exposed",
      abbreviation: "EXPOSED",
      order: 1
    },
    "dropped": {
      name: "DROPPED",
      value: "dropped",
      label: "Dropped",
      abbreviation: "DROPPED",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "EXPOSED": {
    name: "EXPOSED",
    value: "exposed",
    label: "Exposed",
    abbreviation: "EXPOSED",
    order: 1
  },
  "DROPPED": {
    name: "DROPPED",
    value: "dropped",
    label: "Dropped",
    abbreviation: "DROPPED",
    order: 2
  }
};
export var HVACEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "none": {
      name: "NONE",
      value: "none",
      label: "None",
      abbreviation: "NONE",
      order: 1
    },
    "ac": {
      name: "AC",
      value: "ac",
      label: "AC",
      abbreviation: "AC",
      order: 2
    },
    "heat": {
      name: "HEAT",
      value: "heat",
      label: "Heat",
      abbreviation: "HEAT",
      order: 3
    },
    "hvac": {
      name: "HVAC",
      value: "hvac",
      label: "HVAC",
      abbreviation: "HVAC",
      order: 4
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "NONE": {
    name: "NONE",
    value: "none",
    label: "None",
    abbreviation: "NONE",
    order: 1
  },
  "AC": {
    name: "AC",
    value: "ac",
    label: "AC",
    abbreviation: "AC",
    order: 2
  },
  "HEAT": {
    name: "HEAT",
    value: "heat",
    label: "Heat",
    abbreviation: "HEAT",
    order: 3
  },
  "HVAC": {
    name: "HVAC",
    value: "hvac",
    label: "HVAC",
    abbreviation: "HVAC",
    order: 4
  }
};
export var TransactionTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "new_lease": {
      name: "NEW_LEASE",
      value: "new_lease",
      label: "New Lease",
      abbreviation: "NEW_LEASE",
      order: 1
    },
    "renewal": {
      name: "RENEWAL",
      value: "renewal",
      label: "Renewal",
      abbreviation: "RENEWAL",
      order: 2
    },
    "expansion": {
      name: "EXPANSION",
      value: "expansion",
      label: "Expansion",
      abbreviation: "EXPANSION",
      order: 3
    },
    "renewal_expansion": {
      name: "RENEWAL_EXPANSION",
      value: "renewal_expansion",
      label: "Renewal/Expansion",
      abbreviation: "RENEWAL_EXPANSION",
      order: 4
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "NEW_LEASE": {
    name: "NEW_LEASE",
    value: "new_lease",
    label: "New Lease",
    abbreviation: "NEW_LEASE",
    order: 1
  },
  "RENEWAL": {
    name: "RENEWAL",
    value: "renewal",
    label: "Renewal",
    abbreviation: "RENEWAL",
    order: 2
  },
  "EXPANSION": {
    name: "EXPANSION",
    value: "expansion",
    label: "Expansion",
    abbreviation: "EXPANSION",
    order: 3
  },
  "RENEWAL_EXPANSION": {
    name: "RENEWAL_EXPANSION",
    value: "renewal_expansion",
    label: "Renewal/Expansion",
    abbreviation: "RENEWAL_EXPANSION",
    order: 4
  }
};
export var NaturalLightEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "great": {
      name: "GREAT",
      value: "great",
      label: "Great",
      abbreviation: "GREAT",
      order: 1
    },
    "good": {
      name: "GOOD",
      value: "good",
      label: "Good",
      abbreviation: "GOOD",
      order: 2
    },
    "poor": {
      name: "POOR",
      value: "poor",
      label: "Poor",
      abbreviation: "POOR",
      order: 3
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "GREAT": {
    name: "GREAT",
    value: "great",
    label: "Great",
    abbreviation: "GREAT",
    order: 1
  },
  "GOOD": {
    name: "GOOD",
    value: "good",
    label: "Good",
    abbreviation: "GOOD",
    order: 2
  },
  "POOR": {
    name: "POOR",
    value: "poor",
    label: "Poor",
    abbreviation: "POOR",
    order: 3
  }
};
export var ConditionEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "shell": {
      name: "SHELL",
      value: "shell",
      label: "Shell",
      abbreviation: "SHELL",
      order: 1
    },
    "spec_suite": {
      name: "SPEC_SUITE",
      value: "spec_suite",
      label: "Spec Suite",
      abbreviation: "SPEC_SUITE",
      order: 2
    },
    "built_out": {
      name: "BUILT_OUT",
      value: "built_out",
      label: "Built Out",
      abbreviation: "BUILT_OUT",
      order: 3
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "SHELL": {
    name: "SHELL",
    value: "shell",
    label: "Shell",
    abbreviation: "SHELL",
    order: 1
  },
  "SPEC_SUITE": {
    name: "SPEC_SUITE",
    value: "spec_suite",
    label: "Spec Suite",
    abbreviation: "SPEC_SUITE",
    order: 2
  },
  "BUILT_OUT": {
    name: "BUILT_OUT",
    value: "built_out",
    label: "Built Out",
    abbreviation: "BUILT_OUT",
    order: 3
  }
};
export var DataEmailTemplateTypeEnum = {
  values: {
    "initial": {
      name: "INITIAL_OUTREACH",
      value: "initial",
      label: "Initial Outreach",
      abbreviation: "INITIAL_OUTREACH",
      order: 0
    },
    "confirm": {
      name: "CONFIRMATION",
      value: "confirm",
      label: "Confirmation",
      abbreviation: "CONFIRMATION",
      order: 1
    }
  },
  "INITIAL_OUTREACH": {
    name: "INITIAL_OUTREACH",
    value: "initial",
    label: "Initial Outreach",
    abbreviation: "INITIAL_OUTREACH",
    order: 0
  },
  "CONFIRMATION": {
    name: "CONFIRMATION",
    value: "confirm",
    label: "Confirmation",
    abbreviation: "CONFIRMATION",
    order: 1
  }
};
export var KitchenEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "full": {
      name: "FULL",
      value: "full",
      label: "Full Kitchen",
      abbreviation: "FULL",
      order: 1
    },
    "standard": {
      name: "STANDARD",
      value: "standard",
      label: "Standard Kitchen",
      abbreviation: "STANDARD",
      order: 2
    },
    "kitchenette": {
      name: "KITCHENETTE",
      value: "kitchenette",
      label: "Kitchenette",
      abbreviation: "KITCHENETTE",
      order: 3
    },
    "no_kitchen": {
      name: "NO_KITCHEN",
      value: "no_kitchen",
      label: "No Kitchen",
      abbreviation: "NO_KITCHEN",
      order: 4
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "FULL": {
    name: "FULL",
    value: "full",
    label: "Full Kitchen",
    abbreviation: "FULL",
    order: 1
  },
  "STANDARD": {
    name: "STANDARD",
    value: "standard",
    label: "Standard Kitchen",
    abbreviation: "STANDARD",
    order: 2
  },
  "KITCHENETTE": {
    name: "KITCHENETTE",
    value: "kitchenette",
    label: "Kitchenette",
    abbreviation: "KITCHENETTE",
    order: 3
  },
  "NO_KITCHEN": {
    name: "NO_KITCHEN",
    value: "no_kitchen",
    label: "No Kitchen",
    abbreviation: "NO_KITCHEN",
    order: 4
  }
};
export var RateTypeEnum = {
  values: {
    "sqft_yr": {
      name: "SQFT_YR",
      value: "sqft_yr",
      label: "sf/yr",
      abbreviation: "SQFT_YR",
      order: 0
    },
    "sqm_yr": {
      name: "METER_YR",
      value: "sqm_yr",
      label: "sqm/yr",
      abbreviation: "METER_YR",
      order: 1
    },
    "sqft_mo": {
      name: "SQFT_MO",
      value: "sqft_mo",
      label: "sf/mo",
      abbreviation: "SQFT_MO",
      order: 2
    },
    "m_mo": {
      name: "METER_MO",
      value: "m_mo",
      label: "sqm/mo",
      abbreviation: "METER_MO",
      order: 3
    },
    "yearly": {
      name: "YEARLY",
      value: "yearly",
      label: "yr",
      abbreviation: "YEARLY",
      order: 4
    },
    "monthly": {
      name: "MONTHLY",
      value: "monthly",
      label: "mo",
      abbreviation: "MONTHLY",
      order: 5
    }
  },
  "SQFT_YR": {
    name: "SQFT_YR",
    value: "sqft_yr",
    label: "sf/yr",
    abbreviation: "SQFT_YR",
    order: 0
  },
  "METER_YR": {
    name: "METER_YR",
    value: "sqm_yr",
    label: "sqm/yr",
    abbreviation: "METER_YR",
    order: 1
  },
  "SQFT_MO": {
    name: "SQFT_MO",
    value: "sqft_mo",
    label: "sf/mo",
    abbreviation: "SQFT_MO",
    order: 2
  },
  "METER_MO": {
    name: "METER_MO",
    value: "m_mo",
    label: "sqm/mo",
    abbreviation: "METER_MO",
    order: 3
  },
  "YEARLY": {
    name: "YEARLY",
    value: "yearly",
    label: "yr",
    abbreviation: "YEARLY",
    order: 4
  },
  "MONTHLY": {
    name: "MONTHLY",
    value: "monthly",
    label: "mo",
    abbreviation: "MONTHLY",
    order: 5
  }
};
export var WorkTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "allowance": {
      name: "ALLOWANCE",
      value: "allowance",
      label: "Allowance",
      abbreviation: "ALLOWANCE",
      order: 1
    },
    "turn_key": {
      name: "TURN_KEY",
      value: "turn_key",
      label: "Turn-Key",
      abbreviation: "TURN_KEY",
      order: 2
    },
    "paint_carpet": {
      name: "PAINT_CARPET",
      value: "paint_carpet",
      label: "Paint and Carpet",
      abbreviation: "PAINT_CARPET",
      order: 3
    },
    "spec_suite": {
      name: "SPEC_SUITE",
      value: "spec_suite",
      label: "Spec Suite",
      abbreviation: "SPEC_SUITE",
      order: 4
    },
    "as_is": {
      name: "AS_IS",
      value: "as_is",
      label: "As-Is",
      abbreviation: "AS_IS",
      order: 5
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "ALLOWANCE": {
    name: "ALLOWANCE",
    value: "allowance",
    label: "Allowance",
    abbreviation: "ALLOWANCE",
    order: 1
  },
  "TURN_KEY": {
    name: "TURN_KEY",
    value: "turn_key",
    label: "Turn-Key",
    abbreviation: "TURN_KEY",
    order: 2
  },
  "PAINT_CARPET": {
    name: "PAINT_CARPET",
    value: "paint_carpet",
    label: "Paint and Carpet",
    abbreviation: "PAINT_CARPET",
    order: 3
  },
  "SPEC_SUITE": {
    name: "SPEC_SUITE",
    value: "spec_suite",
    label: "Spec Suite",
    abbreviation: "SPEC_SUITE",
    order: 4
  },
  "AS_IS": {
    name: "AS_IS",
    value: "as_is",
    label: "As-Is",
    abbreviation: "AS_IS",
    order: 5
  }
};
export var ViewSpaceEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "water": {
      name: "WATER",
      value: "water",
      label: "Water",
      abbreviation: "WATER",
      order: 1
    },
    "city": {
      name: "CITY",
      value: "city",
      label: "City",
      abbreviation: "CITY",
      order: 2
    },
    "landscape": {
      name: "LANDSCAPE",
      value: "landscape",
      label: "Landscape",
      abbreviation: "LANDSCAPE",
      order: 3
    },
    "obstructed": {
      name: "OBSTRUCTED",
      value: "obstructed",
      label: "Obstructed",
      abbreviation: "OBSTRUCTED",
      order: 4
    },
    "street": {
      name: "STREET_VIEW",
      value: "street",
      label: "Street",
      abbreviation: "STREET_VIEW",
      order: 5
    },
    "none": {
      name: "NONE",
      value: "none",
      label: "None",
      abbreviation: "NONE",
      order: 6
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "WATER": {
    name: "WATER",
    value: "water",
    label: "Water",
    abbreviation: "WATER",
    order: 1
  },
  "CITY": {
    name: "CITY",
    value: "city",
    label: "City",
    abbreviation: "CITY",
    order: 2
  },
  "LANDSCAPE": {
    name: "LANDSCAPE",
    value: "landscape",
    label: "Landscape",
    abbreviation: "LANDSCAPE",
    order: 3
  },
  "OBSTRUCTED": {
    name: "OBSTRUCTED",
    value: "obstructed",
    label: "Obstructed",
    abbreviation: "OBSTRUCTED",
    order: 4
  },
  "STREET_VIEW": {
    name: "STREET_VIEW",
    value: "street",
    label: "Street",
    abbreviation: "STREET_VIEW",
    order: 5
  },
  "NONE": {
    name: "NONE",
    value: "none",
    label: "None",
    abbreviation: "NONE",
    order: 6
  }
};
export var TiAllowanceTypeEnum = {
  values: {
    "per_sqft": {
      name: "PER_SQFT",
      value: "per_sqft",
      label: "cash/metrics",
      abbreviation: "PER_SQFT",
      order: 0
    },
    "dollar": {
      name: "DOLLAR",
      value: "dollar",
      label: "cash",
      abbreviation: "DOLLAR",
      order: 1
    }
  },
  "PER_SQFT": {
    name: "PER_SQFT",
    value: "per_sqft",
    label: "cash/metrics",
    abbreviation: "PER_SQFT",
    order: 0
  },
  "DOLLAR": {
    name: "DOLLAR",
    value: "dollar",
    label: "cash",
    abbreviation: "DOLLAR",
    order: 1
  }
};
export var WorkFlowStatusEnum = {
  values: {
    "in_dealroom": {
      name: "IN_DEALROOM",
      value: "in_dealroom",
      label: "In Dealroom",
      abbreviation: "IN_DEALROOM",
      order: 0
    },
    "archived": {
      name: "ARCHIVED",
      value: "archived",
      label: "Archived",
      abbreviation: "ARCHIVED",
      order: 1
    },
    "passed": {
      name: "PASSED",
      value: "passed",
      label: "Passed",
      abbreviation: "PASSED",
      order: 2
    },
    "represented": {
      name: "REPRESENTED",
      value: "represented",
      label: "Represented",
      abbreviation: "REPRESENTED",
      order: 3
    }
  },
  "IN_DEALROOM": {
    name: "IN_DEALROOM",
    value: "in_dealroom",
    label: "In Dealroom",
    abbreviation: "IN_DEALROOM",
    order: 0
  },
  "ARCHIVED": {
    name: "ARCHIVED",
    value: "archived",
    label: "Archived",
    abbreviation: "ARCHIVED",
    order: 1
  },
  "PASSED": {
    name: "PASSED",
    value: "passed",
    label: "Passed",
    abbreviation: "PASSED",
    order: 2
  },
  "REPRESENTED": {
    name: "REPRESENTED",
    value: "represented",
    label: "Represented",
    abbreviation: "REPRESENTED",
    order: 3
  }
};
export var OutreachTypeEnum = {
  values: {
    "email": {
      name: "EMAIL",
      value: "email",
      label: "Emailed",
      abbreviation: "EMAIL",
      order: 0
    },
    "text": {
      name: "TEXT",
      value: "text",
      label: "Texted",
      abbreviation: "TEXT",
      order: 1
    },
    "call": {
      name: "CALL",
      value: "call",
      label: "Called",
      abbreviation: "CALL",
      order: 2
    },
    "visit": {
      name: "VISIT",
      value: "visit",
      label: "Visited",
      abbreviation: "VISIT",
      order: 3
    }
  },
  "EMAIL": {
    name: "EMAIL",
    value: "email",
    label: "Emailed",
    abbreviation: "EMAIL",
    order: 0
  },
  "TEXT": {
    name: "TEXT",
    value: "text",
    label: "Texted",
    abbreviation: "TEXT",
    order: 1
  },
  "CALL": {
    name: "CALL",
    value: "call",
    label: "Called",
    abbreviation: "CALL",
    order: 2
  },
  "VISIT": {
    name: "VISIT",
    value: "visit",
    label: "Visited",
    abbreviation: "VISIT",
    order: 3
  }
};
export var UseEnum = {
  values: {
    "0": {
      name: "RETAIL",
      value: "0",
      label: "Retail",
      abbreviation: "RETAIL",
      order: 0
    },
    "1": {
      name: "INDUSTRIAL",
      value: "1",
      label: "Industrial",
      abbreviation: "INDUSTRIAL",
      order: 1
    },
    "2": {
      name: "OFFICE",
      value: "2",
      label: "Office",
      abbreviation: "OFFICE",
      order: 2
    },
    "3": {
      name: "LIVE_WORK",
      value: "3",
      label: "Live/Work",
      abbreviation: "LIVE_WORK",
      order: 3
    },
    "4": {
      name: "RESEARCH_AND_DEVELOPMENT",
      value: "4",
      label: "R&D",
      abbreviation: "RESEARCH_AND_DEVELOPMENT",
      order: 4
    },
    "5": {
      name: "PDR",
      value: "5",
      label: "PDR",
      abbreviation: "PDR",
      order: 5
    },
    "6": {
      name: "FLEX",
      value: "6",
      label: "Flex",
      abbreviation: "FLEX",
      order: 6
    },
    "7": {
      name: "LIFE_SCIENCES",
      value: "7",
      label: "Life Sciences",
      abbreviation: "LIFE_SCIENCES",
      order: 7
    },
    "8": {
      name: "MEDICAL",
      value: "8",
      label: "Medical",
      abbreviation: "MEDICAL",
      order: 8
    },
    "9": {
      name: "MULTIFAMILY",
      value: "9",
      label: "Multifamily",
      abbreviation: "MULTIFAMILY",
      order: 9
    }
  },
  "RETAIL": {
    name: "RETAIL",
    value: "0",
    label: "Retail",
    abbreviation: "RETAIL",
    order: 0
  },
  "INDUSTRIAL": {
    name: "INDUSTRIAL",
    value: "1",
    label: "Industrial",
    abbreviation: "INDUSTRIAL",
    order: 1
  },
  "OFFICE": {
    name: "OFFICE",
    value: "2",
    label: "Office",
    abbreviation: "OFFICE",
    order: 2
  },
  "LIVE_WORK": {
    name: "LIVE_WORK",
    value: "3",
    label: "Live/Work",
    abbreviation: "LIVE_WORK",
    order: 3
  },
  "RESEARCH_AND_DEVELOPMENT": {
    name: "RESEARCH_AND_DEVELOPMENT",
    value: "4",
    label: "R&D",
    abbreviation: "RESEARCH_AND_DEVELOPMENT",
    order: 4
  },
  "PDR": {
    name: "PDR",
    value: "5",
    label: "PDR",
    abbreviation: "PDR",
    order: 5
  },
  "FLEX": {
    name: "FLEX",
    value: "6",
    label: "Flex",
    abbreviation: "FLEX",
    order: 6
  },
  "LIFE_SCIENCES": {
    name: "LIFE_SCIENCES",
    value: "7",
    label: "Life Sciences",
    abbreviation: "LIFE_SCIENCES",
    order: 7
  },
  "MEDICAL": {
    name: "MEDICAL",
    value: "8",
    label: "Medical",
    abbreviation: "MEDICAL",
    order: 8
  },
  "MULTIFAMILY": {
    name: "MULTIFAMILY",
    value: "9",
    label: "Multifamily",
    abbreviation: "MULTIFAMILY",
    order: 9
  }
};
export var InternetProvidersEnum = {
  values: {
    "1": {
      name: "COMCAST",
      value: "1",
      label: "Comcast",
      abbreviation: "COMCAST",
      order: 0
    },
    "2": {
      name: "ATT",
      value: "2",
      label: "AT&T",
      abbreviation: "ATT",
      order: 1
    },
    "3": {
      name: "WEBPASS",
      value: "3",
      label: "Webpass",
      abbreviation: "WEBPASS",
      order: 2
    },
    "4": {
      name: "MONKEY_BRAINS",
      value: "4",
      label: "Monkey Brains",
      abbreviation: "MONKEY_BRAINS",
      order: 3
    },
    "5": {
      name: "WILINE_NETWORKS",
      value: "5",
      label: "WiLine Networks",
      abbreviation: "WILINE_NETWORKS",
      order: 4
    },
    "6": {
      name: "FAST_METRICS",
      value: "6",
      label: "Fast Metrics",
      abbreviation: "FAST_METRICS",
      order: 5
    },
    "level_3": {
      name: "LEVEL_3",
      value: "level_3",
      label: "Level 3",
      abbreviation: "LEVEL_3",
      order: 6
    },
    "tw_telecom": {
      name: "TW_TELECOM",
      value: "tw_telecom",
      label: "TW Telecom",
      abbreviation: "TW_TELECOM",
      order: 7
    },
    "abovenet": {
      name: "ABOVENET",
      value: "abovenet",
      label: "AboveNet",
      abbreviation: "ABOVENET",
      order: 8
    },
    "reliance": {
      name: "RELIANCE",
      value: "reliance",
      label: "Reliance",
      abbreviation: "RELIANCE",
      order: 9
    },
    "cogent": {
      name: "COGENT",
      value: "cogent",
      label: "Cogent",
      abbreviation: "COGENT",
      order: 10
    },
    "verizon": {
      name: "VERIZON",
      value: "verizon",
      label: "Verizon",
      abbreviation: "VERIZON",
      order: 11
    }
  },
  "COMCAST": {
    name: "COMCAST",
    value: "1",
    label: "Comcast",
    abbreviation: "COMCAST",
    order: 0
  },
  "ATT": {
    name: "ATT",
    value: "2",
    label: "AT&T",
    abbreviation: "ATT",
    order: 1
  },
  "WEBPASS": {
    name: "WEBPASS",
    value: "3",
    label: "Webpass",
    abbreviation: "WEBPASS",
    order: 2
  },
  "MONKEY_BRAINS": {
    name: "MONKEY_BRAINS",
    value: "4",
    label: "Monkey Brains",
    abbreviation: "MONKEY_BRAINS",
    order: 3
  },
  "WILINE_NETWORKS": {
    name: "WILINE_NETWORKS",
    value: "5",
    label: "WiLine Networks",
    abbreviation: "WILINE_NETWORKS",
    order: 4
  },
  "FAST_METRICS": {
    name: "FAST_METRICS",
    value: "6",
    label: "Fast Metrics",
    abbreviation: "FAST_METRICS",
    order: 5
  },
  "LEVEL_3": {
    name: "LEVEL_3",
    value: "level_3",
    label: "Level 3",
    abbreviation: "LEVEL_3",
    order: 6
  },
  "TW_TELECOM": {
    name: "TW_TELECOM",
    value: "tw_telecom",
    label: "TW Telecom",
    abbreviation: "TW_TELECOM",
    order: 7
  },
  "ABOVENET": {
    name: "ABOVENET",
    value: "abovenet",
    label: "AboveNet",
    abbreviation: "ABOVENET",
    order: 8
  },
  "RELIANCE": {
    name: "RELIANCE",
    value: "reliance",
    label: "Reliance",
    abbreviation: "RELIANCE",
    order: 9
  },
  "COGENT": {
    name: "COGENT",
    value: "cogent",
    label: "Cogent",
    abbreviation: "COGENT",
    order: 10
  },
  "VERIZON": {
    name: "VERIZON",
    value: "verizon",
    label: "Verizon",
    abbreviation: "VERIZON",
    order: 11
  }
};
export var BuildingLeaseTypeEnum = {
  values: {
    "": {
      name: "Blank",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "IG",
      value: "0",
      label: "IG",
      abbreviation: "IG",
      order: 1
    },
    "1": {
      name: "FS",
      value: "1",
      label: "FSG",
      abbreviation: "FS",
      order: 2
    },
    "2": {
      name: "MG",
      value: "2",
      label: "MG",
      abbreviation: "MG",
      order: 3
    },
    "3": {
      name: "NNN",
      value: "3",
      label: "NNN",
      abbreviation: "NNN",
      order: 4
    }
  },
  "Blank": {
    name: "Blank",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "IG": {
    name: "IG",
    value: "0",
    label: "IG",
    abbreviation: "IG",
    order: 1
  },
  "FS": {
    name: "FS",
    value: "1",
    label: "FSG",
    abbreviation: "FS",
    order: 2
  },
  "MG": {
    name: "MG",
    value: "2",
    label: "MG",
    abbreviation: "MG",
    order: 3
  },
  "NNN": {
    name: "NNN",
    value: "3",
    label: "NNN",
    abbreviation: "NNN",
    order: 4
  }
};
export var ZoningEnum = {
  values: {
    "0": {
      name: "P",
      value: "0",
      label: "Public District",
      abbreviation: "P",
      order: 0,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_211"
    },
    "1": {
      name: "RH_1",
      value: "1",
      label: "RH-1",
      abbreviation: "RH_1",
      order: 1,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.1"
    },
    "2": {
      name: "RH_1_S",
      value: "2",
      label: "RH-1-S",
      abbreviation: "RH_1_S",
      order: 2,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.1"
    },
    "3": {
      name: "RH_2",
      value: "3",
      label: "RH-2",
      abbreviation: "RH_2",
      order: 3,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.1"
    },
    "4": {
      name: "RH_3",
      value: "4",
      label: "RH-3",
      abbreviation: "RH_3",
      order: 4,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.1"
    },
    "5": {
      name: "RM_1",
      value: "5",
      label: "RM-1",
      abbreviation: "RM_1",
      order: 5,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.2"
    },
    "6": {
      name: "RM_2",
      value: "6",
      label: "RM-2",
      abbreviation: "RM_2",
      order: 6,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.2"
    },
    "7": {
      name: "RM_3",
      value: "7",
      label: "RM-3",
      abbreviation: "RM_3",
      order: 7,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.2"
    },
    "8": {
      name: "RM_4",
      value: "8",
      label: "RM-4",
      abbreviation: "RM_4",
      order: 8,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.2"
    },
    "9": {
      name: "RTO",
      value: "9",
      label: "RTO",
      abbreviation: "RTO",
      order: 9,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.4"
    },
    "10": {
      name: "RTO_M",
      value: "10",
      label: "RTO-M",
      abbreviation: "RTO_M",
      order: 10,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.4"
    },
    "11": {
      name: "RC_3",
      value: "11",
      label: "RC-3",
      abbreviation: "RC_3",
      order: 11,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.3"
    },
    "12": {
      name: "RC_4",
      value: "12",
      label: "RC-4",
      abbreviation: "RC_4",
      order: 12,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.3"
    },
    "13": {
      name: "NC_1",
      value: "13",
      label: "NC-1",
      abbreviation: "NC_1",
      order: 13,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_710"
    },
    "14": {
      name: "NC_2",
      value: "14",
      label: "NC-2",
      abbreviation: "NC_2",
      order: 14,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_711"
    },
    "15": {
      name: "NC_3",
      value: "15",
      label: "NC-3",
      abbreviation: "NC_3",
      order: 15,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_712"
    },
    "16": {
      name: "NCS",
      value: "16",
      label: "NC-S",
      abbreviation: "NCS",
      order: 16,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_713"
    },
    "17": {
      name: "BROADWAY_NC",
      value: "17",
      label: "Broadway NC",
      abbreviation: "BROADWAY_NC",
      order: 17,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_714"
    },
    "18": {
      name: "CASTRO_NC",
      value: "18",
      label: "Castro Street NC",
      abbreviation: "CASTRO_NC",
      order: 18,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_715"
    },
    "19": {
      name: "INNER_CLEMET_NC",
      value: "19",
      label: "Inner Clemet NC",
      abbreviation: "INNER_CLEMET_NC",
      order: 19,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_716"
    },
    "20": {
      name: "OUTTER_CLEMET_NC",
      value: "20",
      label: "OutterClemet NC",
      abbreviation: "OUTTER_CLEMET_NC",
      order: 20,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_717"
    },
    "21": {
      name: "EXCELSIOR_OUTTER_MISSION_NC",
      value: "21",
      label: "Excelsior Outer Mission Street NC",
      abbreviation: "EXCELSIOR_OUTTER_MISSION_NC",
      order: 21,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_745"
    },
    "22": {
      name: "UPPER_FILMORE_NC",
      value: "22",
      label: "Upper Fillmore Street NC",
      abbreviation: "UPPER_FILMORE_NC",
      order: 22,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_718"
    },
    "23": {
      name: "HAIGHT_NC",
      value: "23",
      label: "Haight Street NC",
      abbreviation: "HAIGHT_NC",
      order: 23,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_719"
    },
    "24": {
      name: "IRVING_NC",
      value: "24",
      label: "Irving Street NC",
      abbreviation: "IRVING_NC",
      order: 24,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_740"
    },
    "25": {
      name: "JAPANTTOWN_NC",
      value: "25",
      label: "Japantown NC",
      abbreviation: "JAPANTTOWN_NC",
      order: 25,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_748"
    },
    "26": {
      name: "JUDAH_NC",
      value: "26",
      label: "Judah Street NC",
      abbreviation: "JUDAH_NC",
      order: 26,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_742"
    },
    "27": {
      name: "UPPPER_MARKET_NC",
      value: "27",
      label: "Upper Market Nc",
      abbreviation: "UPPPER_MARKET_NC",
      order: 27,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_721"
    },
    "28": {
      name: "NORIEGA_NC",
      value: "28",
      label: "Noriega Street Nc",
      abbreviation: "NORIEGA_NC",
      order: 28,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_739"
    },
    "29": {
      name: "NORTH_BEACH_NC",
      value: "29",
      label: "North Beach NC",
      abbreviation: "NORTH_BEACH_NC",
      order: 29,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_722"
    },
    "30": {
      name: "PACIFIC_AVE_NC",
      value: "30",
      label: "Pacific Ave NC",
      abbreviation: "PACIFIC_AVE_NC",
      order: 30,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_732"
    },
    "31": {
      name: "POLK_NC",
      value: "31",
      label: "Polk Street NC",
      abbreviation: "POLK_NC",
      order: 31,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_723"
    },
    "32": {
      name: "SACRAMENTO_STREET_NC",
      value: "32",
      label: "Sacramento Street NC",
      abbreviation: "SACRAMENTO_STREET_NC",
      order: 32,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_724"
    },
    "33": {
      name: "INNER_SUNSET_NC",
      value: "33",
      label: "Inner Sunset NC",
      abbreviation: "INNER_SUNSET_NC",
      order: 33,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_730"
    },
    "34": {
      name: "TARAVAL_NC",
      value: "34",
      label: "Taraval Street NC",
      abbreviation: "TARAVAL_NC",
      order: 34,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_741"
    },
    "35": {
      name: "NOE_VALLEY_24TH_NC",
      value: "35",
      label: "24th Street-Noe Valley NC",
      abbreviation: "NOE_VALLEY_24TH_NC",
      order: 35,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_728"
    },
    "36": {
      name: "UNION_ST_NC",
      value: "36",
      label: "Union Street NC",
      abbreviation: "UNION_ST_NC",
      order: 36,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_725"
    },
    "37": {
      name: "WEST_PORTAL_NC",
      value: "37",
      label: "West Portal Avenue NC",
      abbreviation: "WEST_PORTAL_NC",
      order: 37,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_729"
    },
    "38": {
      name: "NCT_1",
      value: "38",
      label: "NCT-1",
      abbreviation: "NCT_1",
      order: 38,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_733A"
    },
    "39": {
      name: "NCT_2",
      value: "39",
      label: "NCT-2",
      abbreviation: "NCT_2",
      order: 39,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_734"
    },
    "40": {
      name: "NCT_3",
      value: "40",
      label: "NCT-3",
      abbreviation: "NCT_3",
      order: 40,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_731"
    },
    "41": {
      name: "DIVISADERO_NCT",
      value: "41",
      label: "Divisadero Street NCT",
      abbreviation: "DIVISADERO_NCT",
      order: 41,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_746"
    },
    "42": {
      name: "FILLMORE_NCT",
      value: "42",
      label: "Fillmore Street NCT",
      abbreviation: "FILLMORE_NCT",
      order: 42,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_747"
    },
    "43": {
      name: "FOLSOM_NCT",
      value: "43",
      label: "Folsom Street NCT",
      abbreviation: "FOLSOM_NCT",
      order: 43,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_743"
    },
    "44": {
      name: "GLEN_PARK_NCT",
      value: "44",
      label: "Glen Park NCT",
      abbreviation: "GLEN_PARK_NCT",
      order: 44,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_738"
    },
    "45": {
      name: "HAYES_GOUGH_NCT",
      value: "45",
      label: "Hayes-Gough NCT",
      abbreviation: "HAYES_GOUGH_NCT",
      order: 45,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_720"
    },
    "46": {
      name: "UPPER_MARKET_NCT",
      value: "46",
      label: "Upper Market Street NCT",
      abbreviation: "UPPER_MARKET_NCT",
      order: 46,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_733"
    },
    "47": {
      name: "MISSION_NCT",
      value: "47",
      label: "Mission Street NCT",
      abbreviation: "MISSION_NCT",
      order: 47,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_736"
    },
    "48": {
      name: "OCEAN_AVE_NCT",
      value: "48",
      label: "Ocean Avenue NCT",
      abbreviation: "OCEAN_AVE_NCT",
      order: 48,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_737"
    },
    "49": {
      name: "RCD",
      value: "49",
      label: "RCD",
      abbreviation: "RCD",
      order: 49,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_744"
    },
    "50": {
      name: "SOMA_NCT",
      value: "50",
      label: "SoMa NCT",
      abbreviation: "SOMA_NCT",
      order: 50,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_735"
    },
    "51": {
      name: "MISSION_24TH_NCT",
      value: "51",
      label: "24th Street-Mission NCT",
      abbreviation: "MISSION_24TH_NCT",
      order: 51,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_727"
    },
    "52": {
      name: "VALENCIA_NCT",
      value: "52",
      label: "Valencia Street NCT",
      abbreviation: "VALENCIA_NCT",
      order: 52,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_726"
    },
    "53": {
      name: "LAKESHORE_PLAZA_NCS",
      value: "53",
      label: "Lakeshore Plaza NC-S",
      abbreviation: "LAKESHORE_PLAZA_NCS",
      order: 53,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_780.1"
    },
    "54": {
      name: "BAYSHORE_HESTER_NCS",
      value: "54",
      label: "Bayshore-Hester NC-S",
      abbreviation: "BAYSHORE_HESTER_NCS",
      order: 54,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_780.2"
    },
    "55": {
      name: "MISSION_HARRISON_NCS",
      value: "55",
      label: "Mission-Harrison NC-S",
      abbreviation: "MISSION_HARRISON_NCS",
      order: 55,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_780.4"
    },
    "56": {
      name: "NORTH_BEACH_NCS",
      value: "56",
      label: "North Beach NC-S",
      abbreviation: "NORTH_BEACH_NCS",
      order: 56,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_780.3"
    },
    "57": {
      name: "MARKET_COMMUNITY_CENTER_NCS",
      value: "57",
      label: "MARKET_COMMUNITY_CENTER_NCS",
      abbreviation: "MARKET_COMMUNITY_CENTER_NCS",
      order: 57
    },
    "58": {
      name: "C_2",
      value: "58",
      label: "C-2",
      abbreviation: "C_2",
      order: 58,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.1"
    },
    "59": {
      name: "C_3_O",
      value: "59",
      label: "C-3-O",
      abbreviation: "C_3_O",
      order: 59,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
    },
    "60": {
      name: "C_3_O_SD",
      value: "60",
      label: "C-3-O(SD)",
      abbreviation: "C_3_O_SD",
      order: 60,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
    },
    "61": {
      name: "C_3_R",
      value: "61",
      label: "C-3-R",
      abbreviation: "C_3_R",
      order: 61,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
    },
    "62": {
      name: "C_3_G",
      value: "62",
      label: "C-3-G",
      abbreviation: "C_3_G",
      order: 62,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
    },
    "63": {
      name: "C_3_S",
      value: "63",
      label: "C-3-S",
      abbreviation: "C_3_S",
      order: 63,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
    },
    "64": {
      name: "M_1",
      value: "64",
      label: "M-1",
      abbreviation: "M_1",
      order: 64,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.4"
    },
    "65": {
      name: "M_2",
      value: "65",
      label: "M-2",
      abbreviation: "M_2",
      order: 65,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.4"
    },
    "66": {
      name: "PDR_1_B",
      value: "66",
      label: "PDR-1-B",
      abbreviation: "PDR_1_B",
      order: 66,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.3"
    },
    "67": {
      name: "PDR_1_D",
      value: "67",
      label: "PDR-1-D",
      abbreviation: "PDR_1_D",
      order: 67,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.3"
    },
    "68": {
      name: "PDR_1_G",
      value: "68",
      label: "PDR-1-G",
      abbreviation: "PDR_1_G",
      order: 68,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.3"
    },
    "69": {
      name: "PDR_2",
      value: "69",
      label: "PDR-2",
      abbreviation: "PDR_2",
      order: 69,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.3"
    },
    "70": {
      name: "CCB",
      value: "70",
      label: "Chinatown Community Business District",
      abbreviation: "CCB",
      order: 70,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_810"
    },
    "71": {
      name: "CR_NR",
      value: "71",
      label: "CR/NC",
      abbreviation: "CR_NR",
      order: 71,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_812"
    },
    "72": {
      name: "CVR",
      value: "72",
      label: "Chinatown Residential Neighborhood Commercial District",
      abbreviation: "CVR",
      order: 72,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_811"
    },
    "73": {
      name: "RSD",
      value: "73",
      label: "RSD",
      abbreviation: "RSD",
      order: 73,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_815"
    },
    "74": {
      name: "SLR",
      value: "74",
      label: "SLR",
      abbreviation: "SLR",
      order: 74,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_816"
    },
    "75": {
      name: "SLI",
      value: "75",
      label: "SLI",
      abbreviation: "SLI",
      order: 75,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_817"
    },
    "76": {
      name: "SSO",
      value: "76",
      label: "SSO",
      abbreviation: "SSO",
      order: 76,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_818"
    },
    "77": {
      name: "SPD",
      value: "77",
      label: "SPD",
      abbreviation: "SPD",
      order: 77,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_814"
    },
    "78": {
      name: "MUG",
      value: "78",
      label: "MUG",
      abbreviation: "MUG",
      order: 78,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_840"
    },
    "79": {
      name: "MUO",
      value: "79",
      label: "MUO",
      abbreviation: "MUO",
      order: 79,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_842"
    },
    "80": {
      name: "MUR",
      value: "80",
      label: "MUR",
      abbreviation: "MUR",
      order: 80,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_841"
    },
    "81": {
      name: "UMU",
      value: "81",
      label: "UMU",
      abbreviation: "UMU",
      order: 81,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_843"
    },
    "82": {
      name: "RED",
      value: "82",
      label: "RED",
      abbreviation: "RED",
      order: 82,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_813"
    },
    "83": {
      name: "RED_MX",
      value: "83",
      label: "RED-MX",
      abbreviation: "RED_MX",
      order: 83,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_847"
    },
    "84": {
      name: "WMUG",
      value: "84",
      label: "WMUG",
      abbreviation: "WMUG",
      order: 84,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_844"
    },
    "85": {
      name: "WMUO",
      value: "85",
      label: "WMUO",
      abbreviation: "WMUO",
      order: 85,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_845"
    },
    "86": {
      name: "SALI",
      value: "86",
      label: "SALI",
      abbreviation: "SALI",
      order: 86,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_846"
    },
    "87": {
      name: "RH_DTR",
      value: "87",
      label: "RH-DTR",
      abbreviation: "RH_DTR",
      order: 87,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_827"
    },
    "88": {
      name: "SB_DTR",
      value: "88",
      label: "SB_DTR",
      abbreviation: "SB_DTR",
      order: 88,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_829"
    },
    "89": {
      name: "TB_DTR",
      value: "89",
      label: "TB-DTR",
      abbreviation: "TB_DTR",
      order: 89,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_828"
    },
    "90": {
      name: "MB_R_1",
      value: "90",
      label: "MB-R-1",
      abbreviation: "MB_R_1",
      order: 90,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_906"
    },
    "91": {
      name: "MB_R_2",
      value: "91",
      label: "MB-R-2",
      abbreviation: "MB_R_2",
      order: 91,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_907"
    },
    "92": {
      name: "MB_R_3",
      value: "92",
      label: "MB-R-3",
      abbreviation: "MB_R_3",
      order: 92,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_908"
    },
    "93": {
      name: "MB_NC_2",
      value: "93",
      label: "MB-NC-2",
      abbreviation: "MB_NC_2",
      order: 93,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_909"
    },
    "94": {
      name: "MB_NC_3",
      value: "94",
      label: "MB-NC-3",
      abbreviation: "MB_NC_3",
      order: 94,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_910"
    },
    "95": {
      name: "MB_NC_S",
      value: "95",
      label: "MB-NC-S",
      abbreviation: "MB_NC_S",
      order: 95,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_911"
    },
    "96": {
      name: "MB_O",
      value: "96",
      label: "MB-O",
      abbreviation: "MB_O",
      order: 96,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_912"
    },
    "97": {
      name: "MB_CI",
      value: "97",
      label: "MB-CI",
      abbreviation: "MB_CI",
      order: 97,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_913"
    },
    "98": {
      name: "MB_H",
      value: "98",
      label: "MB-H",
      abbreviation: "MB_H",
      order: 98,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_914"
    },
    "99": {
      name: "MB_CF",
      value: "99",
      label: "MB-CF",
      abbreviation: "MB_CF",
      order: 99,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_915"
    },
    "100": {
      name: "MB_OS",
      value: "100",
      label: "MB-OS",
      abbreviation: "MB_OS",
      order: 100,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_916"
    },
    "101": {
      name: "PM_R",
      value: "101",
      label: "PM-R",
      abbreviation: "PM_R",
      order: 101,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
    },
    "102": {
      name: "PM_MU_1",
      value: "102",
      label: "PM-MU-1",
      abbreviation: "PM_MU_1",
      order: 102,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
    },
    "103": {
      name: "PM_MU_2",
      value: "103",
      label: "PM-MU-2",
      abbreviation: "PM_MU_2",
      order: 103,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
    },
    "104": {
      name: "PM_S",
      value: "104",
      label: "PM-S",
      abbreviation: "PM_S",
      order: 104,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
    },
    "105": {
      name: "PM_CF",
      value: "105",
      label: "PM-CF",
      abbreviation: "PM_CF",
      order: 105,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
    },
    "106": {
      name: "PM_OS",
      value: "106",
      label: "PM-OS",
      abbreviation: "PM_OS",
      order: 106,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
    },
    "107": {
      name: "TI_R",
      value: "107",
      label: "TI-R",
      abbreviation: "TI_R",
      order: 107,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
    },
    "108": {
      name: "TI_MU",
      value: "108",
      label: "TI-MU",
      abbreviation: "TI_MU",
      order: 108,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
    },
    "109": {
      name: "TI_OS",
      value: "109",
      label: "TI-Os",
      abbreviation: "TI_OS",
      order: 109,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
    },
    "110": {
      name: "TI_PCI",
      value: "110",
      label: "TI-PCI",
      abbreviation: "TI_PCI",
      order: 110,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
    },
    "111": {
      name: "YBI_R",
      value: "111",
      label: "YBI-R",
      abbreviation: "YBI_R",
      order: 111,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
    },
    "112": {
      name: "YBI_MU",
      value: "112",
      label: "YBI-MU",
      abbreviation: "YBI_MU",
      order: 112,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
    },
    "113": {
      name: "YBI_OS",
      value: "113",
      label: "YBI-OS",
      abbreviation: "YBI_OS",
      order: 113,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
    },
    "114": {
      name: "YBI_PCI",
      value: "114",
      label: "YBI-PCI",
      abbreviation: "YBI_PCI",
      order: 114,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
    },
    "115": {
      name: "MB_RA",
      value: "115",
      label: "MB-RA",
      abbreviation: "MB_RA",
      order: 115,
      link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts"
    }
  },
  "P": {
    name: "P",
    value: "0",
    label: "Public District",
    abbreviation: "P",
    order: 0,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_211"
  },
  "RH_1": {
    name: "RH_1",
    value: "1",
    label: "RH-1",
    abbreviation: "RH_1",
    order: 1,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.1"
  },
  "RH_1_S": {
    name: "RH_1_S",
    value: "2",
    label: "RH-1-S",
    abbreviation: "RH_1_S",
    order: 2,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.1"
  },
  "RH_2": {
    name: "RH_2",
    value: "3",
    label: "RH-2",
    abbreviation: "RH_2",
    order: 3,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.1"
  },
  "RH_3": {
    name: "RH_3",
    value: "4",
    label: "RH-3",
    abbreviation: "RH_3",
    order: 4,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.1"
  },
  "RM_1": {
    name: "RM_1",
    value: "5",
    label: "RM-1",
    abbreviation: "RM_1",
    order: 5,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.2"
  },
  "RM_2": {
    name: "RM_2",
    value: "6",
    label: "RM-2",
    abbreviation: "RM_2",
    order: 6,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.2"
  },
  "RM_3": {
    name: "RM_3",
    value: "7",
    label: "RM-3",
    abbreviation: "RM_3",
    order: 7,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.2"
  },
  "RM_4": {
    name: "RM_4",
    value: "8",
    label: "RM-4",
    abbreviation: "RM_4",
    order: 8,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.2"
  },
  "RTO": {
    name: "RTO",
    value: "9",
    label: "RTO",
    abbreviation: "RTO",
    order: 9,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.4"
  },
  "RTO_M": {
    name: "RTO_M",
    value: "10",
    label: "RTO-M",
    abbreviation: "RTO_M",
    order: 10,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.4"
  },
  "RC_3": {
    name: "RC_3",
    value: "11",
    label: "RC-3",
    abbreviation: "RC_3",
    order: 11,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.3"
  },
  "RC_4": {
    name: "RC_4",
    value: "12",
    label: "RC-4",
    abbreviation: "RC_4",
    order: 12,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_209.3"
  },
  "NC_1": {
    name: "NC_1",
    value: "13",
    label: "NC-1",
    abbreviation: "NC_1",
    order: 13,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_710"
  },
  "NC_2": {
    name: "NC_2",
    value: "14",
    label: "NC-2",
    abbreviation: "NC_2",
    order: 14,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_711"
  },
  "NC_3": {
    name: "NC_3",
    value: "15",
    label: "NC-3",
    abbreviation: "NC_3",
    order: 15,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_712"
  },
  "NCS": {
    name: "NCS",
    value: "16",
    label: "NC-S",
    abbreviation: "NCS",
    order: 16,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_713"
  },
  "BROADWAY_NC": {
    name: "BROADWAY_NC",
    value: "17",
    label: "Broadway NC",
    abbreviation: "BROADWAY_NC",
    order: 17,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_714"
  },
  "CASTRO_NC": {
    name: "CASTRO_NC",
    value: "18",
    label: "Castro Street NC",
    abbreviation: "CASTRO_NC",
    order: 18,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_715"
  },
  "INNER_CLEMET_NC": {
    name: "INNER_CLEMET_NC",
    value: "19",
    label: "Inner Clemet NC",
    abbreviation: "INNER_CLEMET_NC",
    order: 19,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_716"
  },
  "OUTTER_CLEMET_NC": {
    name: "OUTTER_CLEMET_NC",
    value: "20",
    label: "OutterClemet NC",
    abbreviation: "OUTTER_CLEMET_NC",
    order: 20,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_717"
  },
  "EXCELSIOR_OUTTER_MISSION_NC": {
    name: "EXCELSIOR_OUTTER_MISSION_NC",
    value: "21",
    label: "Excelsior Outer Mission Street NC",
    abbreviation: "EXCELSIOR_OUTTER_MISSION_NC",
    order: 21,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_745"
  },
  "UPPER_FILMORE_NC": {
    name: "UPPER_FILMORE_NC",
    value: "22",
    label: "Upper Fillmore Street NC",
    abbreviation: "UPPER_FILMORE_NC",
    order: 22,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_718"
  },
  "HAIGHT_NC": {
    name: "HAIGHT_NC",
    value: "23",
    label: "Haight Street NC",
    abbreviation: "HAIGHT_NC",
    order: 23,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_719"
  },
  "IRVING_NC": {
    name: "IRVING_NC",
    value: "24",
    label: "Irving Street NC",
    abbreviation: "IRVING_NC",
    order: 24,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_740"
  },
  "JAPANTTOWN_NC": {
    name: "JAPANTTOWN_NC",
    value: "25",
    label: "Japantown NC",
    abbreviation: "JAPANTTOWN_NC",
    order: 25,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_748"
  },
  "JUDAH_NC": {
    name: "JUDAH_NC",
    value: "26",
    label: "Judah Street NC",
    abbreviation: "JUDAH_NC",
    order: 26,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_742"
  },
  "UPPPER_MARKET_NC": {
    name: "UPPPER_MARKET_NC",
    value: "27",
    label: "Upper Market Nc",
    abbreviation: "UPPPER_MARKET_NC",
    order: 27,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_721"
  },
  "NORIEGA_NC": {
    name: "NORIEGA_NC",
    value: "28",
    label: "Noriega Street Nc",
    abbreviation: "NORIEGA_NC",
    order: 28,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_739"
  },
  "NORTH_BEACH_NC": {
    name: "NORTH_BEACH_NC",
    value: "29",
    label: "North Beach NC",
    abbreviation: "NORTH_BEACH_NC",
    order: 29,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_722"
  },
  "PACIFIC_AVE_NC": {
    name: "PACIFIC_AVE_NC",
    value: "30",
    label: "Pacific Ave NC",
    abbreviation: "PACIFIC_AVE_NC",
    order: 30,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_732"
  },
  "POLK_NC": {
    name: "POLK_NC",
    value: "31",
    label: "Polk Street NC",
    abbreviation: "POLK_NC",
    order: 31,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_723"
  },
  "SACRAMENTO_STREET_NC": {
    name: "SACRAMENTO_STREET_NC",
    value: "32",
    label: "Sacramento Street NC",
    abbreviation: "SACRAMENTO_STREET_NC",
    order: 32,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_724"
  },
  "INNER_SUNSET_NC": {
    name: "INNER_SUNSET_NC",
    value: "33",
    label: "Inner Sunset NC",
    abbreviation: "INNER_SUNSET_NC",
    order: 33,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_730"
  },
  "TARAVAL_NC": {
    name: "TARAVAL_NC",
    value: "34",
    label: "Taraval Street NC",
    abbreviation: "TARAVAL_NC",
    order: 34,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_741"
  },
  "NOE_VALLEY_24TH_NC": {
    name: "NOE_VALLEY_24TH_NC",
    value: "35",
    label: "24th Street-Noe Valley NC",
    abbreviation: "NOE_VALLEY_24TH_NC",
    order: 35,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_728"
  },
  "UNION_ST_NC": {
    name: "UNION_ST_NC",
    value: "36",
    label: "Union Street NC",
    abbreviation: "UNION_ST_NC",
    order: 36,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_725"
  },
  "WEST_PORTAL_NC": {
    name: "WEST_PORTAL_NC",
    value: "37",
    label: "West Portal Avenue NC",
    abbreviation: "WEST_PORTAL_NC",
    order: 37,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_729"
  },
  "NCT_1": {
    name: "NCT_1",
    value: "38",
    label: "NCT-1",
    abbreviation: "NCT_1",
    order: 38,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_733A"
  },
  "NCT_2": {
    name: "NCT_2",
    value: "39",
    label: "NCT-2",
    abbreviation: "NCT_2",
    order: 39,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_734"
  },
  "NCT_3": {
    name: "NCT_3",
    value: "40",
    label: "NCT-3",
    abbreviation: "NCT_3",
    order: 40,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_731"
  },
  "DIVISADERO_NCT": {
    name: "DIVISADERO_NCT",
    value: "41",
    label: "Divisadero Street NCT",
    abbreviation: "DIVISADERO_NCT",
    order: 41,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_746"
  },
  "FILLMORE_NCT": {
    name: "FILLMORE_NCT",
    value: "42",
    label: "Fillmore Street NCT",
    abbreviation: "FILLMORE_NCT",
    order: 42,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_747"
  },
  "FOLSOM_NCT": {
    name: "FOLSOM_NCT",
    value: "43",
    label: "Folsom Street NCT",
    abbreviation: "FOLSOM_NCT",
    order: 43,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_743"
  },
  "GLEN_PARK_NCT": {
    name: "GLEN_PARK_NCT",
    value: "44",
    label: "Glen Park NCT",
    abbreviation: "GLEN_PARK_NCT",
    order: 44,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_738"
  },
  "HAYES_GOUGH_NCT": {
    name: "HAYES_GOUGH_NCT",
    value: "45",
    label: "Hayes-Gough NCT",
    abbreviation: "HAYES_GOUGH_NCT",
    order: 45,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_720"
  },
  "UPPER_MARKET_NCT": {
    name: "UPPER_MARKET_NCT",
    value: "46",
    label: "Upper Market Street NCT",
    abbreviation: "UPPER_MARKET_NCT",
    order: 46,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_733"
  },
  "MISSION_NCT": {
    name: "MISSION_NCT",
    value: "47",
    label: "Mission Street NCT",
    abbreviation: "MISSION_NCT",
    order: 47,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_736"
  },
  "OCEAN_AVE_NCT": {
    name: "OCEAN_AVE_NCT",
    value: "48",
    label: "Ocean Avenue NCT",
    abbreviation: "OCEAN_AVE_NCT",
    order: 48,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_737"
  },
  "RCD": {
    name: "RCD",
    value: "49",
    label: "RCD",
    abbreviation: "RCD",
    order: 49,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_744"
  },
  "SOMA_NCT": {
    name: "SOMA_NCT",
    value: "50",
    label: "SoMa NCT",
    abbreviation: "SOMA_NCT",
    order: 50,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_735"
  },
  "MISSION_24TH_NCT": {
    name: "MISSION_24TH_NCT",
    value: "51",
    label: "24th Street-Mission NCT",
    abbreviation: "MISSION_24TH_NCT",
    order: 51,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_727"
  },
  "VALENCIA_NCT": {
    name: "VALENCIA_NCT",
    value: "52",
    label: "Valencia Street NCT",
    abbreviation: "VALENCIA_NCT",
    order: 52,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_726"
  },
  "LAKESHORE_PLAZA_NCS": {
    name: "LAKESHORE_PLAZA_NCS",
    value: "53",
    label: "Lakeshore Plaza NC-S",
    abbreviation: "LAKESHORE_PLAZA_NCS",
    order: 53,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_780.1"
  },
  "BAYSHORE_HESTER_NCS": {
    name: "BAYSHORE_HESTER_NCS",
    value: "54",
    label: "Bayshore-Hester NC-S",
    abbreviation: "BAYSHORE_HESTER_NCS",
    order: 54,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_780.2"
  },
  "MISSION_HARRISON_NCS": {
    name: "MISSION_HARRISON_NCS",
    value: "55",
    label: "Mission-Harrison NC-S",
    abbreviation: "MISSION_HARRISON_NCS",
    order: 55,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_780.4"
  },
  "NORTH_BEACH_NCS": {
    name: "NORTH_BEACH_NCS",
    value: "56",
    label: "North Beach NC-S",
    abbreviation: "NORTH_BEACH_NCS",
    order: 56,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article7neighborhoodcommercialdistricts#JD_780.3"
  },
  "MARKET_COMMUNITY_CENTER_NCS": {
    name: "MARKET_COMMUNITY_CENTER_NCS",
    value: "57",
    label: "MARKET_COMMUNITY_CENTER_NCS",
    abbreviation: "MARKET_COMMUNITY_CENTER_NCS",
    order: 57
  },
  "C_2": {
    name: "C_2",
    value: "58",
    label: "C-2",
    abbreviation: "C_2",
    order: 58,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.1"
  },
  "C_3_O": {
    name: "C_3_O",
    value: "59",
    label: "C-3-O",
    abbreviation: "C_3_O",
    order: 59,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
  },
  "C_3_O_SD": {
    name: "C_3_O_SD",
    value: "60",
    label: "C-3-O(SD)",
    abbreviation: "C_3_O_SD",
    order: 60,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
  },
  "C_3_R": {
    name: "C_3_R",
    value: "61",
    label: "C-3-R",
    abbreviation: "C_3_R",
    order: 61,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
  },
  "C_3_G": {
    name: "C_3_G",
    value: "62",
    label: "C-3-G",
    abbreviation: "C_3_G",
    order: 62,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
  },
  "C_3_S": {
    name: "C_3_S",
    value: "63",
    label: "C-3-S",
    abbreviation: "C_3_S",
    order: 63,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.2"
  },
  "M_1": {
    name: "M_1",
    value: "64",
    label: "M-1",
    abbreviation: "M_1",
    order: 64,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.4"
  },
  "M_2": {
    name: "M_2",
    value: "65",
    label: "M-2",
    abbreviation: "M_2",
    order: 65,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.4"
  },
  "PDR_1_B": {
    name: "PDR_1_B",
    value: "66",
    label: "PDR-1-B",
    abbreviation: "PDR_1_B",
    order: 66,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.3"
  },
  "PDR_1_D": {
    name: "PDR_1_D",
    value: "67",
    label: "PDR-1-D",
    abbreviation: "PDR_1_D",
    order: 67,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.3"
  },
  "PDR_1_G": {
    name: "PDR_1_G",
    value: "68",
    label: "PDR-1-G",
    abbreviation: "PDR_1_G",
    order: 68,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.3"
  },
  "PDR_2": {
    name: "PDR_2",
    value: "69",
    label: "PDR-2",
    abbreviation: "PDR_2",
    order: 69,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_210.3"
  },
  "CCB": {
    name: "CCB",
    value: "70",
    label: "Chinatown Community Business District",
    abbreviation: "CCB",
    order: 70,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_810"
  },
  "CR_NR": {
    name: "CR_NR",
    value: "71",
    label: "CR/NC",
    abbreviation: "CR_NR",
    order: 71,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_812"
  },
  "CVR": {
    name: "CVR",
    value: "72",
    label: "Chinatown Residential Neighborhood Commercial District",
    abbreviation: "CVR",
    order: 72,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_811"
  },
  "RSD": {
    name: "RSD",
    value: "73",
    label: "RSD",
    abbreviation: "RSD",
    order: 73,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_815"
  },
  "SLR": {
    name: "SLR",
    value: "74",
    label: "SLR",
    abbreviation: "SLR",
    order: 74,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_816"
  },
  "SLI": {
    name: "SLI",
    value: "75",
    label: "SLI",
    abbreviation: "SLI",
    order: 75,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_817"
  },
  "SSO": {
    name: "SSO",
    value: "76",
    label: "SSO",
    abbreviation: "SSO",
    order: 76,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_818"
  },
  "SPD": {
    name: "SPD",
    value: "77",
    label: "SPD",
    abbreviation: "SPD",
    order: 77,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_814"
  },
  "MUG": {
    name: "MUG",
    value: "78",
    label: "MUG",
    abbreviation: "MUG",
    order: 78,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_840"
  },
  "MUO": {
    name: "MUO",
    value: "79",
    label: "MUO",
    abbreviation: "MUO",
    order: 79,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_842"
  },
  "MUR": {
    name: "MUR",
    value: "80",
    label: "MUR",
    abbreviation: "MUR",
    order: 80,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_841"
  },
  "UMU": {
    name: "UMU",
    value: "81",
    label: "UMU",
    abbreviation: "UMU",
    order: 81,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_843"
  },
  "RED": {
    name: "RED",
    value: "82",
    label: "RED",
    abbreviation: "RED",
    order: 82,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_813"
  },
  "RED_MX": {
    name: "RED_MX",
    value: "83",
    label: "RED-MX",
    abbreviation: "RED_MX",
    order: 83,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_847"
  },
  "WMUG": {
    name: "WMUG",
    value: "84",
    label: "WMUG",
    abbreviation: "WMUG",
    order: 84,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_844"
  },
  "WMUO": {
    name: "WMUO",
    value: "85",
    label: "WMUO",
    abbreviation: "WMUO",
    order: 85,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_845"
  },
  "SALI": {
    name: "SALI",
    value: "86",
    label: "SALI",
    abbreviation: "SALI",
    order: 86,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_846"
  },
  "RH_DTR": {
    name: "RH_DTR",
    value: "87",
    label: "RH-DTR",
    abbreviation: "RH_DTR",
    order: 87,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_827"
  },
  "SB_DTR": {
    name: "SB_DTR",
    value: "88",
    label: "SB_DTR",
    abbreviation: "SB_DTR",
    order: 88,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_829"
  },
  "TB_DTR": {
    name: "TB_DTR",
    value: "89",
    label: "TB-DTR",
    abbreviation: "TB_DTR",
    order: 89,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article8mixedusedistricts#JD_828"
  },
  "MB_R_1": {
    name: "MB_R_1",
    value: "90",
    label: "MB-R-1",
    abbreviation: "MB_R_1",
    order: 90,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_906"
  },
  "MB_R_2": {
    name: "MB_R_2",
    value: "91",
    label: "MB-R-2",
    abbreviation: "MB_R_2",
    order: 91,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_907"
  },
  "MB_R_3": {
    name: "MB_R_3",
    value: "92",
    label: "MB-R-3",
    abbreviation: "MB_R_3",
    order: 92,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_908"
  },
  "MB_NC_2": {
    name: "MB_NC_2",
    value: "93",
    label: "MB-NC-2",
    abbreviation: "MB_NC_2",
    order: 93,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_909"
  },
  "MB_NC_3": {
    name: "MB_NC_3",
    value: "94",
    label: "MB-NC-3",
    abbreviation: "MB_NC_3",
    order: 94,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_910"
  },
  "MB_NC_S": {
    name: "MB_NC_S",
    value: "95",
    label: "MB-NC-S",
    abbreviation: "MB_NC_S",
    order: 95,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_911"
  },
  "MB_O": {
    name: "MB_O",
    value: "96",
    label: "MB-O",
    abbreviation: "MB_O",
    order: 96,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_912"
  },
  "MB_CI": {
    name: "MB_CI",
    value: "97",
    label: "MB-CI",
    abbreviation: "MB_CI",
    order: 97,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_913"
  },
  "MB_H": {
    name: "MB_H",
    value: "98",
    label: "MB-H",
    abbreviation: "MB_H",
    order: 98,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_914"
  },
  "MB_CF": {
    name: "MB_CF",
    value: "99",
    label: "MB-CF",
    abbreviation: "MB_CF",
    order: 99,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_915"
  },
  "MB_OS": {
    name: "MB_OS",
    value: "100",
    label: "MB-OS",
    abbreviation: "MB_OS",
    order: 100,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts#JD_916"
  },
  "PM_R": {
    name: "PM_R",
    value: "101",
    label: "PM-R",
    abbreviation: "PM_R",
    order: 101,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
  },
  "PM_MU_1": {
    name: "PM_MU_1",
    value: "102",
    label: "PM-MU-1",
    abbreviation: "PM_MU_1",
    order: 102,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
  },
  "PM_MU_2": {
    name: "PM_MU_2",
    value: "103",
    label: "PM-MU-2",
    abbreviation: "PM_MU_2",
    order: 103,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
  },
  "PM_S": {
    name: "PM_S",
    value: "104",
    label: "PM-S",
    abbreviation: "PM_S",
    order: 104,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
  },
  "PM_CF": {
    name: "PM_CF",
    value: "105",
    label: "PM-CF",
    abbreviation: "PM_CF",
    order: 105,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
  },
  "PM_OS": {
    name: "PM_OS",
    value: "106",
    label: "PM-OS",
    abbreviation: "PM_OS",
    order: 106,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.64"
  },
  "TI_R": {
    name: "TI_R",
    value: "107",
    label: "TI-R",
    abbreviation: "TI_R",
    order: 107,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
  },
  "TI_MU": {
    name: "TI_MU",
    value: "108",
    label: "TI-MU",
    abbreviation: "TI_MU",
    order: 108,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
  },
  "TI_OS": {
    name: "TI_OS",
    value: "109",
    label: "TI-Os",
    abbreviation: "TI_OS",
    order: 109,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
  },
  "TI_PCI": {
    name: "TI_PCI",
    value: "110",
    label: "TI-PCI",
    abbreviation: "TI_PCI",
    order: 110,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
  },
  "YBI_R": {
    name: "YBI_R",
    value: "111",
    label: "YBI-R",
    abbreviation: "YBI_R",
    order: 111,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
  },
  "YBI_MU": {
    name: "YBI_MU",
    value: "112",
    label: "YBI-MU",
    abbreviation: "YBI_MU",
    order: 112,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
  },
  "YBI_OS": {
    name: "YBI_OS",
    value: "113",
    label: "YBI-OS",
    abbreviation: "YBI_OS",
    order: 113,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
  },
  "YBI_PCI": {
    name: "YBI_PCI",
    value: "114",
    label: "YBI-PCI",
    abbreviation: "YBI_PCI",
    order: 114,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article2usedistricts#JD_249.52"
  },
  "MB_RA": {
    name: "MB_RA",
    value: "115",
    label: "MB-RA",
    abbreviation: "MB_RA",
    order: 115,
    link: "http://library.amlegal.com/nxt/gateway.dll/California/planning/article9missionbaydistricts"
  }
};
export var BuildingConstructionStatusEnum = {
  values: {
    "existing": {
      name: "EXISTING",
      value: "existing",
      label: "Existing",
      abbreviation: "EXISTING",
      order: 0
    },
    "construction": {
      name: "UNDER_CONSTRUCTION",
      value: "construction",
      label: "Under Construction",
      abbreviation: "UNDER_CONSTRUCTION",
      order: 1
    },
    "renovation": {
      name: "UNDER_RENOVATION",
      value: "renovation",
      label: "Under Renovation",
      abbreviation: "UNDER_RENOVATION",
      order: 2
    },
    "planned": {
      name: "PLANNED",
      value: "planned",
      label: "Planned",
      abbreviation: "PLANNED",
      order: 3
    },
    "proposed": {
      name: "PROPOSED",
      value: "proposed",
      label: "Proposed",
      abbreviation: "PROPOSED",
      order: 4
    }
  },
  "EXISTING": {
    name: "EXISTING",
    value: "existing",
    label: "Existing",
    abbreviation: "EXISTING",
    order: 0
  },
  "UNDER_CONSTRUCTION": {
    name: "UNDER_CONSTRUCTION",
    value: "construction",
    label: "Under Construction",
    abbreviation: "UNDER_CONSTRUCTION",
    order: 1
  },
  "UNDER_RENOVATION": {
    name: "UNDER_RENOVATION",
    value: "renovation",
    label: "Under Renovation",
    abbreviation: "UNDER_RENOVATION",
    order: 2
  },
  "PLANNED": {
    name: "PLANNED",
    value: "planned",
    label: "Planned",
    abbreviation: "PLANNED",
    order: 3
  },
  "PROPOSED": {
    name: "PROPOSED",
    value: "proposed",
    label: "Proposed",
    abbreviation: "PROPOSED",
    order: 4
  }
};
export var SecurityDepositTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "CASH",
      value: "0",
      label: "Cash",
      abbreviation: "CASH",
      order: 1
    },
    "1": {
      name: "LOC",
      value: "1",
      label: "LOC",
      abbreviation: "LOC",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "CASH": {
    name: "CASH",
    value: "0",
    label: "Cash",
    abbreviation: "CASH",
    order: 1
  },
  "LOC": {
    name: "LOC",
    value: "1",
    label: "LOC",
    abbreviation: "LOC",
    order: 2
  }
};
export var FurnitureEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "avail": {
      name: "AVAILABLE",
      value: "avail",
      label: "Available",
      abbreviation: "AVAILABLE",
      order: 1
    },
    "inclu": {
      name: "INCLUDED",
      value: "inclu",
      label: "Included",
      abbreviation: "INCLUDED",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "AVAILABLE": {
    name: "AVAILABLE",
    value: "avail",
    label: "Available",
    abbreviation: "AVAILABLE",
    order: 1
  },
  "INCLUDED": {
    name: "INCLUDED",
    value: "inclu",
    label: "Included",
    abbreviation: "INCLUDED",
    order: 2
  }
};
export var BuildingClassEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "A": {
      name: "A",
      value: "A",
      label: "A",
      abbreviation: "A",
      order: 1
    },
    "B": {
      name: "B",
      value: "B",
      label: "B",
      abbreviation: "B",
      order: 2
    },
    "C": {
      name: "C",
      value: "C",
      label: "C",
      abbreviation: "C",
      order: 3
    },
    "D": {
      name: "D",
      value: "D",
      label: "D",
      abbreviation: "D",
      order: 4
    },
    "F": {
      name: "F",
      value: "F",
      label: "F",
      abbreviation: "F",
      order: 5
    },
    "TROPHY": {
      name: "TROPHY",
      value: "TROPHY",
      label: "Trophy",
      abbreviation: "TROPHY",
      order: 6
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "A": {
    name: "A",
    value: "A",
    label: "A",
    abbreviation: "A",
    order: 1
  },
  "B": {
    name: "B",
    value: "B",
    label: "B",
    abbreviation: "B",
    order: 2
  },
  "C": {
    name: "C",
    value: "C",
    label: "C",
    abbreviation: "C",
    order: 3
  },
  "D": {
    name: "D",
    value: "D",
    label: "D",
    abbreviation: "D",
    order: 4
  },
  "F": {
    name: "F",
    value: "F",
    label: "F",
    abbreviation: "F",
    order: 5
  },
  "TROPHY": {
    name: "TROPHY",
    value: "TROPHY",
    label: "Trophy",
    abbreviation: "TROPHY",
    order: 6
  }
};
export var BuildingCoreEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "SIDE_CORE",
      value: "0",
      label: "Side Core",
      abbreviation: "SIDE_CORE",
      order: 1
    },
    "1": {
      name: "CENTER_CORE",
      value: "1",
      label: "Center Core",
      abbreviation: "CENTER_CORE",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "SIDE_CORE": {
    name: "SIDE_CORE",
    value: "0",
    label: "Side Core",
    abbreviation: "SIDE_CORE",
    order: 1
  },
  "CENTER_CORE": {
    name: "CENTER_CORE",
    value: "1",
    label: "Center Core",
    abbreviation: "CENTER_CORE",
    order: 2
  }
};
export var DealStateEnum = {
  values: {
    "pursuit": {
      name: "PURSUIT",
      value: "pursuit",
      label: "Pursuit",
      abbreviation: "PURSUIT",
      order: 0
    },
    "active": {
      name: "ACTIVE",
      value: "active",
      label: "Active",
      abbreviation: "ACTIVE",
      order: 1
    },
    "executed": {
      name: "EXECUTED",
      value: "executed",
      label: "Closed",
      abbreviation: "EXECUTED",
      order: 2
    },
    "lost": {
      name: "LOST",
      value: "lost",
      label: "Lost",
      abbreviation: "LOST",
      order: 3
    }
  },
  "PURSUIT": {
    name: "PURSUIT",
    value: "pursuit",
    label: "Pursuit",
    abbreviation: "PURSUIT",
    order: 0
  },
  "ACTIVE": {
    name: "ACTIVE",
    value: "active",
    label: "Active",
    abbreviation: "ACTIVE",
    order: 1
  },
  "EXECUTED": {
    name: "EXECUTED",
    value: "executed",
    label: "Closed",
    abbreviation: "EXECUTED",
    order: 2
  },
  "LOST": {
    name: "LOST",
    value: "lost",
    label: "Lost",
    abbreviation: "LOST",
    order: 3
  }
};
export var DealStageEnum = {
  values: {
    "planning": {
      name: "PLANNING",
      value: "planning",
      label: "Planning",
      abbreviation: "PLANNING",
      order: 0
    },
    "touring": {
      name: "TOURING",
      value: "touring",
      label: "Touring",
      abbreviation: "TOURING",
      order: 1
    },
    "proposals": {
      name: "PROPOSALS",
      value: "proposals",
      label: "Proposals",
      abbreviation: "PROPOSALS",
      order: 2
    },
    "leases": {
      name: "LEASES",
      value: "leases",
      label: "Leases",
      abbreviation: "LEASES",
      order: 3
    }
  },
  "PLANNING": {
    name: "PLANNING",
    value: "planning",
    label: "Planning",
    abbreviation: "PLANNING",
    order: 0
  },
  "TOURING": {
    name: "TOURING",
    value: "touring",
    label: "Touring",
    abbreviation: "TOURING",
    order: 1
  },
  "PROPOSALS": {
    name: "PROPOSALS",
    value: "proposals",
    label: "Proposals",
    abbreviation: "PROPOSALS",
    order: 2
  },
  "LEASES": {
    name: "LEASES",
    value: "leases",
    label: "Leases",
    abbreviation: "LEASES",
    order: 3
  }
};
export var DealTypeEnum = {
  values: {
    "tenant": {
      name: "TENANT",
      value: "tenant",
      label: "Tenant",
      abbreviation: "TENANT",
      order: 0
    },
    "sublandlord": {
      name: "SUBLANDLORD",
      value: "sublandlord",
      label: "Sublandlord",
      abbreviation: "SUBLANDLORD",
      order: 1
    },
    "landlord": {
      name: "LANDLORD",
      value: "landlord",
      label: "Landlord",
      abbreviation: "LANDLORD",
      order: 2
    }
  },
  "TENANT": {
    name: "TENANT",
    value: "tenant",
    label: "Tenant",
    abbreviation: "TENANT",
    order: 0
  },
  "SUBLANDLORD": {
    name: "SUBLANDLORD",
    value: "sublandlord",
    label: "Sublandlord",
    abbreviation: "SUBLANDLORD",
    order: 1
  },
  "LANDLORD": {
    name: "LANDLORD",
    value: "landlord",
    label: "Landlord",
    abbreviation: "LANDLORD",
    order: 2
  }
};
export var DealFeaturesEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "MUST_HAVE",
      value: "0",
      label: "MUST_HAVE",
      abbreviation: "MUST_HAVE",
      order: 1
    },
    "1": {
      name: "NICE_TO_HAVE",
      value: "1",
      label: "NICE_TO_HAVE",
      abbreviation: "NICE_TO_HAVE",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "MUST_HAVE": {
    name: "MUST_HAVE",
    value: "0",
    label: "MUST_HAVE",
    abbreviation: "MUST_HAVE",
    order: 1
  },
  "NICE_TO_HAVE": {
    name: "NICE_TO_HAVE",
    value: "1",
    label: "NICE_TO_HAVE",
    abbreviation: "NICE_TO_HAVE",
    order: 2
  }
};
export var MoveReasonEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "0": {
      name: "DENSITY",
      value: "0",
      label: "Density",
      abbreviation: "DENSITY",
      order: 1
    },
    "1": {
      name: "NEW_FUNDING",
      value: "1",
      label: "New Funding",
      abbreviation: "NEW_FUNDING",
      order: 2
    },
    "2": {
      name: "EARLY_TERMINATION",
      value: "2",
      label: "Early Termination",
      abbreviation: "EARLY_TERMINATION",
      order: 3
    },
    "4": {
      name: "LED",
      value: "4",
      label: "LED",
      abbreviation: "LED",
      order: 4
    },
    "5": {
      name: "NEW_OFFICE",
      value: "5",
      label: "New Office",
      abbreviation: "NEW_OFFICE",
      order: 5
    },
    "6": {
      name: "GROWTH",
      value: "6",
      label: "Growth",
      abbreviation: "GROWTH",
      order: 6
    },
    "7": {
      name: "RENEWAL",
      value: "7",
      label: "Renewal",
      abbreviation: "RENEWAL",
      order: 7
    },
    "3": {
      name: "OTHER",
      value: "3",
      label: "Other",
      abbreviation: "OTHER",
      order: 8
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "DENSITY": {
    name: "DENSITY",
    value: "0",
    label: "Density",
    abbreviation: "DENSITY",
    order: 1
  },
  "NEW_FUNDING": {
    name: "NEW_FUNDING",
    value: "1",
    label: "New Funding",
    abbreviation: "NEW_FUNDING",
    order: 2
  },
  "EARLY_TERMINATION": {
    name: "EARLY_TERMINATION",
    value: "2",
    label: "Early Termination",
    abbreviation: "EARLY_TERMINATION",
    order: 3
  },
  "LED": {
    name: "LED",
    value: "4",
    label: "LED",
    abbreviation: "LED",
    order: 4
  },
  "NEW_OFFICE": {
    name: "NEW_OFFICE",
    value: "5",
    label: "New Office",
    abbreviation: "NEW_OFFICE",
    order: 5
  },
  "GROWTH": {
    name: "GROWTH",
    value: "6",
    label: "Growth",
    abbreviation: "GROWTH",
    order: 6
  },
  "RENEWAL": {
    name: "RENEWAL",
    value: "7",
    label: "Renewal",
    abbreviation: "RENEWAL",
    order: 7
  },
  "OTHER": {
    name: "OTHER",
    value: "3",
    label: "Other",
    abbreviation: "OTHER",
    order: 8
  }
};
export var LossReasonEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "competitor": {
      name: "WORKING_WITH_COMPETITOR",
      value: "competitor",
      label: "Working With Competitor",
      abbreviation: "WORKING_WITH_COMPETITOR",
      order: 1
    },
    "found_own_space": {
      name: "FOUND_OWN_SPACE",
      value: "found_own_space",
      label: "Found a space on their own",
      abbreviation: "FOUND_OWN_SPACE",
      order: 2
    },
    "search_cancelled": {
      name: "SEARCH_CANCELLED",
      value: "search_cancelled",
      label: "Search Cancelled",
      abbreviation: "SEARCH_CANCELLED",
      order: 3
    },
    "company_died": {
      name: "COMPANY_DIED",
      value: "company_died",
      label: "Company Died",
      abbreviation: "COMPANY_DIED",
      order: 4
    },
    "dropped": {
      name: "DROPPED_BY_RAISE",
      value: "dropped",
      label: "Dropped by Raise",
      abbreviation: "DROPPED_BY_RAISE",
      order: 5
    },
    "other": {
      name: "OTHER",
      value: "other",
      label: "Other",
      abbreviation: "OTHER",
      order: 6
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "WORKING_WITH_COMPETITOR": {
    name: "WORKING_WITH_COMPETITOR",
    value: "competitor",
    label: "Working With Competitor",
    abbreviation: "WORKING_WITH_COMPETITOR",
    order: 1
  },
  "FOUND_OWN_SPACE": {
    name: "FOUND_OWN_SPACE",
    value: "found_own_space",
    label: "Found a space on their own",
    abbreviation: "FOUND_OWN_SPACE",
    order: 2
  },
  "SEARCH_CANCELLED": {
    name: "SEARCH_CANCELLED",
    value: "search_cancelled",
    label: "Search Cancelled",
    abbreviation: "SEARCH_CANCELLED",
    order: 3
  },
  "COMPANY_DIED": {
    name: "COMPANY_DIED",
    value: "company_died",
    label: "Company Died",
    abbreviation: "COMPANY_DIED",
    order: 4
  },
  "DROPPED_BY_RAISE": {
    name: "DROPPED_BY_RAISE",
    value: "dropped",
    label: "Dropped by Raise",
    abbreviation: "DROPPED_BY_RAISE",
    order: 5
  },
  "OTHER": {
    name: "OTHER",
    value: "other",
    label: "Other",
    abbreviation: "OTHER",
    order: 6
  }
};
export var PursuitStageEnum = {
  values: {
    "pitching": {
      name: "PITCHING",
      value: "pitching",
      label: "Pitching",
      abbreviation: "PITCHING",
      order: 0
    }
  },
  "PITCHING": {
    name: "PITCHING",
    value: "pitching",
    label: "Pitching",
    abbreviation: "PITCHING",
    order: 0
  }
};
export var YesNoEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "yes": {
      name: "YES",
      value: "yes",
      label: "Yes",
      abbreviation: "YES",
      order: 1
    },
    "no": {
      name: "NO",
      value: "no",
      label: "No",
      abbreviation: "NO",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "YES": {
    name: "YES",
    value: "yes",
    label: "Yes",
    abbreviation: "YES",
    order: 1
  },
  "NO": {
    name: "NO",
    value: "no",
    label: "No",
    abbreviation: "NO",
    order: 2
  }
};
export var OrganizationStatusEnum = {
  values: {
    "unknown": {
      name: "UNKNOWN",
      value: "unknown",
      label: "No history",
      abbreviation: "UNKNOWN",
      order: 0
    },
    "past": {
      name: "PAST",
      value: "past",
      label: "Past",
      abbreviation: "PAST",
      order: 1
    },
    "active": {
      name: "ACTIVE",
      value: "active",
      label: "Active",
      abbreviation: "ACTIVE",
      order: 2
    },
    "pursuit": {
      name: "PURSUIT",
      value: "pursuit",
      label: "In Pursuit",
      abbreviation: "PURSUIT",
      order: 3
    },
    "lost_pursuit": {
      name: "LOST_PURSUIT",
      value: "lost_pursuit",
      label: "Lost Pursuit",
      abbreviation: "LOST_PURSUIT",
      order: 4
    },
    "lost_client": {
      name: "LOST_CLIENT",
      value: "lost_client",
      label: "Lost Client",
      abbreviation: "LOST_CLIENT",
      order: 5
    }
  },
  "UNKNOWN": {
    name: "UNKNOWN",
    value: "unknown",
    label: "No history",
    abbreviation: "UNKNOWN",
    order: 0
  },
  "PAST": {
    name: "PAST",
    value: "past",
    label: "Past",
    abbreviation: "PAST",
    order: 1
  },
  "ACTIVE": {
    name: "ACTIVE",
    value: "active",
    label: "Active",
    abbreviation: "ACTIVE",
    order: 2
  },
  "PURSUIT": {
    name: "PURSUIT",
    value: "pursuit",
    label: "In Pursuit",
    abbreviation: "PURSUIT",
    order: 3
  },
  "LOST_PURSUIT": {
    name: "LOST_PURSUIT",
    value: "lost_pursuit",
    label: "Lost Pursuit",
    abbreviation: "LOST_PURSUIT",
    order: 4
  },
  "LOST_CLIENT": {
    name: "LOST_CLIENT",
    value: "lost_client",
    label: "Lost Client",
    abbreviation: "LOST_CLIENT",
    order: 5
  }
};
export var OrgTypeEnum = {
  values: {
    "tenant": {
      name: "TENANT",
      value: "tenant",
      label: "Tenant",
      abbreviation: "TENANT",
      order: 0
    },
    "landlord": {
      name: "LANDLORD",
      value: "landlord",
      label: "Landlord",
      abbreviation: "LANDLORD",
      order: 1
    }
  },
  "TENANT": {
    name: "TENANT",
    value: "tenant",
    label: "Tenant",
    abbreviation: "TENANT",
    order: 0
  },
  "LANDLORD": {
    name: "LANDLORD",
    value: "landlord",
    label: "Landlord",
    abbreviation: "LANDLORD",
    order: 1
  }
};
export var DealSourceEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "existing_relationship": {
      name: "EXISTING_RELATIONSHIP",
      value: "existing_relationship",
      label: "Existing Relationship",
      abbreviation: "EXISTING_RELATIONSHIP",
      order: 1,
      description: "Repeat Client of Raise, or an Individual with whom you have transacted who is now at a new co"
    },
    "existing_client": {
      name: "EXISTING_CLIENT",
      value: "existing_client",
      label: "Existing Client",
      abbreviation: "EXISTING_CLIENT",
      order: 2
    },
    "inbound_referral": {
      name: "INBOUND_REFERRAL",
      value: "inbound_referral",
      label: "Inbound Referral",
      abbreviation: "INBOUND_REFERRAL",
      order: 3,
      description: "Person outside of Raise referring directly to Lead Broker"
    },
    "inbound_word_of_mouth": {
      name: "INBOUND_WORD_OF_MOUTH",
      value: "inbound_word_of_mouth",
      label: "Inbound - Word Of Mouth",
      abbreviation: "INBOUND_WORD_OF_MOUTH",
      order: 4
    },
    "inbound_online_search": {
      name: "INBOUND_ONLINE_SEARCH",
      value: "inbound_online_search",
      label: "Inbound - Online Search",
      abbreviation: "INBOUND_ONLINE_SEARCH",
      order: 5
    },
    "inbound_other": {
      name: "INBOUND_OTHER",
      value: "inbound_other",
      label: "Inbound - Other",
      abbreviation: "INBOUND_OTHER",
      order: 6
    },
    "outbound_referral": {
      name: "OUTBOUND_REFERRAL",
      value: "outbound_referral",
      label: "Outbound - Referral",
      abbreviation: "OUTBOUND_REFERRAL",
      order: 7
    },
    "outbound_cold_outreach": {
      name: "OUTBOUND_COLD_OUTREACH",
      value: "outbound_cold_outreach",
      label: "Outbound - Cold Outreach",
      abbreviation: "OUTBOUND_COLD_OUTREACH",
      order: 8
    },
    "outbound_event": {
      name: "OUTBOUND_EVENT",
      value: "outbound_event",
      label: "Outbound - Events",
      abbreviation: "OUTBOUND_EVENT",
      order: 9
    },
    "outbound_other": {
      name: "OUTBOUND_OTHER",
      value: "outbound_other",
      label: "Outbound - Other",
      abbreviation: "OUTBOUND_OTHER",
      order: 10
    },
    "company_sourced": {
      name: "COMPANY_SOURCED",
      value: "company_sourced",
      label: "Company Sourced",
      abbreviation: "COMPANY_SOURCED",
      order: 11,
      description: "Marketing efforts, investor based, website, events, goodwill, advertising"
    },
    "outbound_pursuit": {
      name: "OUTBOUND_PURSUIT",
      value: "outbound_pursuit",
      label: "Outbound Pursuit",
      abbreviation: "OUTBOUND_PURSUIT",
      order: 12,
      description: "New prospect pursued and assignment won"
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "EXISTING_RELATIONSHIP": {
    name: "EXISTING_RELATIONSHIP",
    value: "existing_relationship",
    label: "Existing Relationship",
    abbreviation: "EXISTING_RELATIONSHIP",
    order: 1,
    description: "Repeat Client of Raise, or an Individual with whom you have transacted who is now at a new co"
  },
  "EXISTING_CLIENT": {
    name: "EXISTING_CLIENT",
    value: "existing_client",
    label: "Existing Client",
    abbreviation: "EXISTING_CLIENT",
    order: 2
  },
  "INBOUND_REFERRAL": {
    name: "INBOUND_REFERRAL",
    value: "inbound_referral",
    label: "Inbound Referral",
    abbreviation: "INBOUND_REFERRAL",
    order: 3,
    description: "Person outside of Raise referring directly to Lead Broker"
  },
  "INBOUND_WORD_OF_MOUTH": {
    name: "INBOUND_WORD_OF_MOUTH",
    value: "inbound_word_of_mouth",
    label: "Inbound - Word Of Mouth",
    abbreviation: "INBOUND_WORD_OF_MOUTH",
    order: 4
  },
  "INBOUND_ONLINE_SEARCH": {
    name: "INBOUND_ONLINE_SEARCH",
    value: "inbound_online_search",
    label: "Inbound - Online Search",
    abbreviation: "INBOUND_ONLINE_SEARCH",
    order: 5
  },
  "INBOUND_OTHER": {
    name: "INBOUND_OTHER",
    value: "inbound_other",
    label: "Inbound - Other",
    abbreviation: "INBOUND_OTHER",
    order: 6
  },
  "OUTBOUND_REFERRAL": {
    name: "OUTBOUND_REFERRAL",
    value: "outbound_referral",
    label: "Outbound - Referral",
    abbreviation: "OUTBOUND_REFERRAL",
    order: 7
  },
  "OUTBOUND_COLD_OUTREACH": {
    name: "OUTBOUND_COLD_OUTREACH",
    value: "outbound_cold_outreach",
    label: "Outbound - Cold Outreach",
    abbreviation: "OUTBOUND_COLD_OUTREACH",
    order: 8
  },
  "OUTBOUND_EVENT": {
    name: "OUTBOUND_EVENT",
    value: "outbound_event",
    label: "Outbound - Events",
    abbreviation: "OUTBOUND_EVENT",
    order: 9
  },
  "OUTBOUND_OTHER": {
    name: "OUTBOUND_OTHER",
    value: "outbound_other",
    label: "Outbound - Other",
    abbreviation: "OUTBOUND_OTHER",
    order: 10
  },
  "COMPANY_SOURCED": {
    name: "COMPANY_SOURCED",
    value: "company_sourced",
    label: "Company Sourced",
    abbreviation: "COMPANY_SOURCED",
    order: 11,
    description: "Marketing efforts, investor based, website, events, goodwill, advertising"
  },
  "OUTBOUND_PURSUIT": {
    name: "OUTBOUND_PURSUIT",
    value: "outbound_pursuit",
    label: "Outbound Pursuit",
    abbreviation: "OUTBOUND_PURSUIT",
    order: 12,
    description: "New prospect pursued and assignment won"
  }
};
export var DocumentCategoryEnum = {
  values: {
    "report": {
      name: "REPORT",
      value: "report",
      label: "REPORT",
      abbreviation: "REPORT",
      order: 0
    },
    "document": {
      name: "DOCUMENT",
      value: "document",
      label: "DOCUMENT",
      abbreviation: "DOCUMENT",
      order: 1
    }
  },
  "REPORT": {
    name: "REPORT",
    value: "report",
    label: "REPORT",
    abbreviation: "REPORT",
    order: 0
  },
  "DOCUMENT": {
    name: "DOCUMENT",
    value: "document",
    label: "DOCUMENT",
    abbreviation: "DOCUMENT",
    order: 1
  }
};
export var FileUploadTypeEnum = {
  values: {
    "flyer": {
      name: "FLYER",
      value: "flyer",
      label: "FLYER",
      abbreviation: "FLYER",
      order: 0
    },
    "lease_availability_report": {
      name: "LEASE_AVAILABILITY_REPORT",
      value: "lease_availability_report",
      label: "LEASE_AVAILABILITY_REPORT",
      abbreviation: "LEASE_AVAILABILITY_REPORT",
      order: 1
    },
    "listing_floorplans": {
      name: "LISTING_FLOORPLANS",
      value: "listing_floorplans",
      label: "LISTING_FLOORPLANS",
      abbreviation: "LISTING_FLOORPLANS",
      order: 2
    },
    "listing_flyer": {
      name: "LISTING_FLYER",
      value: "listing_flyer",
      label: "LISTING_FLYER",
      abbreviation: "LISTING_FLYER",
      order: 3
    },
    "listing_images": {
      name: "LISTING_IMAGES",
      value: "listing_images",
      label: "LISTING_IMAGES",
      abbreviation: "LISTING_IMAGES",
      order: 4
    },
    "building_images": {
      name: "BUILDING_IMAGES",
      value: "building_images",
      label: "BUILDING_IMAGES",
      abbreviation: "BUILDING_IMAGES",
      order: 5
    },
    "document": {
      name: "DOCUMENT",
      value: "document",
      label: "DOCUMENT",
      abbreviation: "DOCUMENT",
      order: 6
    }
  },
  "FLYER": {
    name: "FLYER",
    value: "flyer",
    label: "FLYER",
    abbreviation: "FLYER",
    order: 0
  },
  "LEASE_AVAILABILITY_REPORT": {
    name: "LEASE_AVAILABILITY_REPORT",
    value: "lease_availability_report",
    label: "LEASE_AVAILABILITY_REPORT",
    abbreviation: "LEASE_AVAILABILITY_REPORT",
    order: 1
  },
  "LISTING_FLOORPLANS": {
    name: "LISTING_FLOORPLANS",
    value: "listing_floorplans",
    label: "LISTING_FLOORPLANS",
    abbreviation: "LISTING_FLOORPLANS",
    order: 2
  },
  "LISTING_FLYER": {
    name: "LISTING_FLYER",
    value: "listing_flyer",
    label: "LISTING_FLYER",
    abbreviation: "LISTING_FLYER",
    order: 3
  },
  "LISTING_IMAGES": {
    name: "LISTING_IMAGES",
    value: "listing_images",
    label: "LISTING_IMAGES",
    abbreviation: "LISTING_IMAGES",
    order: 4
  },
  "BUILDING_IMAGES": {
    name: "BUILDING_IMAGES",
    value: "building_images",
    label: "BUILDING_IMAGES",
    abbreviation: "BUILDING_IMAGES",
    order: 5
  },
  "DOCUMENT": {
    name: "DOCUMENT",
    value: "document",
    label: "DOCUMENT",
    abbreviation: "DOCUMENT",
    order: 6
  }
};
export var HoldReasonEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "--",
      abbreviation: "",
      order: 0
    },
    "lease_extension": {
      name: "LEASE_EXTENSION",
      value: "lease_extension",
      label: "Lease Extension",
      abbreviation: "LEASE_EXTENSION",
      order: 1
    },
    "slow_growth": {
      name: "SLOW_GROWTH",
      value: "slow_growth",
      label: "Slow Growth",
      abbreviation: "SLOW_GROWTH",
      order: 2
    },
    "raising_round": {
      name: "RAISING_ROUND",
      value: "raising_round",
      label: "Raising Round",
      abbreviation: "RAISING_ROUND",
      order: 3
    },
    "other": {
      name: "OTHER",
      value: "other",
      label: "Other",
      abbreviation: "OTHER",
      order: 4
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "--",
    abbreviation: "",
    order: 0
  },
  "LEASE_EXTENSION": {
    name: "LEASE_EXTENSION",
    value: "lease_extension",
    label: "Lease Extension",
    abbreviation: "LEASE_EXTENSION",
    order: 1
  },
  "SLOW_GROWTH": {
    name: "SLOW_GROWTH",
    value: "slow_growth",
    label: "Slow Growth",
    abbreviation: "SLOW_GROWTH",
    order: 2
  },
  "RAISING_ROUND": {
    name: "RAISING_ROUND",
    value: "raising_round",
    label: "Raising Round",
    abbreviation: "RAISING_ROUND",
    order: 3
  },
  "OTHER": {
    name: "OTHER",
    value: "other",
    label: "Other",
    abbreviation: "OTHER",
    order: 4
  }
};
export var DealroomVoteStateEnum = {
  values: {
    "all": {
      name: "ALL",
      value: "all",
      label: "All",
      abbreviation: "ALL",
      order: 0
    },
    "awaiting": {
      name: "AWAITING",
      value: "awaiting",
      label: "New",
      abbreviation: "AWAITING",
      order: 1
    },
    "liked": {
      name: "LIKED",
      value: "liked",
      label: "Liked",
      abbreviation: "LIKED",
      order: 2
    },
    "disliked": {
      name: "DISLIKED",
      value: "disliked",
      label: "Disliked",
      abbreviation: "DISLIKED",
      order: 3
    },
    "toured": {
      name: "TOURED",
      value: "toured",
      label: "Toured",
      abbreviation: "TOURED",
      order: 4
    },
    "archived": {
      name: "ARCHIVED",
      value: "archived",
      label: "Archived",
      abbreviation: "ARCHIVED",
      order: 5
    },
    "available": {
      name: "AVAILABLE",
      value: "available",
      label: "Available",
      abbreviation: "AVAILABLE",
      order: 6
    },
    "unavailable": {
      name: "UNAVAILABLE",
      value: "unavailable",
      label: "Unavailable",
      abbreviation: "UNAVAILABLE",
      order: 7
    },
    "tour_request": {
      name: "TOUR_REQUEST",
      value: "tour_request",
      label: "Tour Request",
      abbreviation: "TOUR_REQUEST",
      order: 8
    }
  },
  "ALL": {
    name: "ALL",
    value: "all",
    label: "All",
    abbreviation: "ALL",
    order: 0
  },
  "AWAITING": {
    name: "AWAITING",
    value: "awaiting",
    label: "New",
    abbreviation: "AWAITING",
    order: 1
  },
  "LIKED": {
    name: "LIKED",
    value: "liked",
    label: "Liked",
    abbreviation: "LIKED",
    order: 2
  },
  "DISLIKED": {
    name: "DISLIKED",
    value: "disliked",
    label: "Disliked",
    abbreviation: "DISLIKED",
    order: 3
  },
  "TOURED": {
    name: "TOURED",
    value: "toured",
    label: "Toured",
    abbreviation: "TOURED",
    order: 4
  },
  "ARCHIVED": {
    name: "ARCHIVED",
    value: "archived",
    label: "Archived",
    abbreviation: "ARCHIVED",
    order: 5
  },
  "AVAILABLE": {
    name: "AVAILABLE",
    value: "available",
    label: "Available",
    abbreviation: "AVAILABLE",
    order: 6
  },
  "UNAVAILABLE": {
    name: "UNAVAILABLE",
    value: "unavailable",
    label: "Unavailable",
    abbreviation: "UNAVAILABLE",
    order: 7
  },
  "TOUR_REQUEST": {
    name: "TOUR_REQUEST",
    value: "tour_request",
    label: "Tour Request",
    abbreviation: "TOUR_REQUEST",
    order: 8
  }
};
export var TourStopActionEnum = {
  values: {
    "markConfirmed": {
      name: "MARK_CONFIRMED",
      value: "markConfirmed",
      label: "Mark confirmed",
      abbreviation: "MARK_CONFIRMED",
      order: 0
    },
    "markUnconfirmed": {
      name: "MARK_UNCONFIRMED",
      value: "markUnconfirmed",
      label: "Mark unconfirmed",
      abbreviation: "MARK_UNCONFIRMED",
      order: 1
    }
  },
  "MARK_CONFIRMED": {
    name: "MARK_CONFIRMED",
    value: "markConfirmed",
    label: "Mark confirmed",
    abbreviation: "MARK_CONFIRMED",
    order: 0
  },
  "MARK_UNCONFIRMED": {
    name: "MARK_UNCONFIRMED",
    value: "markUnconfirmed",
    label: "Mark unconfirmed",
    abbreviation: "MARK_UNCONFIRMED",
    order: 1
  }
};
export var SelectableNodeEnum = {
  values: {
    "masterlistings": {
      name: "MASTERLISTINGS",
      value: "masterlistings",
      label: "MASTERLISTINGS",
      abbreviation: "MASTERLISTINGS",
      order: 0
    },
    "comps": {
      name: "COMPS",
      value: "comps",
      label: "COMPS",
      abbreviation: "COMPS",
      order: 1
    },
    "users": {
      name: "USERS",
      value: "users",
      label: "USERS",
      abbreviation: "USERS",
      order: 2
    },
    "markets": {
      name: "MARKETS",
      value: "markets",
      label: "MARKETS",
      abbreviation: "MARKETS",
      order: 3
    },
    "neighborhoods": {
      name: "NEIGHBORHOODS",
      value: "neighborhoods",
      label: "NEIGHBORHOODS",
      abbreviation: "NEIGHBORHOODS",
      order: 4
    },
    "orgs": {
      name: "ORGANIZATIONS",
      value: "orgs",
      label: "ORGANIZATIONS",
      abbreviation: "ORGANIZATIONS",
      order: 5
    },
    "contacts": {
      name: "CONTACTS",
      value: "contacts",
      label: "CONTACTS",
      abbreviation: "CONTACTS",
      order: 6
    },
    "brokerages": {
      name: "BROKERAGES",
      value: "brokerages",
      label: "BROKERAGES",
      abbreviation: "BROKERAGES",
      order: 7
    },
    "listings_agents": {
      name: "LISTING_AGENTS",
      value: "listings_agents",
      label: "LISTING_AGENTS",
      abbreviation: "LISTING_AGENTS",
      order: 8
    },
    "buildings": {
      name: "BUILDINGS",
      value: "buildings",
      label: "BUILDINGS",
      abbreviation: "BUILDINGS",
      order: 9
    },
    "regions": {
      name: "REGION",
      value: "regions",
      label: "REGION",
      abbreviation: "REGION",
      order: 10
    },
    "dealrooms": {
      name: "DEALROOM",
      value: "dealrooms",
      label: "DEALROOM",
      abbreviation: "DEALROOM",
      order: 11
    },
    "dealroom_listings": {
      name: "DEALROOM_LISTINGS",
      value: "dealroom_listings",
      label: "DEALROOM_LISTINGS",
      abbreviation: "DEALROOM_LISTINGS",
      order: 12
    },
    "advocates": {
      name: "ADVOCATES",
      value: "advocates",
      label: "ADVOCATES",
      abbreviation: "ADVOCATES",
      order: 13
    },
    "properties": {
      name: "PROPERTIES",
      value: "properties",
      label: "PROPERTIES",
      abbreviation: "PROPERTIES",
      order: 14
    },
    "image_tags": {
      name: "IMAGE_TAGS",
      value: "image_tags",
      label: "IMAGE_TAGS",
      abbreviation: "IMAGE_TAGS",
      order: 15
    }
  },
  "MASTERLISTINGS": {
    name: "MASTERLISTINGS",
    value: "masterlistings",
    label: "MASTERLISTINGS",
    abbreviation: "MASTERLISTINGS",
    order: 0
  },
  "COMPS": {
    name: "COMPS",
    value: "comps",
    label: "COMPS",
    abbreviation: "COMPS",
    order: 1
  },
  "USERS": {
    name: "USERS",
    value: "users",
    label: "USERS",
    abbreviation: "USERS",
    order: 2
  },
  "MARKETS": {
    name: "MARKETS",
    value: "markets",
    label: "MARKETS",
    abbreviation: "MARKETS",
    order: 3
  },
  "NEIGHBORHOODS": {
    name: "NEIGHBORHOODS",
    value: "neighborhoods",
    label: "NEIGHBORHOODS",
    abbreviation: "NEIGHBORHOODS",
    order: 4
  },
  "ORGANIZATIONS": {
    name: "ORGANIZATIONS",
    value: "orgs",
    label: "ORGANIZATIONS",
    abbreviation: "ORGANIZATIONS",
    order: 5
  },
  "CONTACTS": {
    name: "CONTACTS",
    value: "contacts",
    label: "CONTACTS",
    abbreviation: "CONTACTS",
    order: 6
  },
  "BROKERAGES": {
    name: "BROKERAGES",
    value: "brokerages",
    label: "BROKERAGES",
    abbreviation: "BROKERAGES",
    order: 7
  },
  "LISTING_AGENTS": {
    name: "LISTING_AGENTS",
    value: "listings_agents",
    label: "LISTING_AGENTS",
    abbreviation: "LISTING_AGENTS",
    order: 8
  },
  "BUILDINGS": {
    name: "BUILDINGS",
    value: "buildings",
    label: "BUILDINGS",
    abbreviation: "BUILDINGS",
    order: 9
  },
  "REGION": {
    name: "REGION",
    value: "regions",
    label: "REGION",
    abbreviation: "REGION",
    order: 10
  },
  "DEALROOM": {
    name: "DEALROOM",
    value: "dealrooms",
    label: "DEALROOM",
    abbreviation: "DEALROOM",
    order: 11
  },
  "DEALROOM_LISTINGS": {
    name: "DEALROOM_LISTINGS",
    value: "dealroom_listings",
    label: "DEALROOM_LISTINGS",
    abbreviation: "DEALROOM_LISTINGS",
    order: 12
  },
  "ADVOCATES": {
    name: "ADVOCATES",
    value: "advocates",
    label: "ADVOCATES",
    abbreviation: "ADVOCATES",
    order: 13
  },
  "PROPERTIES": {
    name: "PROPERTIES",
    value: "properties",
    label: "PROPERTIES",
    abbreviation: "PROPERTIES",
    order: 14
  },
  "IMAGE_TAGS": {
    name: "IMAGE_TAGS",
    value: "image_tags",
    label: "IMAGE_TAGS",
    abbreviation: "IMAGE_TAGS",
    order: 15
  }
};
export var UserTypeEnum = {
  values: {
    "data": {
      name: "DATA",
      value: "data",
      label: "Data Entry",
      abbreviation: "DATA",
      order: 0
    },
    "research": {
      name: "RESEARCH",
      value: "research",
      label: "Data Research",
      abbreviation: "RESEARCH",
      order: 1
    },
    "broker": {
      name: "BROKER",
      value: "broker",
      label: "Broker",
      abbreviation: "BROKER",
      order: 2
    },
    "staff": {
      name: "STAFF",
      value: "staff",
      label: "Staff",
      abbreviation: "STAFF",
      order: 3
    },
    "all": {
      name: "ALL",
      value: "all",
      label: "all",
      abbreviation: "ALL",
      order: 4
    },
    "accountant": {
      name: "ACCOUNTANT",
      value: "accountant",
      label: "Accountant",
      abbreviation: "ACCOUNTANT",
      order: 5
    },
    "pm": {
      name: "PROJECT_MANAGER",
      value: "pm",
      label: "PM",
      abbreviation: "PROJECT_MANAGER",
      order: 6
    },
    "work_place": {
      name: "WORKPLACE",
      value: "work_place",
      label: "Work Place",
      abbreviation: "WORKPLACE",
      order: 7
    },
    "product_team": {
      name: "PRODUCT_TEAM",
      value: "product_team",
      label: "Product Team",
      abbreviation: "PRODUCT_TEAM",
      order: 8
    },
    "sales_coordinator": {
      name: "SALES_COORDINATOR",
      value: "sales_coordinator",
      label: "Sales Coordinator",
      abbreviation: "SALES_COORDINATOR",
      order: 9
    },
    "no_employee": {
      name: "NO_LONGER_EMPLOYEE",
      value: "no_employee",
      label: "No Longer Staff",
      abbreviation: "NO_LONGER_EMPLOYEE",
      order: 10
    }
  },
  "DATA": {
    name: "DATA",
    value: "data",
    label: "Data Entry",
    abbreviation: "DATA",
    order: 0
  },
  "RESEARCH": {
    name: "RESEARCH",
    value: "research",
    label: "Data Research",
    abbreviation: "RESEARCH",
    order: 1
  },
  "BROKER": {
    name: "BROKER",
    value: "broker",
    label: "Broker",
    abbreviation: "BROKER",
    order: 2
  },
  "STAFF": {
    name: "STAFF",
    value: "staff",
    label: "Staff",
    abbreviation: "STAFF",
    order: 3
  },
  "ALL": {
    name: "ALL",
    value: "all",
    label: "all",
    abbreviation: "ALL",
    order: 4
  },
  "ACCOUNTANT": {
    name: "ACCOUNTANT",
    value: "accountant",
    label: "Accountant",
    abbreviation: "ACCOUNTANT",
    order: 5
  },
  "PROJECT_MANAGER": {
    name: "PROJECT_MANAGER",
    value: "pm",
    label: "PM",
    abbreviation: "PROJECT_MANAGER",
    order: 6
  },
  "WORKPLACE": {
    name: "WORKPLACE",
    value: "work_place",
    label: "Work Place",
    abbreviation: "WORKPLACE",
    order: 7
  },
  "PRODUCT_TEAM": {
    name: "PRODUCT_TEAM",
    value: "product_team",
    label: "Product Team",
    abbreviation: "PRODUCT_TEAM",
    order: 8
  },
  "SALES_COORDINATOR": {
    name: "SALES_COORDINATOR",
    value: "sales_coordinator",
    label: "Sales Coordinator",
    abbreviation: "SALES_COORDINATOR",
    order: 9
  },
  "NO_LONGER_EMPLOYEE": {
    name: "NO_LONGER_EMPLOYEE",
    value: "no_employee",
    label: "No Longer Staff",
    abbreviation: "NO_LONGER_EMPLOYEE",
    order: 10
  }
};
export var ProposalStateEnum = {
  values: {
    "draft": {
      name: "DRAFT",
      value: "draft",
      label: "Draft",
      abbreviation: "DRAFT",
      order: 0
    },
    "first_sent": {
      name: "FIRST_SEND",
      value: "first_sent",
      label: "Proposal Sent",
      abbreviation: "FIRST_SEND",
      order: 1
    },
    "received": {
      name: "RECEIVED",
      value: "received",
      label: "Counter Received",
      abbreviation: "RECEIVED",
      order: 2
    },
    "sent": {
      name: "SENT",
      value: "sent",
      label: "Counter Sent",
      abbreviation: "SENT",
      order: 3
    },
    "signed_loi": {
      name: "SIGNED_LOI",
      value: "signed_loi",
      label: "Signed LOI",
      abbreviation: "SIGNED_LOI",
      order: 4
    },
    "unsolicited": {
      name: "UNSOLICITED",
      value: "unsolicited",
      label: "Proposal Received",
      abbreviation: "UNSOLICITED",
      order: 5
    }
  },
  "DRAFT": {
    name: "DRAFT",
    value: "draft",
    label: "Draft",
    abbreviation: "DRAFT",
    order: 0
  },
  "FIRST_SEND": {
    name: "FIRST_SEND",
    value: "first_sent",
    label: "Proposal Sent",
    abbreviation: "FIRST_SEND",
    order: 1
  },
  "RECEIVED": {
    name: "RECEIVED",
    value: "received",
    label: "Counter Received",
    abbreviation: "RECEIVED",
    order: 2
  },
  "SENT": {
    name: "SENT",
    value: "sent",
    label: "Counter Sent",
    abbreviation: "SENT",
    order: 3
  },
  "SIGNED_LOI": {
    name: "SIGNED_LOI",
    value: "signed_loi",
    label: "Signed LOI",
    abbreviation: "SIGNED_LOI",
    order: 4
  },
  "UNSOLICITED": {
    name: "UNSOLICITED",
    value: "unsolicited",
    label: "Proposal Received",
    abbreviation: "UNSOLICITED",
    order: 5
  }
};
export var ProposalSenderEnum = {
  values: {
    "tenant": {
      name: "TENANT",
      value: "tenant",
      label: "Tenant",
      abbreviation: "TENANT",
      order: 0
    },
    "landlord": {
      name: "LANDLORD",
      value: "landlord",
      label: "Landlord",
      abbreviation: "LANDLORD",
      order: 1
    },
    "client": {
      name: "CLIENT",
      value: "client",
      label: "Client",
      abbreviation: "CLIENT",
      order: 2
    },
    "none": {
      name: "NONE",
      value: "none",
      label: "–",
      abbreviation: "NONE",
      order: 3
    }
  },
  "TENANT": {
    name: "TENANT",
    value: "tenant",
    label: "Tenant",
    abbreviation: "TENANT",
    order: 0
  },
  "LANDLORD": {
    name: "LANDLORD",
    value: "landlord",
    label: "Landlord",
    abbreviation: "LANDLORD",
    order: 1
  },
  "CLIENT": {
    name: "CLIENT",
    value: "client",
    label: "Client",
    abbreviation: "CLIENT",
    order: 2
  },
  "NONE": {
    name: "NONE",
    value: "none",
    label: "–",
    abbreviation: "NONE",
    order: 3
  }
};
export var CommissionTypeEnum = {
  values: {
    "rate": {
      name: "RATE",
      value: "rate",
      label: "Rate",
      abbreviation: "RATE",
      order: 0
    },
    "contract_percentage": {
      name: "CONTRACT_PERCENTAGE",
      value: "contract_percentage",
      label: "Contract percentage",
      abbreviation: "CONTRACT_PERCENTAGE",
      order: 1
    },
    "negotiated": {
      name: "NEGOTIATED",
      value: "negotiated",
      label: "Negotiated",
      abbreviation: "NEGOTIATED",
      order: 2
    }
  },
  "RATE": {
    name: "RATE",
    value: "rate",
    label: "Rate",
    abbreviation: "RATE",
    order: 0
  },
  "CONTRACT_PERCENTAGE": {
    name: "CONTRACT_PERCENTAGE",
    value: "contract_percentage",
    label: "Contract percentage",
    abbreviation: "CONTRACT_PERCENTAGE",
    order: 1
  },
  "NEGOTIATED": {
    name: "NEGOTIATED",
    value: "negotiated",
    label: "Negotiated",
    abbreviation: "NEGOTIATED",
    order: 2
  }
};
export var RebateTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "percentage": {
      name: "PERCENTAGE",
      value: "percentage",
      label: "%",
      abbreviation: "PERCENTAGE",
      order: 1
    },
    "dollar": {
      name: "DOLLAR",
      value: "dollar",
      label: "$",
      abbreviation: "DOLLAR",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "PERCENTAGE": {
    name: "PERCENTAGE",
    value: "percentage",
    label: "%",
    abbreviation: "PERCENTAGE",
    order: 1
  },
  "DOLLAR": {
    name: "DOLLAR",
    value: "dollar",
    label: "$",
    abbreviation: "DOLLAR",
    order: 2
  }
};
export var FeesTypeEnum = {
  values: {
    "rebate": {
      name: "REBATE",
      value: "rebate",
      label: "Rebate",
      abbreviation: "REBATE",
      order: 0
    },
    "expense": {
      name: "EXPENSE",
      value: "expense",
      label: "Expense",
      abbreviation: "EXPENSE",
      order: 1
    }
  },
  "REBATE": {
    name: "REBATE",
    value: "rebate",
    label: "Rebate",
    abbreviation: "REBATE",
    order: 0
  },
  "EXPENSE": {
    name: "EXPENSE",
    value: "expense",
    label: "Expense",
    abbreviation: "EXPENSE",
    order: 1
  }
};
export var FrontMetaDataTypeEnum = {
  values: {
    "listings_email": {
      name: "LISTINGS_EMAIL",
      value: "listings_email",
      label: "LISTINGS_EMAIL",
      abbreviation: "LISTINGS_EMAIL",
      order: 0
    },
    "activity_digest": {
      name: "ACTIVITY_DIGEST",
      value: "activity_digest",
      label: "ACTIVITY_DIGEST",
      abbreviation: "ACTIVITY_DIGEST",
      order: 1
    },
    "tour_req_email": {
      name: "TOUR_REQUEST_EMAIL",
      value: "tour_req_email",
      label: "TOUR_REQUEST_EMAIL",
      abbreviation: "TOUR_REQUEST_EMAIL",
      order: 2
    }
  },
  "LISTINGS_EMAIL": {
    name: "LISTINGS_EMAIL",
    value: "listings_email",
    label: "LISTINGS_EMAIL",
    abbreviation: "LISTINGS_EMAIL",
    order: 0
  },
  "ACTIVITY_DIGEST": {
    name: "ACTIVITY_DIGEST",
    value: "activity_digest",
    label: "ACTIVITY_DIGEST",
    abbreviation: "ACTIVITY_DIGEST",
    order: 1
  },
  "TOUR_REQUEST_EMAIL": {
    name: "TOUR_REQUEST_EMAIL",
    value: "tour_req_email",
    label: "TOUR_REQUEST_EMAIL",
    abbreviation: "TOUR_REQUEST_EMAIL",
    order: 2
  }
};
export var ListingSourceEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "change_log": {
      name: "CHANGE_LOG",
      value: "change_log",
      label: "Change Log",
      abbreviation: "CHANGE_LOG",
      order: 1
    },
    "comps": {
      name: "COMPS",
      value: "comps",
      label: "Comp",
      abbreviation: "COMPS",
      order: 2
    },
    "import": {
      name: "IMPORT",
      value: "import",
      label: "Import",
      abbreviation: "IMPORT",
      order: 3
    },
    "costar_import": {
      name: "COSTAR_IMPORT",
      value: "costar_import",
      label: "CoStar Import",
      abbreviation: "COSTAR_IMPORT",
      order: 4
    },
    "portfolio_management": {
      name: "PORTFOLIO_MANAGEMENT",
      value: "portfolio_management",
      label: "Lease Abstract",
      abbreviation: "PORTFOLIO_MANAGEMENT",
      order: 5
    },
    "listing_agent": {
      name: "LISTING_AGENT",
      value: "listing_agent",
      label: "Listing Agent",
      abbreviation: "LISTING_AGENT",
      order: 6
    },
    "email_blast": {
      name: "EMAIL_BLAST",
      value: "email_blast",
      label: "Marketing Email",
      abbreviation: "EMAIL_BLAST",
      order: 7
    },
    "other": {
      name: "OTHER",
      value: "other",
      label: "Other",
      abbreviation: "OTHER",
      order: 8
    },
    "build_out": {
      name: "BUILD_OUT",
      value: "build_out",
      label: "Build out",
      abbreviation: "BUILD_OUT",
      order: 9
    },
    "priority_queue": {
      name: "PRIORITY_QUEUE",
      value: "priority_queue",
      label: "Priority Queue",
      abbreviation: "PRIORITY_QUEUE",
      order: 10
    },
    "jas_log": {
      name: "JAS_LOG",
      value: "jas_log",
      label: "JasLog",
      abbreviation: "JAS_LOG",
      order: 11
    },
    "building_clean_up": {
      name: "BUILDING_CLEAN_UP",
      value: "building_clean_up",
      label: "Building Clean Up",
      abbreviation: "BUILDING_CLEAN_UP",
      order: 12
    },
    "broker_outreach": {
      name: "BROKER_OUTREACH",
      value: "broker_outreach",
      label: "Broker Outreach",
      abbreviation: "BROKER_OUTREACH",
      order: 13
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "CHANGE_LOG": {
    name: "CHANGE_LOG",
    value: "change_log",
    label: "Change Log",
    abbreviation: "CHANGE_LOG",
    order: 1
  },
  "COMPS": {
    name: "COMPS",
    value: "comps",
    label: "Comp",
    abbreviation: "COMPS",
    order: 2
  },
  "IMPORT": {
    name: "IMPORT",
    value: "import",
    label: "Import",
    abbreviation: "IMPORT",
    order: 3
  },
  "COSTAR_IMPORT": {
    name: "COSTAR_IMPORT",
    value: "costar_import",
    label: "CoStar Import",
    abbreviation: "COSTAR_IMPORT",
    order: 4
  },
  "PORTFOLIO_MANAGEMENT": {
    name: "PORTFOLIO_MANAGEMENT",
    value: "portfolio_management",
    label: "Lease Abstract",
    abbreviation: "PORTFOLIO_MANAGEMENT",
    order: 5
  },
  "LISTING_AGENT": {
    name: "LISTING_AGENT",
    value: "listing_agent",
    label: "Listing Agent",
    abbreviation: "LISTING_AGENT",
    order: 6
  },
  "EMAIL_BLAST": {
    name: "EMAIL_BLAST",
    value: "email_blast",
    label: "Marketing Email",
    abbreviation: "EMAIL_BLAST",
    order: 7
  },
  "OTHER": {
    name: "OTHER",
    value: "other",
    label: "Other",
    abbreviation: "OTHER",
    order: 8
  },
  "BUILD_OUT": {
    name: "BUILD_OUT",
    value: "build_out",
    label: "Build out",
    abbreviation: "BUILD_OUT",
    order: 9
  },
  "PRIORITY_QUEUE": {
    name: "PRIORITY_QUEUE",
    value: "priority_queue",
    label: "Priority Queue",
    abbreviation: "PRIORITY_QUEUE",
    order: 10
  },
  "JAS_LOG": {
    name: "JAS_LOG",
    value: "jas_log",
    label: "JasLog",
    abbreviation: "JAS_LOG",
    order: 11
  },
  "BUILDING_CLEAN_UP": {
    name: "BUILDING_CLEAN_UP",
    value: "building_clean_up",
    label: "Building Clean Up",
    abbreviation: "BUILDING_CLEAN_UP",
    order: 12
  },
  "BROKER_OUTREACH": {
    name: "BROKER_OUTREACH",
    value: "broker_outreach",
    label: "Broker Outreach",
    abbreviation: "BROKER_OUTREACH",
    order: 13
  }
};
export var OrganizationWorkplaceDealStateEnum = {
  values: {
    "active": {
      name: "ACTIVE",
      value: "active",
      label: "Active",
      abbreviation: "ACTIVE",
      order: 0
    },
    "pursuit": {
      name: "PURSUIT",
      value: "pursuit",
      label: "Pursuit",
      abbreviation: "PURSUIT",
      order: 1
    },
    "none": {
      name: "NONE",
      value: "none",
      label: "No Activity",
      abbreviation: "NONE",
      order: 2
    }
  },
  "ACTIVE": {
    name: "ACTIVE",
    value: "active",
    label: "Active",
    abbreviation: "ACTIVE",
    order: 0
  },
  "PURSUIT": {
    name: "PURSUIT",
    value: "pursuit",
    label: "Pursuit",
    abbreviation: "PURSUIT",
    order: 1
  },
  "NONE": {
    name: "NONE",
    value: "none",
    label: "No Activity",
    abbreviation: "NONE",
    order: 2
  }
};
export var OrganizationDateRangeFilterEnum = {
  values: {
    "last_7_days": {
      name: "LAST_7_DAYS",
      value: "last_7_days",
      label: "Last 7 Days",
      abbreviation: "LAST_7_DAYS",
      order: 0
    },
    "last_week": {
      name: "LAST_WEEK",
      value: "last_week",
      label: "Last Week",
      abbreviation: "LAST_WEEK",
      order: 1
    },
    "last_month": {
      name: "LAST_MONTH",
      value: "last_month",
      label: "Last Month",
      abbreviation: "LAST_MONTH",
      order: 2
    },
    "last_quarter": {
      name: "LAST_QUARTER",
      value: "last_quarter",
      label: "Last Quarter",
      abbreviation: "LAST_QUARTER",
      order: 3
    },
    "this_year": {
      name: "THIS_YEAR",
      value: "this_year",
      label: "This Year",
      abbreviation: "THIS_YEAR",
      order: 4
    },
    "last_year": {
      name: "LAST_YEAR",
      value: "last_year",
      label: "Last Year",
      abbreviation: "LAST_YEAR",
      order: 5
    }
  },
  "LAST_7_DAYS": {
    name: "LAST_7_DAYS",
    value: "last_7_days",
    label: "Last 7 Days",
    abbreviation: "LAST_7_DAYS",
    order: 0
  },
  "LAST_WEEK": {
    name: "LAST_WEEK",
    value: "last_week",
    label: "Last Week",
    abbreviation: "LAST_WEEK",
    order: 1
  },
  "LAST_MONTH": {
    name: "LAST_MONTH",
    value: "last_month",
    label: "Last Month",
    abbreviation: "LAST_MONTH",
    order: 2
  },
  "LAST_QUARTER": {
    name: "LAST_QUARTER",
    value: "last_quarter",
    label: "Last Quarter",
    abbreviation: "LAST_QUARTER",
    order: 3
  },
  "THIS_YEAR": {
    name: "THIS_YEAR",
    value: "this_year",
    label: "This Year",
    abbreviation: "THIS_YEAR",
    order: 4
  },
  "LAST_YEAR": {
    name: "LAST_YEAR",
    value: "last_year",
    label: "Last Year",
    abbreviation: "LAST_YEAR",
    order: 5
  }
};
export var TeamMarketEnum = {
  values: {
    "sf": {
      name: "SF",
      value: "sf",
      label: "San Francisco",
      abbreviation: "SF",
      order: 0
    },
    "la": {
      name: "LA",
      value: "la",
      label: "Los Angeles",
      abbreviation: "LA",
      order: 1
    },
    "sv": {
      name: "SV",
      value: "sv",
      label: "Silicon Valley",
      abbreviation: "SV",
      order: 2
    }
  },
  "SF": {
    name: "SF",
    value: "sf",
    label: "San Francisco",
    abbreviation: "SF",
    order: 0
  },
  "LA": {
    name: "LA",
    value: "la",
    label: "Los Angeles",
    abbreviation: "LA",
    order: 1
  },
  "SV": {
    name: "SV",
    value: "sv",
    label: "Silicon Valley",
    abbreviation: "SV",
    order: 2
  }
};
export var DataStatusEnum = {
  values: {
    "all": {
      name: "ALL",
      value: "all",
      label: "All",
      abbreviation: "ALL",
      order: 0
    },
    "unconfirmed": {
      name: "UNCONFIRMED",
      value: "unconfirmed",
      label: "Unconfirmed",
      abbreviation: "UNCONFIRMED",
      order: 1
    },
    "awaiting": {
      name: "AWAITING",
      value: "awaiting",
      label: "Awaiting",
      abbreviation: "AWAITING",
      order: 2
    },
    "confirmed": {
      name: "CONFIRMED",
      value: "confirmed",
      label: "Confirmed",
      abbreviation: "CONFIRMED",
      order: 3
    }
  },
  "ALL": {
    name: "ALL",
    value: "all",
    label: "All",
    abbreviation: "ALL",
    order: 0
  },
  "UNCONFIRMED": {
    name: "UNCONFIRMED",
    value: "unconfirmed",
    label: "Unconfirmed",
    abbreviation: "UNCONFIRMED",
    order: 1
  },
  "AWAITING": {
    name: "AWAITING",
    value: "awaiting",
    label: "Awaiting",
    abbreviation: "AWAITING",
    order: 2
  },
  "CONFIRMED": {
    name: "CONFIRMED",
    value: "confirmed",
    label: "Confirmed",
    abbreviation: "CONFIRMED",
    order: 3
  }
};
export var TeamRoleEnum = {
  values: {
    "lead": {
      name: "LEAD",
      value: "lead",
      label: "Lead only",
      abbreviation: "LEAD",
      order: 0
    },
    "supporting": {
      name: "SUPPORTING",
      value: "supporting",
      label: "Supporting only",
      abbreviation: "SUPPORTING",
      order: 1
    },
    "all": {
      name: "ALL",
      value: "all",
      label: "Lead & Supporting",
      abbreviation: "ALL",
      order: 2
    }
  },
  "LEAD": {
    name: "LEAD",
    value: "lead",
    label: "Lead only",
    abbreviation: "LEAD",
    order: 0
  },
  "SUPPORTING": {
    name: "SUPPORTING",
    value: "supporting",
    label: "Supporting only",
    abbreviation: "SUPPORTING",
    order: 1
  },
  "ALL": {
    name: "ALL",
    value: "all",
    label: "Lead & Supporting",
    abbreviation: "ALL",
    order: 2
  }
};
export var InterestedOrganizationStatusEnum = {
  values: {
    "inquiry": {
      name: "INQUIRY",
      value: "inquiry",
      label: "Inquiry",
      abbreviation: "INQUIRY",
      order: 0
    },
    "toured": {
      name: "TOURED",
      value: "toured",
      label: "Toured",
      abbreviation: "TOURED",
      order: 1
    },
    "in_negotiations": {
      name: "IN_NEGOTIATIONS",
      value: "in_negotiations",
      label: "In Negotiations",
      abbreviation: "IN_NEGOTIATIONS",
      order: 2
    },
    "dead": {
      name: "DEAD",
      value: "dead",
      label: "Dead",
      abbreviation: "DEAD",
      order: 3
    }
  },
  "INQUIRY": {
    name: "INQUIRY",
    value: "inquiry",
    label: "Inquiry",
    abbreviation: "INQUIRY",
    order: 0
  },
  "TOURED": {
    name: "TOURED",
    value: "toured",
    label: "Toured",
    abbreviation: "TOURED",
    order: 1
  },
  "IN_NEGOTIATIONS": {
    name: "IN_NEGOTIATIONS",
    value: "in_negotiations",
    label: "In Negotiations",
    abbreviation: "IN_NEGOTIATIONS",
    order: 2
  },
  "DEAD": {
    name: "DEAD",
    value: "dead",
    label: "Dead",
    abbreviation: "DEAD",
    order: 3
  }
};
export var ActivityStageEnum = {
  values: {
    "inquiry": {
      name: "INQUIRY",
      value: "inquiry",
      label: "Inquiry",
      abbreviation: "INQUIRY",
      order: 0
    },
    "toured": {
      name: "TOURED",
      value: "toured",
      label: "Toured",
      abbreviation: "TOURED",
      order: 1
    },
    "in_negotiation": {
      name: "IN_NEGOTIATION",
      value: "in_negotiation",
      label: "In Negotiation",
      abbreviation: "IN_NEGOTIATION",
      order: 2
    },
    "dead": {
      name: "DEAD",
      value: "dead",
      label: "Dead",
      abbreviation: "DEAD",
      order: 3
    }
  },
  "INQUIRY": {
    name: "INQUIRY",
    value: "inquiry",
    label: "Inquiry",
    abbreviation: "INQUIRY",
    order: 0
  },
  "TOURED": {
    name: "TOURED",
    value: "toured",
    label: "Toured",
    abbreviation: "TOURED",
    order: 1
  },
  "IN_NEGOTIATION": {
    name: "IN_NEGOTIATION",
    value: "in_negotiation",
    label: "In Negotiation",
    abbreviation: "IN_NEGOTIATION",
    order: 2
  },
  "DEAD": {
    name: "DEAD",
    value: "dead",
    label: "Dead",
    abbreviation: "DEAD",
    order: 3
  }
};
export var ExpenseRecurringEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "monthly": {
      name: "MONTHLY",
      value: "monthly",
      label: "Monthly",
      abbreviation: "MONTHLY",
      order: 1
    },
    "yearly": {
      name: "YEARLY",
      value: "yearly",
      label: "Yearly",
      abbreviation: "YEARLY",
      order: 2
    },
    "quarterly": {
      name: "QUARTERLY",
      value: "quarterly",
      label: "Quarterly",
      abbreviation: "QUARTERLY",
      order: 3
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "MONTHLY": {
    name: "MONTHLY",
    value: "monthly",
    label: "Monthly",
    abbreviation: "MONTHLY",
    order: 1
  },
  "YEARLY": {
    name: "YEARLY",
    value: "yearly",
    label: "Yearly",
    abbreviation: "YEARLY",
    order: 2
  },
  "QUARTERLY": {
    name: "QUARTERLY",
    value: "quarterly",
    label: "Quarterly",
    abbreviation: "QUARTERLY",
    order: 3
  }
};
export var RoleTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "landlord": {
      name: "LANDLORD",
      value: "landlord",
      label: "Landlord",
      abbreviation: "LANDLORD",
      order: 1
    },
    "sublandlord": {
      name: "SUBLANDLORD",
      value: "sublandlord",
      label: "Sublandlord",
      abbreviation: "SUBLANDLORD",
      order: 2
    },
    "subtenant": {
      name: "SUBTENANT",
      value: "subtenant",
      label: "Subtenant",
      abbreviation: "SUBTENANT",
      order: 3
    },
    "tenant": {
      name: "TENANT",
      value: "tenant",
      label: "Tenant",
      abbreviation: "TENANT",
      order: 4
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "LANDLORD": {
    name: "LANDLORD",
    value: "landlord",
    label: "Landlord",
    abbreviation: "LANDLORD",
    order: 1
  },
  "SUBLANDLORD": {
    name: "SUBLANDLORD",
    value: "sublandlord",
    label: "Sublandlord",
    abbreviation: "SUBLANDLORD",
    order: 2
  },
  "SUBTENANT": {
    name: "SUBTENANT",
    value: "subtenant",
    label: "Subtenant",
    abbreviation: "SUBTENANT",
    order: 3
  },
  "TENANT": {
    name: "TENANT",
    value: "tenant",
    label: "Tenant",
    abbreviation: "TENANT",
    order: 4
  }
};
export var RentableSizeTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "sqft": {
      name: "SQFT",
      value: "sqft",
      label: "sqft",
      abbreviation: "SQFT",
      order: 1
    },
    "sqm": {
      name: "SQM",
      value: "sqm",
      label: "sqm",
      abbreviation: "SQM",
      order: 2
    },
    "tsubo": {
      name: "TSUBO",
      value: "tsubo",
      label: "tsubo",
      abbreviation: "TSUBO",
      order: 3
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "SQFT": {
    name: "SQFT",
    value: "sqft",
    label: "sqft",
    abbreviation: "SQFT",
    order: 1
  },
  "SQM": {
    name: "SQM",
    value: "sqm",
    label: "sqm",
    abbreviation: "SQM",
    order: 2
  },
  "TSUBO": {
    name: "TSUBO",
    value: "tsubo",
    label: "tsubo",
    abbreviation: "TSUBO",
    order: 3
  }
};
export var LeaseOptionTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "renewal": {
      name: "RENEWAL",
      value: "renewal",
      label: "Renewal",
      abbreviation: "RENEWAL",
      order: 1
    },
    "expansion": {
      name: "EXPANSION",
      value: "expansion",
      label: "Expansion",
      abbreviation: "EXPANSION",
      order: 2
    },
    "contraction": {
      name: "CONTRACTION",
      value: "contraction",
      label: "Contraction",
      abbreviation: "CONTRACTION",
      order: 3
    },
    "termination": {
      name: "TERMINATION",
      value: "termination",
      label: "Termination",
      abbreviation: "TERMINATION",
      order: 4
    },
    "right_first_offer": {
      name: "RIGHT_FIRST_OFFER",
      value: "right_first_offer",
      label: "Right of First Offer",
      abbreviation: "RIGHT_FIRST_OFFER",
      order: 5
    },
    "right_first_refusal": {
      name: "RIGHT_FIRST_REFUSAL",
      value: "right_first_refusal",
      label: "Right of First Refusal",
      abbreviation: "RIGHT_FIRST_REFUSAL",
      order: 6
    },
    "option_purchase": {
      name: "OPTION_PURCHASE",
      value: "option_purchase",
      label: "Option to Purchase",
      abbreviation: "OPTION_PURCHASE",
      order: 7
    },
    "custom": {
      name: "CUSTOM",
      value: "custom",
      label: "Custom",
      abbreviation: "CUSTOM",
      order: 8
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "RENEWAL": {
    name: "RENEWAL",
    value: "renewal",
    label: "Renewal",
    abbreviation: "RENEWAL",
    order: 1
  },
  "EXPANSION": {
    name: "EXPANSION",
    value: "expansion",
    label: "Expansion",
    abbreviation: "EXPANSION",
    order: 2
  },
  "CONTRACTION": {
    name: "CONTRACTION",
    value: "contraction",
    label: "Contraction",
    abbreviation: "CONTRACTION",
    order: 3
  },
  "TERMINATION": {
    name: "TERMINATION",
    value: "termination",
    label: "Termination",
    abbreviation: "TERMINATION",
    order: 4
  },
  "RIGHT_FIRST_OFFER": {
    name: "RIGHT_FIRST_OFFER",
    value: "right_first_offer",
    label: "Right of First Offer",
    abbreviation: "RIGHT_FIRST_OFFER",
    order: 5
  },
  "RIGHT_FIRST_REFUSAL": {
    name: "RIGHT_FIRST_REFUSAL",
    value: "right_first_refusal",
    label: "Right of First Refusal",
    abbreviation: "RIGHT_FIRST_REFUSAL",
    order: 6
  },
  "OPTION_PURCHASE": {
    name: "OPTION_PURCHASE",
    value: "option_purchase",
    label: "Option to Purchase",
    abbreviation: "OPTION_PURCHASE",
    order: 7
  },
  "CUSTOM": {
    name: "CUSTOM",
    value: "custom",
    label: "Custom",
    abbreviation: "CUSTOM",
    order: 8
  }
};
export var LeaseClauseTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "alterations": {
      name: "ALTERATIONS",
      value: "alterations",
      label: "Alterations",
      abbreviation: "ALTERATIONS",
      order: 1
    },
    "assignment_sublease": {
      name: "ASSIGNMENT_SUBLEASE",
      value: "assignment_sublease",
      label: "Assignment/ Sublease",
      abbreviation: "ASSIGNMENT_SUBLEASE",
      order: 2
    },
    "exterior_signage": {
      name: "EXTERIOR_SIGNAGE",
      value: "exterior_signage",
      label: "Exterior Signage",
      abbreviation: "EXTERIOR_SIGNAGE",
      order: 3
    },
    "holding_over": {
      name: "HOLDING_OVER",
      value: "holding_over",
      label: "Holding Over",
      abbreviation: "HOLDING_OVER",
      order: 4
    },
    "relocation": {
      name: "RELOCATION",
      value: "relocation",
      label: "Relocation",
      abbreviation: "RELOCATION",
      order: 5
    },
    "restoration": {
      name: "RESTORATION",
      value: "restoration",
      label: "Restoration",
      abbreviation: "RESTORATION",
      order: 6
    },
    "subord_nondist": {
      name: "SUBORDINATION_NONDISTURBANCE",
      value: "subord_nondist",
      label: "Subordination & Non-Disturbance",
      abbreviation: "SUBORDINATION_NONDISTURBANCE",
      order: 7
    },
    "ti_allowance": {
      name: "TI_ALLOWANCE",
      value: "ti_allowance",
      label: "Tenant Improvement (TI) Allowance",
      abbreviation: "TI_ALLOWANCE",
      order: 8
    },
    "custom": {
      name: "CUSTOM",
      value: "custom",
      label: "Custom",
      abbreviation: "CUSTOM",
      order: 9
    },
    "op_ex": {
      name: "OP_EX",
      value: "op_ex",
      label: "OpEx",
      abbreviation: "OP_EX",
      order: 10
    },
    "parking": {
      name: "PARKING",
      value: "parking",
      label: "Parking",
      abbreviation: "PARKING",
      order: 11
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "ALTERATIONS": {
    name: "ALTERATIONS",
    value: "alterations",
    label: "Alterations",
    abbreviation: "ALTERATIONS",
    order: 1
  },
  "ASSIGNMENT_SUBLEASE": {
    name: "ASSIGNMENT_SUBLEASE",
    value: "assignment_sublease",
    label: "Assignment/ Sublease",
    abbreviation: "ASSIGNMENT_SUBLEASE",
    order: 2
  },
  "EXTERIOR_SIGNAGE": {
    name: "EXTERIOR_SIGNAGE",
    value: "exterior_signage",
    label: "Exterior Signage",
    abbreviation: "EXTERIOR_SIGNAGE",
    order: 3
  },
  "HOLDING_OVER": {
    name: "HOLDING_OVER",
    value: "holding_over",
    label: "Holding Over",
    abbreviation: "HOLDING_OVER",
    order: 4
  },
  "RELOCATION": {
    name: "RELOCATION",
    value: "relocation",
    label: "Relocation",
    abbreviation: "RELOCATION",
    order: 5
  },
  "RESTORATION": {
    name: "RESTORATION",
    value: "restoration",
    label: "Restoration",
    abbreviation: "RESTORATION",
    order: 6
  },
  "SUBORDINATION_NONDISTURBANCE": {
    name: "SUBORDINATION_NONDISTURBANCE",
    value: "subord_nondist",
    label: "Subordination & Non-Disturbance",
    abbreviation: "SUBORDINATION_NONDISTURBANCE",
    order: 7
  },
  "TI_ALLOWANCE": {
    name: "TI_ALLOWANCE",
    value: "ti_allowance",
    label: "Tenant Improvement (TI) Allowance",
    abbreviation: "TI_ALLOWANCE",
    order: 8
  },
  "CUSTOM": {
    name: "CUSTOM",
    value: "custom",
    label: "Custom",
    abbreviation: "CUSTOM",
    order: 9
  },
  "OP_EX": {
    name: "OP_EX",
    value: "op_ex",
    label: "OpEx",
    abbreviation: "OP_EX",
    order: 10
  },
  "PARKING": {
    name: "PARKING",
    value: "parking",
    label: "Parking",
    abbreviation: "PARKING",
    order: 11
  }
};
export var CriticalDateEventTypeEnum = {
  values: {
    "annual_rent_increase": {
      name: "ANNUAL_RENT",
      value: "annual_rent_increase",
      label: "Annual Rent Increase",
      abbreviation: "ANNUAL_RENT",
      order: 0
    },
    "expansion_option_begin": {
      name: "EXPANSION_BEGIN",
      value: "expansion_option_begin",
      label: "Expansion Option Term Begins",
      abbreviation: "EXPANSION_BEGIN",
      order: 1
    },
    "expansion_option_end": {
      name: "EXPANSION_END",
      value: "expansion_option_end",
      label: "Expansion Option Term Ends",
      abbreviation: "EXPANSION_END",
      order: 2
    },
    "contraction_option_begin": {
      name: "CONTRACTION_BEGIN",
      value: "contraction_option_begin",
      label: "Contraction Option Term Begins",
      abbreviation: "CONTRACTION_BEGIN",
      order: 3
    },
    "contraction_option_end": {
      name: "CONTRACTION_END",
      value: "contraction_option_end",
      label: "Contraction Option Term Ends",
      abbreviation: "CONTRACTION_END",
      order: 4
    },
    "lease_expiration": {
      name: "LEASE_EXP",
      value: "lease_expiration",
      label: "Lease Expiration",
      abbreviation: "LEASE_EXP",
      order: 5
    },
    "renewal_option_begin": {
      name: "RENEWAL_BEGIN",
      value: "renewal_option_begin",
      label: "Renewal Option Exercise Window Begins",
      abbreviation: "RENEWAL_BEGIN",
      order: 6
    },
    "renewal_option_end": {
      name: "RENEWAL_END",
      value: "renewal_option_end",
      label: "Renewal Option Exercise Window Ends",
      abbreviation: "RENEWAL_END",
      order: 7
    },
    "sd_burn_down": {
      name: "SD_BURN_DOWN",
      value: "sd_burn_down",
      label: "Security Deposit Burn Down",
      abbreviation: "SD_BURN_DOWN",
      order: 8
    },
    "sd_return": {
      name: "SD_RETURN",
      value: "sd_return",
      label: "Security Deposit Adjustment",
      abbreviation: "SD_RETURN",
      order: 9
    },
    "termination_option_begin": {
      name: "TERMINATION_BEGIN",
      value: "termination_option_begin",
      label: "Termination Option Term Begins",
      abbreviation: "TERMINATION_BEGIN",
      order: 10
    },
    "termination_option_end": {
      name: "TERMINATION_END",
      value: "termination_option_end",
      label: "Termination Option Term End",
      abbreviation: "TERMINATION_END",
      order: 11
    },
    "ti_claim": {
      name: "TI_CLAIM",
      value: "ti_claim",
      label: "TI Allowance Claim",
      abbreviation: "TI_CLAIM",
      order: 12
    },
    "ti_deadline": {
      name: "TI_DEADLINE",
      value: "ti_deadline",
      label: "TI Allowance Deadline",
      abbreviation: "TI_DEADLINE",
      order: 13
    },
    "right_first_offer_begin": {
      name: "RIGHT_FIRST_OFFER_BEGIN",
      value: "right_first_offer_begin",
      label: "Right First Offer Begins",
      abbreviation: "RIGHT_FIRST_OFFER_BEGIN",
      order: 14
    },
    "right_first_offer_end": {
      name: "RIGHT_FIRST_OFFER_END",
      value: "right_first_offer_end",
      label: "Right First Offer Ends",
      abbreviation: "RIGHT_FIRST_OFFER_END",
      order: 15
    },
    "right_first_refusal_begin": {
      name: "RIGHT_FIRST_REFUSAL_BEGIN",
      value: "right_first_refusal_begin",
      label: "Right First Refusal Begins",
      abbreviation: "RIGHT_FIRST_REFUSAL_BEGIN",
      order: 16
    },
    "right_first_refusal_end": {
      name: "RIGHT_FIRST_REFUSAL_END",
      value: "right_first_refusal_end",
      label: "Right First Refusal Ends",
      abbreviation: "RIGHT_FIRST_REFUSAL_END",
      order: 17
    },
    "option_purchase_begin": {
      name: "OPTION_PURCHASE_BEGIN",
      value: "option_purchase_begin",
      label: "Option Purchase Begins",
      abbreviation: "OPTION_PURCHASE_BEGIN",
      order: 18
    },
    "option_purchase_end": {
      name: "OPTION_PURCHASE_END",
      value: "option_purchase_end",
      label: "Option Purchase Ends",
      abbreviation: "OPTION_PURCHASE_END",
      order: 19
    }
  },
  "ANNUAL_RENT": {
    name: "ANNUAL_RENT",
    value: "annual_rent_increase",
    label: "Annual Rent Increase",
    abbreviation: "ANNUAL_RENT",
    order: 0
  },
  "EXPANSION_BEGIN": {
    name: "EXPANSION_BEGIN",
    value: "expansion_option_begin",
    label: "Expansion Option Term Begins",
    abbreviation: "EXPANSION_BEGIN",
    order: 1
  },
  "EXPANSION_END": {
    name: "EXPANSION_END",
    value: "expansion_option_end",
    label: "Expansion Option Term Ends",
    abbreviation: "EXPANSION_END",
    order: 2
  },
  "CONTRACTION_BEGIN": {
    name: "CONTRACTION_BEGIN",
    value: "contraction_option_begin",
    label: "Contraction Option Term Begins",
    abbreviation: "CONTRACTION_BEGIN",
    order: 3
  },
  "CONTRACTION_END": {
    name: "CONTRACTION_END",
    value: "contraction_option_end",
    label: "Contraction Option Term Ends",
    abbreviation: "CONTRACTION_END",
    order: 4
  },
  "LEASE_EXP": {
    name: "LEASE_EXP",
    value: "lease_expiration",
    label: "Lease Expiration",
    abbreviation: "LEASE_EXP",
    order: 5
  },
  "RENEWAL_BEGIN": {
    name: "RENEWAL_BEGIN",
    value: "renewal_option_begin",
    label: "Renewal Option Exercise Window Begins",
    abbreviation: "RENEWAL_BEGIN",
    order: 6
  },
  "RENEWAL_END": {
    name: "RENEWAL_END",
    value: "renewal_option_end",
    label: "Renewal Option Exercise Window Ends",
    abbreviation: "RENEWAL_END",
    order: 7
  },
  "SD_BURN_DOWN": {
    name: "SD_BURN_DOWN",
    value: "sd_burn_down",
    label: "Security Deposit Burn Down",
    abbreviation: "SD_BURN_DOWN",
    order: 8
  },
  "SD_RETURN": {
    name: "SD_RETURN",
    value: "sd_return",
    label: "Security Deposit Adjustment",
    abbreviation: "SD_RETURN",
    order: 9
  },
  "TERMINATION_BEGIN": {
    name: "TERMINATION_BEGIN",
    value: "termination_option_begin",
    label: "Termination Option Term Begins",
    abbreviation: "TERMINATION_BEGIN",
    order: 10
  },
  "TERMINATION_END": {
    name: "TERMINATION_END",
    value: "termination_option_end",
    label: "Termination Option Term End",
    abbreviation: "TERMINATION_END",
    order: 11
  },
  "TI_CLAIM": {
    name: "TI_CLAIM",
    value: "ti_claim",
    label: "TI Allowance Claim",
    abbreviation: "TI_CLAIM",
    order: 12
  },
  "TI_DEADLINE": {
    name: "TI_DEADLINE",
    value: "ti_deadline",
    label: "TI Allowance Deadline",
    abbreviation: "TI_DEADLINE",
    order: 13
  },
  "RIGHT_FIRST_OFFER_BEGIN": {
    name: "RIGHT_FIRST_OFFER_BEGIN",
    value: "right_first_offer_begin",
    label: "Right First Offer Begins",
    abbreviation: "RIGHT_FIRST_OFFER_BEGIN",
    order: 14
  },
  "RIGHT_FIRST_OFFER_END": {
    name: "RIGHT_FIRST_OFFER_END",
    value: "right_first_offer_end",
    label: "Right First Offer Ends",
    abbreviation: "RIGHT_FIRST_OFFER_END",
    order: 15
  },
  "RIGHT_FIRST_REFUSAL_BEGIN": {
    name: "RIGHT_FIRST_REFUSAL_BEGIN",
    value: "right_first_refusal_begin",
    label: "Right First Refusal Begins",
    abbreviation: "RIGHT_FIRST_REFUSAL_BEGIN",
    order: 16
  },
  "RIGHT_FIRST_REFUSAL_END": {
    name: "RIGHT_FIRST_REFUSAL_END",
    value: "right_first_refusal_end",
    label: "Right First Refusal Ends",
    abbreviation: "RIGHT_FIRST_REFUSAL_END",
    order: 17
  },
  "OPTION_PURCHASE_BEGIN": {
    name: "OPTION_PURCHASE_BEGIN",
    value: "option_purchase_begin",
    label: "Option Purchase Begins",
    abbreviation: "OPTION_PURCHASE_BEGIN",
    order: 18
  },
  "OPTION_PURCHASE_END": {
    name: "OPTION_PURCHASE_END",
    value: "option_purchase_end",
    label: "Option Purchase Ends",
    abbreviation: "OPTION_PURCHASE_END",
    order: 19
  }
};
export var LeaseAmendmentReasonEnum = {
  values: {
    "renewal": {
      name: "RENEWAL",
      value: "renewal",
      label: "Renewal",
      abbreviation: "RENEWAL",
      order: 0
    },
    "expansion": {
      name: "EXPANSION",
      value: "expansion",
      label: "Expansion",
      abbreviation: "EXPANSION",
      order: 1
    },
    "renewal_expansion": {
      name: "RENEWAL_EXPANSION",
      value: "renewal_expansion",
      label: "Renewal / Expansion",
      abbreviation: "RENEWAL_EXPANSION",
      order: 2
    },
    "termination": {
      name: "TERMINATION",
      value: "termination",
      label: "Termination",
      abbreviation: "TERMINATION",
      order: 3
    },
    "space_reduction": {
      name: "SPACE_REDUCTION",
      value: "space_reduction",
      label: "Space Reduction",
      abbreviation: "SPACE_REDUCTION",
      order: 4
    },
    "other": {
      name: "OTHER",
      value: "other",
      label: "Other",
      abbreviation: "OTHER",
      order: 5
    }
  },
  "RENEWAL": {
    name: "RENEWAL",
    value: "renewal",
    label: "Renewal",
    abbreviation: "RENEWAL",
    order: 0
  },
  "EXPANSION": {
    name: "EXPANSION",
    value: "expansion",
    label: "Expansion",
    abbreviation: "EXPANSION",
    order: 1
  },
  "RENEWAL_EXPANSION": {
    name: "RENEWAL_EXPANSION",
    value: "renewal_expansion",
    label: "Renewal / Expansion",
    abbreviation: "RENEWAL_EXPANSION",
    order: 2
  },
  "TERMINATION": {
    name: "TERMINATION",
    value: "termination",
    label: "Termination",
    abbreviation: "TERMINATION",
    order: 3
  },
  "SPACE_REDUCTION": {
    name: "SPACE_REDUCTION",
    value: "space_reduction",
    label: "Space Reduction",
    abbreviation: "SPACE_REDUCTION",
    order: 4
  },
  "OTHER": {
    name: "OTHER",
    value: "other",
    label: "Other",
    abbreviation: "OTHER",
    order: 5
  }
};
export var ChangeEventTypeEnum = {
  values: {
    "data_change": {
      name: "DATA_CHANGE",
      value: "data_change",
      label: "DATA_CHANGE",
      abbreviation: "DATA_CHANGE",
      order: 0
    },
    "enrich": {
      name: "ENRICHMENT",
      value: "enrich",
      label: "ENRICHMENT",
      abbreviation: "ENRICHMENT",
      order: 1
    },
    "action": {
      name: "ACTION",
      value: "action",
      label: "ACTION",
      abbreviation: "ACTION",
      order: 2
    },
    "add_to_dr": {
      name: "ADDED_TO_DEALROOM",
      value: "add_to_dr",
      label: "ADDED_TO_DEALROOM",
      abbreviation: "ADDED_TO_DEALROOM",
      order: 3
    }
  },
  "DATA_CHANGE": {
    name: "DATA_CHANGE",
    value: "data_change",
    label: "DATA_CHANGE",
    abbreviation: "DATA_CHANGE",
    order: 0
  },
  "ENRICHMENT": {
    name: "ENRICHMENT",
    value: "enrich",
    label: "ENRICHMENT",
    abbreviation: "ENRICHMENT",
    order: 1
  },
  "ACTION": {
    name: "ACTION",
    value: "action",
    label: "ACTION",
    abbreviation: "ACTION",
    order: 2
  },
  "ADDED_TO_DEALROOM": {
    name: "ADDED_TO_DEALROOM",
    value: "add_to_dr",
    label: "ADDED_TO_DEALROOM",
    abbreviation: "ADDED_TO_DEALROOM",
    order: 3
  }
};
export var BuildingLoadingZoneEnum = {
  values: {
    "doc_high": {
      name: "DOC_HIGH",
      value: "doc_high",
      label: "Doc High",
      abbreviation: "DOC_HIGH",
      order: 0
    },
    "drive_in": {
      name: "Drive_in",
      value: "drive_in",
      label: "Drive In",
      abbreviation: "Drive_in",
      order: 1
    },
    "both": {
      name: "BOTH",
      value: "both",
      label: "Both",
      abbreviation: "BOTH",
      order: 2
    },
    "none": {
      name: "NONE",
      value: "none",
      label: "None",
      abbreviation: "NONE",
      order: 3
    }
  },
  "DOC_HIGH": {
    name: "DOC_HIGH",
    value: "doc_high",
    label: "Doc High",
    abbreviation: "DOC_HIGH",
    order: 0
  },
  "Drive_in": {
    name: "Drive_in",
    value: "drive_in",
    label: "Drive In",
    abbreviation: "Drive_in",
    order: 1
  },
  "BOTH": {
    name: "BOTH",
    value: "both",
    label: "Both",
    abbreviation: "BOTH",
    order: 2
  },
  "NONE": {
    name: "NONE",
    value: "none",
    label: "None",
    abbreviation: "NONE",
    order: 3
  }
};
export var ImageTagsEnum = {
  values: {
    "building": {
      name: "BUILDING",
      value: "building",
      label: "building",
      abbreviation: "BUILDING",
      order: 0
    },
    "lobby": {
      name: "LOBBY",
      value: "lobby",
      label: "lobby",
      abbreviation: "LOBBY",
      order: 1
    },
    "exterior": {
      name: "EXTERIOR",
      value: "exterior",
      label: "exterior",
      abbreviation: "EXTERIOR",
      order: 2
    },
    "conference-room": {
      name: "CONFERENCE_ROOM",
      value: "conference-room",
      label: "conference room",
      abbreviation: "CONFERENCE_ROOM",
      order: 3
    },
    "restroom": {
      name: "RESTROOM",
      value: "restroom",
      label: "restroom",
      abbreviation: "RESTROOM",
      order: 4
    },
    "common-space": {
      name: "COMMON_SPACE",
      value: "common-space",
      label: "common space",
      abbreviation: "COMMON_SPACE",
      order: 5
    },
    "entrance": {
      name: "ENTRANCE",
      value: "entrance",
      label: "entrance",
      abbreviation: "ENTRANCE",
      order: 6
    },
    "kitchen": {
      name: "KITCHEN",
      value: "kitchen",
      label: "kitchen",
      abbreviation: "KITCHEN",
      order: 7
    },
    "reception": {
      name: "RECEPTION",
      value: "reception",
      label: "reception",
      abbreviation: "RECEPTION",
      order: 8
    },
    "server-room": {
      name: "SERVER_ROOM",
      value: "server-room",
      label: "server room",
      abbreviation: "SERVER_ROOM",
      order: 9
    },
    "outdoor-deck": {
      name: "OUTDOOR_DECK",
      value: "outdoor-deck",
      label: "outdoor deck",
      abbreviation: "OUTDOOR_DECK",
      order: 10
    },
    "other": {
      name: "OTHER",
      value: "other",
      label: "other",
      abbreviation: "OTHER",
      order: 11
    }
  },
  "BUILDING": {
    name: "BUILDING",
    value: "building",
    label: "building",
    abbreviation: "BUILDING",
    order: 0
  },
  "LOBBY": {
    name: "LOBBY",
    value: "lobby",
    label: "lobby",
    abbreviation: "LOBBY",
    order: 1
  },
  "EXTERIOR": {
    name: "EXTERIOR",
    value: "exterior",
    label: "exterior",
    abbreviation: "EXTERIOR",
    order: 2
  },
  "CONFERENCE_ROOM": {
    name: "CONFERENCE_ROOM",
    value: "conference-room",
    label: "conference room",
    abbreviation: "CONFERENCE_ROOM",
    order: 3
  },
  "RESTROOM": {
    name: "RESTROOM",
    value: "restroom",
    label: "restroom",
    abbreviation: "RESTROOM",
    order: 4
  },
  "COMMON_SPACE": {
    name: "COMMON_SPACE",
    value: "common-space",
    label: "common space",
    abbreviation: "COMMON_SPACE",
    order: 5
  },
  "ENTRANCE": {
    name: "ENTRANCE",
    value: "entrance",
    label: "entrance",
    abbreviation: "ENTRANCE",
    order: 6
  },
  "KITCHEN": {
    name: "KITCHEN",
    value: "kitchen",
    label: "kitchen",
    abbreviation: "KITCHEN",
    order: 7
  },
  "RECEPTION": {
    name: "RECEPTION",
    value: "reception",
    label: "reception",
    abbreviation: "RECEPTION",
    order: 8
  },
  "SERVER_ROOM": {
    name: "SERVER_ROOM",
    value: "server-room",
    label: "server room",
    abbreviation: "SERVER_ROOM",
    order: 9
  },
  "OUTDOOR_DECK": {
    name: "OUTDOOR_DECK",
    value: "outdoor-deck",
    label: "outdoor deck",
    abbreviation: "OUTDOOR_DECK",
    order: 10
  },
  "OTHER": {
    name: "OTHER",
    value: "other",
    label: "other",
    abbreviation: "OTHER",
    order: 11
  }
};
export var LeaseAmendmentTypeEnum = {
  values: {
    "original": {
      name: "ORIGINAL",
      value: "original",
      label: "Original",
      abbreviation: "ORIGINAL",
      order: 0
    },
    "amendment": {
      name: "AMENDMENT",
      value: "amendment",
      label: "Amendment",
      abbreviation: "AMENDMENT",
      order: 1
    },
    "addendum": {
      name: "ADDENDUM",
      value: "addendum",
      label: "Addendum",
      abbreviation: "ADDENDUM",
      order: 2
    },
    "estoppel": {
      name: "ESTOPPEL",
      value: "estoppel",
      label: "Estoppel",
      abbreviation: "ESTOPPEL",
      order: 3
    },
    "LOI": {
      name: "LOI",
      value: "LOI",
      label: "LOI",
      abbreviation: "LOI",
      order: 4
    },
    "sublease_consent": {
      name: "SUBLEASE_CONSENT",
      value: "sublease_consent",
      label: "Consent to sublease",
      abbreviation: "SUBLEASE_CONSENT",
      order: 5
    },
    "other": {
      name: "OTHER",
      value: "other",
      label: "Other",
      abbreviation: "OTHER",
      order: 6
    }
  },
  "ORIGINAL": {
    name: "ORIGINAL",
    value: "original",
    label: "Original",
    abbreviation: "ORIGINAL",
    order: 0
  },
  "AMENDMENT": {
    name: "AMENDMENT",
    value: "amendment",
    label: "Amendment",
    abbreviation: "AMENDMENT",
    order: 1
  },
  "ADDENDUM": {
    name: "ADDENDUM",
    value: "addendum",
    label: "Addendum",
    abbreviation: "ADDENDUM",
    order: 2
  },
  "ESTOPPEL": {
    name: "ESTOPPEL",
    value: "estoppel",
    label: "Estoppel",
    abbreviation: "ESTOPPEL",
    order: 3
  },
  "LOI": {
    name: "LOI",
    value: "LOI",
    label: "LOI",
    abbreviation: "LOI",
    order: 4
  },
  "SUBLEASE_CONSENT": {
    name: "SUBLEASE_CONSENT",
    value: "sublease_consent",
    label: "Consent to sublease",
    abbreviation: "SUBLEASE_CONSENT",
    order: 5
  },
  "OTHER": {
    name: "OTHER",
    value: "other",
    label: "Other",
    abbreviation: "OTHER",
    order: 6
  }
};
export var CurrencyEnum = {
  values: {
    "AED": {
      name: "AED",
      value: "AED",
      label: "United Arab Emirates Dirham",
      abbreviation: "AED",
      order: 0,
      description: "د.إ"
    },
    "AFN": {
      name: "AFN",
      value: "AFN",
      label: "Afghan Afghani",
      abbreviation: "AFN",
      order: 1,
      description: "؋"
    },
    "ALL": {
      name: "ALL",
      value: "ALL",
      label: "Albanian Lek",
      abbreviation: "ALL",
      order: 2,
      description: "L"
    },
    "AMD": {
      name: "AMD",
      value: "AMD",
      label: "Armenian Dram",
      abbreviation: "AMD",
      order: 3,
      description: "֏"
    },
    "ANG": {
      name: "ANG",
      value: "ANG",
      label: "Netherlands Antillean Guilder",
      abbreviation: "ANG",
      order: 4,
      description: "ƒ"
    },
    "AOA": {
      name: "AOA",
      value: "AOA",
      label: "Angolan Kwanza",
      abbreviation: "AOA",
      order: 5,
      description: "Kz"
    },
    "ARS": {
      name: "ARS",
      value: "ARS",
      label: "Argentine Peso",
      abbreviation: "ARS",
      order: 6,
      description: "$"
    },
    "AUD": {
      name: "AUD",
      value: "AUD",
      label: "Australian Dollar",
      abbreviation: "AUD",
      order: 7,
      description: "$"
    },
    "AWG": {
      name: "AWG",
      value: "AWG",
      label: "Aruban Florin",
      abbreviation: "AWG",
      order: 8,
      description: "ƒ"
    },
    "AZN": {
      name: "AZN",
      value: "AZN",
      label: "Azerbaijani Manat",
      abbreviation: "AZN",
      order: 9,
      description: "₼"
    },
    "BAM": {
      name: "BAM",
      value: "BAM",
      label: "Bosnia-Herzegovina Convertible Mark",
      abbreviation: "BAM",
      order: 10,
      description: "KM"
    },
    "BBD": {
      name: "BBD",
      value: "BBD",
      label: "Barbadian Dollar",
      abbreviation: "BBD",
      order: 11,
      description: "$"
    },
    "BDT": {
      name: "BDT",
      value: "BDT",
      label: "Bangladeshi Taka",
      abbreviation: "BDT",
      order: 12,
      description: "৳"
    },
    "BGN": {
      name: "BGN",
      value: "BGN",
      label: "Bulgarian Lev",
      abbreviation: "BGN",
      order: 13,
      description: "лв"
    },
    "BHD": {
      name: "BHD",
      value: "BHD",
      label: "Bahraini Dinar",
      abbreviation: "BHD",
      order: 14,
      description: ".د.ب"
    },
    "BIF": {
      name: "BIF",
      value: "BIF",
      label: "Burundian Franc",
      abbreviation: "BIF",
      order: 15,
      description: "FBu"
    },
    "BMD": {
      name: "BMD",
      value: "BMD",
      label: "Bermudan Dollar",
      abbreviation: "BMD",
      order: 16,
      description: "$"
    },
    "BND": {
      name: "BND",
      value: "BND",
      label: "Brunei Dollar",
      abbreviation: "BND",
      order: 17,
      description: "$"
    },
    "BOB": {
      name: "BOB",
      value: "BOB",
      label: "Bolivian Boliviano",
      abbreviation: "BOB",
      order: 18,
      description: "$b"
    },
    "BRL": {
      name: "BRL",
      value: "BRL",
      label: "Brazilian Real",
      abbreviation: "BRL",
      order: 19,
      description: "R$"
    },
    "BSD": {
      name: "BSD",
      value: "BSD",
      label: "Bahamian Dollar",
      abbreviation: "BSD",
      order: 20,
      description: "$"
    },
    "BTC": {
      name: "BTC",
      value: "BTC",
      label: "Bitcoin",
      abbreviation: "BTC",
      order: 21,
      description: "฿"
    },
    "BTN": {
      name: "BTN",
      value: "BTN",
      label: "Bhutanese Ngultrum",
      abbreviation: "BTN",
      order: 22,
      description: "Nu."
    },
    "BWP": {
      name: "BWP",
      value: "BWP",
      label: "Botswanan Pula",
      abbreviation: "BWP",
      order: 23,
      description: "P"
    },
    "BYN": {
      name: "BYN",
      value: "BYN",
      label: "New Belarusian Ruble",
      abbreviation: "BYN",
      order: 24,
      description: "Br"
    },
    "BYR": {
      name: "BYR",
      value: "BYR",
      label: "Belarusian Ruble",
      abbreviation: "BYR",
      order: 25,
      description: "Br"
    },
    "BZD": {
      name: "BZD",
      value: "BZD",
      label: "Belize Dollar",
      abbreviation: "BZD",
      order: 26,
      description: "BZ$"
    },
    "CAD": {
      name: "CAD",
      value: "CAD",
      label: "Canadian Dollar",
      abbreviation: "CAD",
      order: 27,
      description: "$"
    },
    "CDF": {
      name: "CDF",
      value: "CDF",
      label: "Congolese Franc",
      abbreviation: "CDF",
      order: 28,
      description: "FC"
    },
    "CHF": {
      name: "CHF",
      value: "CHF",
      label: "Swiss Franc",
      abbreviation: "CHF",
      order: 29,
      description: "CHF"
    },
    "CLF": {
      name: "CLF",
      value: "CLF",
      label: "Chilean Unit of Account (UF)",
      abbreviation: "CLF",
      order: 30,
      description: "UF"
    },
    "CLP": {
      name: "CLP",
      value: "CLP",
      label: "Chilean Peso",
      abbreviation: "CLP",
      order: 31,
      description: "$"
    },
    "CNY": {
      name: "CNY",
      value: "CNY",
      label: "Chinese Yuan",
      abbreviation: "CNY",
      order: 32,
      description: "¥"
    },
    "COP": {
      name: "COP",
      value: "COP",
      label: "Colombian Peso",
      abbreviation: "COP",
      order: 33,
      description: "$"
    },
    "CRC": {
      name: "CRC",
      value: "CRC",
      label: "Costa Rican Colón",
      abbreviation: "CRC",
      order: 34,
      description: "₡"
    },
    "CUC": {
      name: "CUC",
      value: "CUC",
      label: "Cuban Convertible Peso",
      abbreviation: "CUC",
      order: 35,
      description: "$"
    },
    "CUP": {
      name: "CUP",
      value: "CUP",
      label: "Cuban Peso",
      abbreviation: "CUP",
      order: 36,
      description: "₱"
    },
    "CVE": {
      name: "CVE",
      value: "CVE",
      label: "Cape Verdean Escudo",
      abbreviation: "CVE",
      order: 37,
      description: "$"
    },
    "CZK": {
      name: "CZK",
      value: "CZK",
      label: "Czech Republic Koruna",
      abbreviation: "CZK",
      order: 38,
      description: "Kč"
    },
    "DJF": {
      name: "DJF",
      value: "DJF",
      label: "Djiboutian Franc",
      abbreviation: "DJF",
      order: 39,
      description: "Fdj"
    },
    "DKK": {
      name: "DKK",
      value: "DKK",
      label: "Danish Krone",
      abbreviation: "DKK",
      order: 40,
      description: "kr"
    },
    "DOP": {
      name: "DOP",
      value: "DOP",
      label: "Dominican Peso",
      abbreviation: "DOP",
      order: 41,
      description: "RD$"
    },
    "DZD": {
      name: "DZD",
      value: "DZD",
      label: "Algerian Dinar",
      abbreviation: "DZD",
      order: 42,
      description: "دج"
    },
    "EGP": {
      name: "EGP",
      value: "EGP",
      label: "Egyptian Pound",
      abbreviation: "EGP",
      order: 43,
      description: "£"
    },
    "ERN": {
      name: "ERN",
      value: "ERN",
      label: "Eritrean Nakfa",
      abbreviation: "ERN",
      order: 44,
      description: "Nfk"
    },
    "ETB": {
      name: "ETB",
      value: "ETB",
      label: "Ethiopian Birr",
      abbreviation: "ETB",
      order: 45,
      description: "Br"
    },
    "EUR": {
      name: "EUR",
      value: "EUR",
      label: "Euro",
      abbreviation: "EUR",
      order: 46,
      description: "€"
    },
    "FJD": {
      name: "FJD",
      value: "FJD",
      label: "Fijian Dollar",
      abbreviation: "FJD",
      order: 47,
      description: "$"
    },
    "FKP": {
      name: "FKP",
      value: "FKP",
      label: "Falkland Islands Pound",
      abbreviation: "FKP",
      order: 48,
      description: "£"
    },
    "GBP": {
      name: "GBP",
      value: "GBP",
      label: "British Pound Sterling",
      abbreviation: "GBP",
      order: 49,
      description: "£"
    },
    "GEL": {
      name: "GEL",
      value: "GEL",
      label: "Georgian Lari",
      abbreviation: "GEL",
      order: 50,
      description: "₾"
    },
    "GGP": {
      name: "GGP",
      value: "GGP",
      label: "Guernsey Pound",
      abbreviation: "GGP",
      order: 51,
      description: "£"
    },
    "GHS": {
      name: "GHS",
      value: "GHS",
      label: "Ghanaian Cedi",
      abbreviation: "GHS",
      order: 52,
      description: "GH₵"
    },
    "GIP": {
      name: "GIP",
      value: "GIP",
      label: "Gibraltar Pound",
      abbreviation: "GIP",
      order: 53,
      description: "£"
    },
    "GMD": {
      name: "GMD",
      value: "GMD",
      label: "Gambian Dalasi",
      abbreviation: "GMD",
      order: 54,
      description: "D"
    },
    "GNF": {
      name: "GNF",
      value: "GNF",
      label: "Guinean Franc",
      abbreviation: "GNF",
      order: 55,
      description: "FG"
    },
    "GTQ": {
      name: "GTQ",
      value: "GTQ",
      label: "Guatemalan Quetzal",
      abbreviation: "GTQ",
      order: 56,
      description: "Q"
    },
    "GYD": {
      name: "GYD",
      value: "GYD",
      label: "Guyanaese Dollar",
      abbreviation: "GYD",
      order: 57,
      description: "$"
    },
    "HKD": {
      name: "HKD",
      value: "HKD",
      label: "Hong Kong Dollar",
      abbreviation: "HKD",
      order: 58,
      description: "$"
    },
    "HNL": {
      name: "HNL",
      value: "HNL",
      label: "Honduran Lempira",
      abbreviation: "HNL",
      order: 59,
      description: "L"
    },
    "HRK": {
      name: "HRK",
      value: "HRK",
      label: "Croatian Kuna",
      abbreviation: "HRK",
      order: 60,
      description: "kn"
    },
    "HTG": {
      name: "HTG",
      value: "HTG",
      label: "Haitian Gourde",
      abbreviation: "HTG",
      order: 61,
      description: "G"
    },
    "HUF": {
      name: "HUF",
      value: "HUF",
      label: "Hungarian Forint",
      abbreviation: "HUF",
      order: 62,
      description: "Ft"
    },
    "IDR": {
      name: "IDR",
      value: "IDR",
      label: "Indonesian Rupiah",
      abbreviation: "IDR",
      order: 63,
      description: "Rp"
    },
    "ILS": {
      name: "ILS",
      value: "ILS",
      label: "Israeli New Sheqel",
      abbreviation: "ILS",
      order: 64,
      description: "₪"
    },
    "IMP": {
      name: "IMP",
      value: "IMP",
      label: "Manx pound",
      abbreviation: "IMP",
      order: 65,
      description: "£"
    },
    "INR": {
      name: "INR",
      value: "INR",
      label: "Indian Rupee",
      abbreviation: "INR",
      order: 66,
      description: "₹"
    },
    "IQD": {
      name: "IQD",
      value: "IQD",
      label: "Iraqi Dinar",
      abbreviation: "IQD",
      order: 67,
      description: "ع.د"
    },
    "IRR": {
      name: "IRR",
      value: "IRR",
      label: "Iranian Rial",
      abbreviation: "IRR",
      order: 68,
      description: "﷼"
    },
    "ISK": {
      name: "ISK",
      value: "ISK",
      label: "Icelandic Króna",
      abbreviation: "ISK",
      order: 69,
      description: "kr"
    },
    "JEP": {
      name: "JEP",
      value: "JEP",
      label: "Jersey Pound",
      abbreviation: "JEP",
      order: 70,
      description: "£"
    },
    "JMD": {
      name: "JMD",
      value: "JMD",
      label: "Jamaican Dollar",
      abbreviation: "JMD",
      order: 71,
      description: "J$"
    },
    "JOD": {
      name: "JOD",
      value: "JOD",
      label: "Jordanian Dinar",
      abbreviation: "JOD",
      order: 72,
      description: "JD"
    },
    "JPY": {
      name: "JPY",
      value: "JPY",
      label: "Japanese Yen",
      abbreviation: "JPY",
      order: 73,
      description: "¥"
    },
    "KES": {
      name: "KES",
      value: "KES",
      label: "Kenyan Shilling",
      abbreviation: "KES",
      order: 74,
      description: "KSh"
    },
    "KGS": {
      name: "KGS",
      value: "KGS",
      label: "Kyrgystani Som",
      abbreviation: "KGS",
      order: 75,
      description: "лв"
    },
    "KHR": {
      name: "KHR",
      value: "KHR",
      label: "Cambodian Riel",
      abbreviation: "KHR",
      order: 76,
      description: "៛"
    },
    "KMF": {
      name: "KMF",
      value: "KMF",
      label: "Comorian Franc",
      abbreviation: "KMF",
      order: 77,
      description: "CF"
    },
    "KPW": {
      name: "KPW",
      value: "KPW",
      label: "North Korean Won",
      abbreviation: "KPW",
      order: 78,
      description: "₩"
    },
    "KRW": {
      name: "KRW",
      value: "KRW",
      label: "South Korean Won",
      abbreviation: "KRW",
      order: 79,
      description: "₩"
    },
    "KWD": {
      name: "KWD",
      value: "KWD",
      label: "Kuwaiti Dinar",
      abbreviation: "KWD",
      order: 80,
      description: "KD"
    },
    "KYD": {
      name: "KYD",
      value: "KYD",
      label: "Cayman Islands Dollar",
      abbreviation: "KYD",
      order: 81,
      description: "$"
    },
    "KZT": {
      name: "KZT",
      value: "KZT",
      label: "Kazakhstani Tenge",
      abbreviation: "KZT",
      order: 82,
      description: "₸"
    },
    "LAK": {
      name: "LAK",
      value: "LAK",
      label: "Laotian Kip",
      abbreviation: "LAK",
      order: 83,
      description: "₭"
    },
    "LBP": {
      name: "LBP",
      value: "LBP",
      label: "Lebanese Pound",
      abbreviation: "LBP",
      order: 84,
      description: "£"
    },
    "LKR": {
      name: "LKR",
      value: "LKR",
      label: "Sri Lankan Rupee",
      abbreviation: "LKR",
      order: 85,
      description: "₨"
    },
    "LRD": {
      name: "LRD",
      value: "LRD",
      label: "Liberian Dollar",
      abbreviation: "LRD",
      order: 86,
      description: "$"
    },
    "LSL": {
      name: "LSL",
      value: "LSL",
      label: "Lesotho Loti",
      abbreviation: "LSL",
      order: 87,
      description: "M"
    },
    "LTL": {
      name: "LTL",
      value: "LTL",
      label: "Lithuanian Litas",
      abbreviation: "LTL",
      order: 88,
      description: "Lt"
    },
    "LVL": {
      name: "LVL",
      value: "LVL",
      label: "Latvian Lats",
      abbreviation: "LVL",
      order: 89,
      description: "Ls"
    },
    "LYD": {
      name: "LYD",
      value: "LYD",
      label: "Libyan Dinar",
      abbreviation: "LYD",
      order: 90,
      description: "LD"
    },
    "MAD": {
      name: "MAD",
      value: "MAD",
      label: "Moroccan Dirham",
      abbreviation: "MAD",
      order: 91,
      description: "MAD"
    },
    "MDL": {
      name: "MDL",
      value: "MDL",
      label: "Moldovan Leu",
      abbreviation: "MDL",
      order: 92,
      description: "lei"
    },
    "MGA": {
      name: "MGA",
      value: "MGA",
      label: "Malagasy Ariary",
      abbreviation: "MGA",
      order: 93,
      description: "Ar"
    },
    "MKD": {
      name: "MKD",
      value: "MKD",
      label: "Macedonian Denar",
      abbreviation: "MKD",
      order: 94,
      description: "ден"
    },
    "MMK": {
      name: "MMK",
      value: "MMK",
      label: "Myanma Kyat",
      abbreviation: "MMK",
      order: 95,
      description: "K"
    },
    "MNT": {
      name: "MNT",
      value: "MNT",
      label: "Mongolian Tugrik",
      abbreviation: "MNT",
      order: 96,
      description: "₮"
    },
    "MOP": {
      name: "MOP",
      value: "MOP",
      label: "Macanese Pataca",
      abbreviation: "MOP",
      order: 97,
      description: "MOP$"
    },
    "MRO": {
      name: "MRO",
      value: "MRO",
      label: "Mauritanian Ouguiya",
      abbreviation: "MRO",
      order: 98,
      description: "UM"
    },
    "MUR": {
      name: "MUR",
      value: "MUR",
      label: "Mauritian Rupee",
      abbreviation: "MUR",
      order: 99,
      description: "₨"
    },
    "MVR": {
      name: "MVR",
      value: "MVR",
      label: "Maldivian Rufiyaa",
      abbreviation: "MVR",
      order: 100,
      description: "Rf"
    },
    "MWK": {
      name: "MWK",
      value: "MWK",
      label: "Malawian Kwacha",
      abbreviation: "MWK",
      order: 101,
      description: "MK"
    },
    "MXN": {
      name: "MXN",
      value: "MXN",
      label: "Mexican Peso",
      abbreviation: "MXN",
      order: 102,
      description: "$"
    },
    "MYR": {
      name: "MYR",
      value: "MYR",
      label: "Malaysian Ringgit",
      abbreviation: "MYR",
      order: 103,
      description: "RM"
    },
    "MZN": {
      name: "MZN",
      value: "MZN",
      label: "Mozambican Metical",
      abbreviation: "MZN",
      order: 104,
      description: "MT"
    },
    "NAD": {
      name: "NAD",
      value: "NAD",
      label: "Namibian Dollar",
      abbreviation: "NAD",
      order: 105,
      description: "$"
    },
    "NGN": {
      name: "NGN",
      value: "NGN",
      label: "Nigerian Naira",
      abbreviation: "NGN",
      order: 106,
      description: "₦"
    },
    "NIO": {
      name: "NIO",
      value: "NIO",
      label: "Nicaraguan Córdoba",
      abbreviation: "NIO",
      order: 107,
      description: "C$"
    },
    "NOK": {
      name: "NOK",
      value: "NOK",
      label: "Norwegian Krone",
      abbreviation: "NOK",
      order: 108,
      description: "kr"
    },
    "NPR": {
      name: "NPR",
      value: "NPR",
      label: "Nepalese Rupee",
      abbreviation: "NPR",
      order: 109,
      description: "₨"
    },
    "NZD": {
      name: "NZD",
      value: "NZD",
      label: "New Zealand Dollar",
      abbreviation: "NZD",
      order: 110,
      description: "$"
    },
    "OMR": {
      name: "OMR",
      value: "OMR",
      label: "Omani Rial",
      abbreviation: "OMR",
      order: 111,
      description: "﷼"
    },
    "PAB": {
      name: "PAB",
      value: "PAB",
      label: "Panamanian Balboa",
      abbreviation: "PAB",
      order: 112,
      description: "B/."
    },
    "PEN": {
      name: "PEN",
      value: "PEN",
      label: "Peruvian Nuevo Sol",
      abbreviation: "PEN",
      order: 113,
      description: "S/."
    },
    "PGK": {
      name: "PGK",
      value: "PGK",
      label: "Papua New Guinean Kina",
      abbreviation: "PGK",
      order: 114,
      description: "K"
    },
    "PHP": {
      name: "PHP",
      value: "PHP",
      label: "Philippine Peso",
      abbreviation: "PHP",
      order: 115,
      description: "₱"
    },
    "PKR": {
      name: "PKR",
      value: "PKR",
      label: "Pakistani Rupee",
      abbreviation: "PKR",
      order: 116,
      description: "₨"
    },
    "PLN": {
      name: "PLN",
      value: "PLN",
      label: "Polish Zloty",
      abbreviation: "PLN",
      order: 117,
      description: "zł"
    },
    "PYG": {
      name: "PYG",
      value: "PYG",
      label: "Paraguayan Guarani",
      abbreviation: "PYG",
      order: 118,
      description: "Gs"
    },
    "QAR": {
      name: "QAR",
      value: "QAR",
      label: "Qatari Rial",
      abbreviation: "QAR",
      order: 119,
      description: "﷼"
    },
    "RON": {
      name: "RON",
      value: "RON",
      label: "Romanian Leu",
      abbreviation: "RON",
      order: 120,
      description: "lei"
    },
    "RSD": {
      name: "RSD",
      value: "RSD",
      label: "Serbian Dinar",
      abbreviation: "RSD",
      order: 121,
      description: "Дин."
    },
    "RUB": {
      name: "RUB",
      value: "RUB",
      label: "Russian Ruble",
      abbreviation: "RUB",
      order: 122,
      description: "₽"
    },
    "RWF": {
      name: "RWF",
      value: "RWF",
      label: "Rwandan Franc",
      abbreviation: "RWF",
      order: 123,
      description: "R₣"
    },
    "SAR": {
      name: "SAR",
      value: "SAR",
      label: "Saudi Riyal",
      abbreviation: "SAR",
      order: 124,
      description: "﷼"
    },
    "SBD": {
      name: "SBD",
      value: "SBD",
      label: "Solomon Islands Dollar",
      abbreviation: "SBD",
      order: 125,
      description: "$"
    },
    "SCR": {
      name: "SCR",
      value: "SCR",
      label: "Seychellois Rupee",
      abbreviation: "SCR",
      order: 126,
      description: "₨"
    },
    "SDG": {
      name: "SDG",
      value: "SDG",
      label: "Sudanese Pound",
      abbreviation: "SDG",
      order: 127,
      description: "ج.س."
    },
    "SEK": {
      name: "SEK",
      value: "SEK",
      label: "Swedish Krona",
      abbreviation: "SEK",
      order: 128,
      description: "kr"
    },
    "SGD": {
      name: "SGD",
      value: "SGD",
      label: "Singapore Dollar",
      abbreviation: "SGD",
      order: 129,
      description: "$"
    },
    "SHP": {
      name: "SHP",
      value: "SHP",
      label: "Saint Helena Pound",
      abbreviation: "SHP",
      order: 130,
      description: "£"
    },
    "SLL": {
      name: "SLL",
      value: "SLL",
      label: "Sierra Leonean Leone",
      abbreviation: "SLL",
      order: 131,
      description: "Le"
    },
    "SOS": {
      name: "SOS",
      value: "SOS",
      label: "Somali Shilling",
      abbreviation: "SOS",
      order: 132,
      description: "S"
    },
    "SRD": {
      name: "SRD",
      value: "SRD",
      label: "Surinamese Dollar",
      abbreviation: "SRD",
      order: 133,
      description: "$"
    },
    "SSP": {
      name: "SSP",
      value: "SSP",
      label: "SSP",
      abbreviation: "SSP",
      order: 134,
      description: "£"
    },
    "STD": {
      name: "STD",
      value: "STD",
      label: "São Tomé and Príncipe Dobra",
      abbreviation: "STD",
      order: 135,
      description: "Db"
    },
    "STN": {
      name: "STN",
      value: "STN",
      label: "STN",
      abbreviation: "STN",
      order: 136,
      description: "Db"
    },
    "SVC": {
      name: "SVC",
      value: "SVC",
      label: "Salvadoran Colón",
      abbreviation: "SVC",
      order: 137,
      description: "$"
    },
    "SYP": {
      name: "SYP",
      value: "SYP",
      label: "Syrian Pound",
      abbreviation: "SYP",
      order: 138,
      description: "£"
    },
    "SZL": {
      name: "SZL",
      value: "SZL",
      label: "Swazi Lilangeni",
      abbreviation: "SZL",
      order: 139,
      description: "E"
    },
    "THB": {
      name: "THB",
      value: "THB",
      label: "Thai Baht",
      abbreviation: "THB",
      order: 140,
      description: "฿"
    },
    "TJS": {
      name: "TJS",
      value: "TJS",
      label: "Tajikistani Somoni",
      abbreviation: "TJS",
      order: 141,
      description: "SM"
    },
    "TMT": {
      name: "TMT",
      value: "TMT",
      label: "Turkmenistani Manat",
      abbreviation: "TMT",
      order: 142,
      description: "T"
    },
    "TND": {
      name: "TND",
      value: "TND",
      label: "Tunisian Dinar",
      abbreviation: "TND",
      order: 143,
      description: "د.ت"
    },
    "TOP": {
      name: "TOP",
      value: "TOP",
      label: "Tongan Paʻanga",
      abbreviation: "TOP",
      order: 144,
      description: "T$"
    },
    "TRY": {
      name: "TRY",
      value: "TRY",
      label: "Turkish Lira",
      abbreviation: "TRY",
      order: 145,
      description: "₺"
    },
    "TTD": {
      name: "TTD",
      value: "TTD",
      label: "Trinidad and Tobago Dollar",
      abbreviation: "TTD",
      order: 146,
      description: "TT$"
    },
    "TWD": {
      name: "TWD",
      value: "TWD",
      label: "New Taiwan Dollar",
      abbreviation: "TWD",
      order: 147,
      description: "NT$"
    },
    "TZS": {
      name: "TZS",
      value: "TZS",
      label: "Tanzanian Shilling",
      abbreviation: "TZS",
      order: 148,
      description: "TSh"
    },
    "UAH": {
      name: "UAH",
      value: "UAH",
      label: "Ukrainian Hryvnia",
      abbreviation: "UAH",
      order: 149,
      description: "₴"
    },
    "UGX": {
      name: "UGX",
      value: "UGX",
      label: "Ugandan Shilling",
      abbreviation: "UGX",
      order: 150,
      description: "USh"
    },
    "USD": {
      name: "USD",
      value: "USD",
      label: "United States Dollar",
      abbreviation: "USD",
      order: 151,
      description: "$"
    },
    "UYU": {
      name: "UYU",
      value: "UYU",
      label: "Uruguayan Peso",
      abbreviation: "UYU",
      order: 152,
      description: "$U"
    },
    "UZS": {
      name: "UZS",
      value: "UZS",
      label: "Uzbekistan Som",
      abbreviation: "UZS",
      order: 153,
      description: "лв"
    },
    "VEF": {
      name: "VEF",
      value: "VEF",
      label: "Venezuelan Bolívar Fuerte",
      abbreviation: "VEF",
      order: 154,
      description: "Bs"
    },
    "VND": {
      name: "VND",
      value: "VND",
      label: "Vietnamese Dong",
      abbreviation: "VND",
      order: 155,
      description: "₫"
    },
    "VUV": {
      name: "VUV",
      value: "VUV",
      label: "Vanuatu Vatu",
      abbreviation: "VUV",
      order: 156,
      description: "VT"
    },
    "WST": {
      name: "WST",
      value: "WST",
      label: "Samoan Tala",
      abbreviation: "WST",
      order: 157,
      description: "WS$"
    },
    "XAF": {
      name: "XAF",
      value: "XAF",
      label: "CFA Franc BEAC",
      abbreviation: "XAF",
      order: 158,
      description: "FCFA"
    },
    "XAG": {
      name: "XAG",
      value: "XAG",
      label: "Silver (troy ounce)",
      abbreviation: "XAG",
      order: 159,
      description: "XAG"
    },
    "XAU": {
      name: "XAU",
      value: "XAU",
      label: "Gold (troy ounce)",
      abbreviation: "XAU",
      order: 160,
      description: "XAU"
    },
    "XCD": {
      name: "XCD",
      value: "XCD",
      label: "East Caribbean Dollar",
      abbreviation: "XCD",
      order: 161,
      description: "$"
    },
    "XDR": {
      name: "XDR",
      value: "XDR",
      label: "Special Drawing Rights",
      abbreviation: "XDR",
      order: 162,
      description: "XDR"
    },
    "XOF": {
      name: "XOF",
      value: "XOF",
      label: "CFA Franc BCEAO",
      abbreviation: "XOF",
      order: 163,
      description: "CFA"
    },
    "XPF": {
      name: "XPF",
      value: "XPF",
      label: "CFP Franc",
      abbreviation: "XPF",
      order: 164,
      description: "₣"
    },
    "YER": {
      name: "YER",
      value: "YER",
      label: "Yemeni Rial",
      abbreviation: "YER",
      order: 165,
      description: "﷼"
    },
    "ZAR": {
      name: "ZAR",
      value: "ZAR",
      label: "South African Rand",
      abbreviation: "ZAR",
      order: 166,
      description: "R"
    },
    "ZMK": {
      name: "ZMK",
      value: "ZMK",
      label: "Zambian Kwacha (pre-2013)",
      abbreviation: "ZMK",
      order: 167,
      description: "ZK"
    },
    "ZMW": {
      name: "ZMW",
      value: "ZMW",
      label: "Zambian Kwacha",
      abbreviation: "ZMW",
      order: 168,
      description: "ZK"
    },
    "ZWL": {
      name: "ZWL",
      value: "ZWL",
      label: "Zimbabwean Dollar",
      abbreviation: "ZWL",
      order: 169,
      description: "Z$"
    }
  },
  "AED": {
    name: "AED",
    value: "AED",
    label: "United Arab Emirates Dirham",
    abbreviation: "AED",
    order: 0,
    description: "د.إ"
  },
  "AFN": {
    name: "AFN",
    value: "AFN",
    label: "Afghan Afghani",
    abbreviation: "AFN",
    order: 1,
    description: "؋"
  },
  "ALL": {
    name: "ALL",
    value: "ALL",
    label: "Albanian Lek",
    abbreviation: "ALL",
    order: 2,
    description: "L"
  },
  "AMD": {
    name: "AMD",
    value: "AMD",
    label: "Armenian Dram",
    abbreviation: "AMD",
    order: 3,
    description: "֏"
  },
  "ANG": {
    name: "ANG",
    value: "ANG",
    label: "Netherlands Antillean Guilder",
    abbreviation: "ANG",
    order: 4,
    description: "ƒ"
  },
  "AOA": {
    name: "AOA",
    value: "AOA",
    label: "Angolan Kwanza",
    abbreviation: "AOA",
    order: 5,
    description: "Kz"
  },
  "ARS": {
    name: "ARS",
    value: "ARS",
    label: "Argentine Peso",
    abbreviation: "ARS",
    order: 6,
    description: "$"
  },
  "AUD": {
    name: "AUD",
    value: "AUD",
    label: "Australian Dollar",
    abbreviation: "AUD",
    order: 7,
    description: "$"
  },
  "AWG": {
    name: "AWG",
    value: "AWG",
    label: "Aruban Florin",
    abbreviation: "AWG",
    order: 8,
    description: "ƒ"
  },
  "AZN": {
    name: "AZN",
    value: "AZN",
    label: "Azerbaijani Manat",
    abbreviation: "AZN",
    order: 9,
    description: "₼"
  },
  "BAM": {
    name: "BAM",
    value: "BAM",
    label: "Bosnia-Herzegovina Convertible Mark",
    abbreviation: "BAM",
    order: 10,
    description: "KM"
  },
  "BBD": {
    name: "BBD",
    value: "BBD",
    label: "Barbadian Dollar",
    abbreviation: "BBD",
    order: 11,
    description: "$"
  },
  "BDT": {
    name: "BDT",
    value: "BDT",
    label: "Bangladeshi Taka",
    abbreviation: "BDT",
    order: 12,
    description: "৳"
  },
  "BGN": {
    name: "BGN",
    value: "BGN",
    label: "Bulgarian Lev",
    abbreviation: "BGN",
    order: 13,
    description: "лв"
  },
  "BHD": {
    name: "BHD",
    value: "BHD",
    label: "Bahraini Dinar",
    abbreviation: "BHD",
    order: 14,
    description: ".د.ب"
  },
  "BIF": {
    name: "BIF",
    value: "BIF",
    label: "Burundian Franc",
    abbreviation: "BIF",
    order: 15,
    description: "FBu"
  },
  "BMD": {
    name: "BMD",
    value: "BMD",
    label: "Bermudan Dollar",
    abbreviation: "BMD",
    order: 16,
    description: "$"
  },
  "BND": {
    name: "BND",
    value: "BND",
    label: "Brunei Dollar",
    abbreviation: "BND",
    order: 17,
    description: "$"
  },
  "BOB": {
    name: "BOB",
    value: "BOB",
    label: "Bolivian Boliviano",
    abbreviation: "BOB",
    order: 18,
    description: "$b"
  },
  "BRL": {
    name: "BRL",
    value: "BRL",
    label: "Brazilian Real",
    abbreviation: "BRL",
    order: 19,
    description: "R$"
  },
  "BSD": {
    name: "BSD",
    value: "BSD",
    label: "Bahamian Dollar",
    abbreviation: "BSD",
    order: 20,
    description: "$"
  },
  "BTC": {
    name: "BTC",
    value: "BTC",
    label: "Bitcoin",
    abbreviation: "BTC",
    order: 21,
    description: "฿"
  },
  "BTN": {
    name: "BTN",
    value: "BTN",
    label: "Bhutanese Ngultrum",
    abbreviation: "BTN",
    order: 22,
    description: "Nu."
  },
  "BWP": {
    name: "BWP",
    value: "BWP",
    label: "Botswanan Pula",
    abbreviation: "BWP",
    order: 23,
    description: "P"
  },
  "BYN": {
    name: "BYN",
    value: "BYN",
    label: "New Belarusian Ruble",
    abbreviation: "BYN",
    order: 24,
    description: "Br"
  },
  "BYR": {
    name: "BYR",
    value: "BYR",
    label: "Belarusian Ruble",
    abbreviation: "BYR",
    order: 25,
    description: "Br"
  },
  "BZD": {
    name: "BZD",
    value: "BZD",
    label: "Belize Dollar",
    abbreviation: "BZD",
    order: 26,
    description: "BZ$"
  },
  "CAD": {
    name: "CAD",
    value: "CAD",
    label: "Canadian Dollar",
    abbreviation: "CAD",
    order: 27,
    description: "$"
  },
  "CDF": {
    name: "CDF",
    value: "CDF",
    label: "Congolese Franc",
    abbreviation: "CDF",
    order: 28,
    description: "FC"
  },
  "CHF": {
    name: "CHF",
    value: "CHF",
    label: "Swiss Franc",
    abbreviation: "CHF",
    order: 29,
    description: "CHF"
  },
  "CLF": {
    name: "CLF",
    value: "CLF",
    label: "Chilean Unit of Account (UF)",
    abbreviation: "CLF",
    order: 30,
    description: "UF"
  },
  "CLP": {
    name: "CLP",
    value: "CLP",
    label: "Chilean Peso",
    abbreviation: "CLP",
    order: 31,
    description: "$"
  },
  "CNY": {
    name: "CNY",
    value: "CNY",
    label: "Chinese Yuan",
    abbreviation: "CNY",
    order: 32,
    description: "¥"
  },
  "COP": {
    name: "COP",
    value: "COP",
    label: "Colombian Peso",
    abbreviation: "COP",
    order: 33,
    description: "$"
  },
  "CRC": {
    name: "CRC",
    value: "CRC",
    label: "Costa Rican Colón",
    abbreviation: "CRC",
    order: 34,
    description: "₡"
  },
  "CUC": {
    name: "CUC",
    value: "CUC",
    label: "Cuban Convertible Peso",
    abbreviation: "CUC",
    order: 35,
    description: "$"
  },
  "CUP": {
    name: "CUP",
    value: "CUP",
    label: "Cuban Peso",
    abbreviation: "CUP",
    order: 36,
    description: "₱"
  },
  "CVE": {
    name: "CVE",
    value: "CVE",
    label: "Cape Verdean Escudo",
    abbreviation: "CVE",
    order: 37,
    description: "$"
  },
  "CZK": {
    name: "CZK",
    value: "CZK",
    label: "Czech Republic Koruna",
    abbreviation: "CZK",
    order: 38,
    description: "Kč"
  },
  "DJF": {
    name: "DJF",
    value: "DJF",
    label: "Djiboutian Franc",
    abbreviation: "DJF",
    order: 39,
    description: "Fdj"
  },
  "DKK": {
    name: "DKK",
    value: "DKK",
    label: "Danish Krone",
    abbreviation: "DKK",
    order: 40,
    description: "kr"
  },
  "DOP": {
    name: "DOP",
    value: "DOP",
    label: "Dominican Peso",
    abbreviation: "DOP",
    order: 41,
    description: "RD$"
  },
  "DZD": {
    name: "DZD",
    value: "DZD",
    label: "Algerian Dinar",
    abbreviation: "DZD",
    order: 42,
    description: "دج"
  },
  "EGP": {
    name: "EGP",
    value: "EGP",
    label: "Egyptian Pound",
    abbreviation: "EGP",
    order: 43,
    description: "£"
  },
  "ERN": {
    name: "ERN",
    value: "ERN",
    label: "Eritrean Nakfa",
    abbreviation: "ERN",
    order: 44,
    description: "Nfk"
  },
  "ETB": {
    name: "ETB",
    value: "ETB",
    label: "Ethiopian Birr",
    abbreviation: "ETB",
    order: 45,
    description: "Br"
  },
  "EUR": {
    name: "EUR",
    value: "EUR",
    label: "Euro",
    abbreviation: "EUR",
    order: 46,
    description: "€"
  },
  "FJD": {
    name: "FJD",
    value: "FJD",
    label: "Fijian Dollar",
    abbreviation: "FJD",
    order: 47,
    description: "$"
  },
  "FKP": {
    name: "FKP",
    value: "FKP",
    label: "Falkland Islands Pound",
    abbreviation: "FKP",
    order: 48,
    description: "£"
  },
  "GBP": {
    name: "GBP",
    value: "GBP",
    label: "British Pound Sterling",
    abbreviation: "GBP",
    order: 49,
    description: "£"
  },
  "GEL": {
    name: "GEL",
    value: "GEL",
    label: "Georgian Lari",
    abbreviation: "GEL",
    order: 50,
    description: "₾"
  },
  "GGP": {
    name: "GGP",
    value: "GGP",
    label: "Guernsey Pound",
    abbreviation: "GGP",
    order: 51,
    description: "£"
  },
  "GHS": {
    name: "GHS",
    value: "GHS",
    label: "Ghanaian Cedi",
    abbreviation: "GHS",
    order: 52,
    description: "GH₵"
  },
  "GIP": {
    name: "GIP",
    value: "GIP",
    label: "Gibraltar Pound",
    abbreviation: "GIP",
    order: 53,
    description: "£"
  },
  "GMD": {
    name: "GMD",
    value: "GMD",
    label: "Gambian Dalasi",
    abbreviation: "GMD",
    order: 54,
    description: "D"
  },
  "GNF": {
    name: "GNF",
    value: "GNF",
    label: "Guinean Franc",
    abbreviation: "GNF",
    order: 55,
    description: "FG"
  },
  "GTQ": {
    name: "GTQ",
    value: "GTQ",
    label: "Guatemalan Quetzal",
    abbreviation: "GTQ",
    order: 56,
    description: "Q"
  },
  "GYD": {
    name: "GYD",
    value: "GYD",
    label: "Guyanaese Dollar",
    abbreviation: "GYD",
    order: 57,
    description: "$"
  },
  "HKD": {
    name: "HKD",
    value: "HKD",
    label: "Hong Kong Dollar",
    abbreviation: "HKD",
    order: 58,
    description: "$"
  },
  "HNL": {
    name: "HNL",
    value: "HNL",
    label: "Honduran Lempira",
    abbreviation: "HNL",
    order: 59,
    description: "L"
  },
  "HRK": {
    name: "HRK",
    value: "HRK",
    label: "Croatian Kuna",
    abbreviation: "HRK",
    order: 60,
    description: "kn"
  },
  "HTG": {
    name: "HTG",
    value: "HTG",
    label: "Haitian Gourde",
    abbreviation: "HTG",
    order: 61,
    description: "G"
  },
  "HUF": {
    name: "HUF",
    value: "HUF",
    label: "Hungarian Forint",
    abbreviation: "HUF",
    order: 62,
    description: "Ft"
  },
  "IDR": {
    name: "IDR",
    value: "IDR",
    label: "Indonesian Rupiah",
    abbreviation: "IDR",
    order: 63,
    description: "Rp"
  },
  "ILS": {
    name: "ILS",
    value: "ILS",
    label: "Israeli New Sheqel",
    abbreviation: "ILS",
    order: 64,
    description: "₪"
  },
  "IMP": {
    name: "IMP",
    value: "IMP",
    label: "Manx pound",
    abbreviation: "IMP",
    order: 65,
    description: "£"
  },
  "INR": {
    name: "INR",
    value: "INR",
    label: "Indian Rupee",
    abbreviation: "INR",
    order: 66,
    description: "₹"
  },
  "IQD": {
    name: "IQD",
    value: "IQD",
    label: "Iraqi Dinar",
    abbreviation: "IQD",
    order: 67,
    description: "ع.د"
  },
  "IRR": {
    name: "IRR",
    value: "IRR",
    label: "Iranian Rial",
    abbreviation: "IRR",
    order: 68,
    description: "﷼"
  },
  "ISK": {
    name: "ISK",
    value: "ISK",
    label: "Icelandic Króna",
    abbreviation: "ISK",
    order: 69,
    description: "kr"
  },
  "JEP": {
    name: "JEP",
    value: "JEP",
    label: "Jersey Pound",
    abbreviation: "JEP",
    order: 70,
    description: "£"
  },
  "JMD": {
    name: "JMD",
    value: "JMD",
    label: "Jamaican Dollar",
    abbreviation: "JMD",
    order: 71,
    description: "J$"
  },
  "JOD": {
    name: "JOD",
    value: "JOD",
    label: "Jordanian Dinar",
    abbreviation: "JOD",
    order: 72,
    description: "JD"
  },
  "JPY": {
    name: "JPY",
    value: "JPY",
    label: "Japanese Yen",
    abbreviation: "JPY",
    order: 73,
    description: "¥"
  },
  "KES": {
    name: "KES",
    value: "KES",
    label: "Kenyan Shilling",
    abbreviation: "KES",
    order: 74,
    description: "KSh"
  },
  "KGS": {
    name: "KGS",
    value: "KGS",
    label: "Kyrgystani Som",
    abbreviation: "KGS",
    order: 75,
    description: "лв"
  },
  "KHR": {
    name: "KHR",
    value: "KHR",
    label: "Cambodian Riel",
    abbreviation: "KHR",
    order: 76,
    description: "៛"
  },
  "KMF": {
    name: "KMF",
    value: "KMF",
    label: "Comorian Franc",
    abbreviation: "KMF",
    order: 77,
    description: "CF"
  },
  "KPW": {
    name: "KPW",
    value: "KPW",
    label: "North Korean Won",
    abbreviation: "KPW",
    order: 78,
    description: "₩"
  },
  "KRW": {
    name: "KRW",
    value: "KRW",
    label: "South Korean Won",
    abbreviation: "KRW",
    order: 79,
    description: "₩"
  },
  "KWD": {
    name: "KWD",
    value: "KWD",
    label: "Kuwaiti Dinar",
    abbreviation: "KWD",
    order: 80,
    description: "KD"
  },
  "KYD": {
    name: "KYD",
    value: "KYD",
    label: "Cayman Islands Dollar",
    abbreviation: "KYD",
    order: 81,
    description: "$"
  },
  "KZT": {
    name: "KZT",
    value: "KZT",
    label: "Kazakhstani Tenge",
    abbreviation: "KZT",
    order: 82,
    description: "₸"
  },
  "LAK": {
    name: "LAK",
    value: "LAK",
    label: "Laotian Kip",
    abbreviation: "LAK",
    order: 83,
    description: "₭"
  },
  "LBP": {
    name: "LBP",
    value: "LBP",
    label: "Lebanese Pound",
    abbreviation: "LBP",
    order: 84,
    description: "£"
  },
  "LKR": {
    name: "LKR",
    value: "LKR",
    label: "Sri Lankan Rupee",
    abbreviation: "LKR",
    order: 85,
    description: "₨"
  },
  "LRD": {
    name: "LRD",
    value: "LRD",
    label: "Liberian Dollar",
    abbreviation: "LRD",
    order: 86,
    description: "$"
  },
  "LSL": {
    name: "LSL",
    value: "LSL",
    label: "Lesotho Loti",
    abbreviation: "LSL",
    order: 87,
    description: "M"
  },
  "LTL": {
    name: "LTL",
    value: "LTL",
    label: "Lithuanian Litas",
    abbreviation: "LTL",
    order: 88,
    description: "Lt"
  },
  "LVL": {
    name: "LVL",
    value: "LVL",
    label: "Latvian Lats",
    abbreviation: "LVL",
    order: 89,
    description: "Ls"
  },
  "LYD": {
    name: "LYD",
    value: "LYD",
    label: "Libyan Dinar",
    abbreviation: "LYD",
    order: 90,
    description: "LD"
  },
  "MAD": {
    name: "MAD",
    value: "MAD",
    label: "Moroccan Dirham",
    abbreviation: "MAD",
    order: 91,
    description: "MAD"
  },
  "MDL": {
    name: "MDL",
    value: "MDL",
    label: "Moldovan Leu",
    abbreviation: "MDL",
    order: 92,
    description: "lei"
  },
  "MGA": {
    name: "MGA",
    value: "MGA",
    label: "Malagasy Ariary",
    abbreviation: "MGA",
    order: 93,
    description: "Ar"
  },
  "MKD": {
    name: "MKD",
    value: "MKD",
    label: "Macedonian Denar",
    abbreviation: "MKD",
    order: 94,
    description: "ден"
  },
  "MMK": {
    name: "MMK",
    value: "MMK",
    label: "Myanma Kyat",
    abbreviation: "MMK",
    order: 95,
    description: "K"
  },
  "MNT": {
    name: "MNT",
    value: "MNT",
    label: "Mongolian Tugrik",
    abbreviation: "MNT",
    order: 96,
    description: "₮"
  },
  "MOP": {
    name: "MOP",
    value: "MOP",
    label: "Macanese Pataca",
    abbreviation: "MOP",
    order: 97,
    description: "MOP$"
  },
  "MRO": {
    name: "MRO",
    value: "MRO",
    label: "Mauritanian Ouguiya",
    abbreviation: "MRO",
    order: 98,
    description: "UM"
  },
  "MUR": {
    name: "MUR",
    value: "MUR",
    label: "Mauritian Rupee",
    abbreviation: "MUR",
    order: 99,
    description: "₨"
  },
  "MVR": {
    name: "MVR",
    value: "MVR",
    label: "Maldivian Rufiyaa",
    abbreviation: "MVR",
    order: 100,
    description: "Rf"
  },
  "MWK": {
    name: "MWK",
    value: "MWK",
    label: "Malawian Kwacha",
    abbreviation: "MWK",
    order: 101,
    description: "MK"
  },
  "MXN": {
    name: "MXN",
    value: "MXN",
    label: "Mexican Peso",
    abbreviation: "MXN",
    order: 102,
    description: "$"
  },
  "MYR": {
    name: "MYR",
    value: "MYR",
    label: "Malaysian Ringgit",
    abbreviation: "MYR",
    order: 103,
    description: "RM"
  },
  "MZN": {
    name: "MZN",
    value: "MZN",
    label: "Mozambican Metical",
    abbreviation: "MZN",
    order: 104,
    description: "MT"
  },
  "NAD": {
    name: "NAD",
    value: "NAD",
    label: "Namibian Dollar",
    abbreviation: "NAD",
    order: 105,
    description: "$"
  },
  "NGN": {
    name: "NGN",
    value: "NGN",
    label: "Nigerian Naira",
    abbreviation: "NGN",
    order: 106,
    description: "₦"
  },
  "NIO": {
    name: "NIO",
    value: "NIO",
    label: "Nicaraguan Córdoba",
    abbreviation: "NIO",
    order: 107,
    description: "C$"
  },
  "NOK": {
    name: "NOK",
    value: "NOK",
    label: "Norwegian Krone",
    abbreviation: "NOK",
    order: 108,
    description: "kr"
  },
  "NPR": {
    name: "NPR",
    value: "NPR",
    label: "Nepalese Rupee",
    abbreviation: "NPR",
    order: 109,
    description: "₨"
  },
  "NZD": {
    name: "NZD",
    value: "NZD",
    label: "New Zealand Dollar",
    abbreviation: "NZD",
    order: 110,
    description: "$"
  },
  "OMR": {
    name: "OMR",
    value: "OMR",
    label: "Omani Rial",
    abbreviation: "OMR",
    order: 111,
    description: "﷼"
  },
  "PAB": {
    name: "PAB",
    value: "PAB",
    label: "Panamanian Balboa",
    abbreviation: "PAB",
    order: 112,
    description: "B/."
  },
  "PEN": {
    name: "PEN",
    value: "PEN",
    label: "Peruvian Nuevo Sol",
    abbreviation: "PEN",
    order: 113,
    description: "S/."
  },
  "PGK": {
    name: "PGK",
    value: "PGK",
    label: "Papua New Guinean Kina",
    abbreviation: "PGK",
    order: 114,
    description: "K"
  },
  "PHP": {
    name: "PHP",
    value: "PHP",
    label: "Philippine Peso",
    abbreviation: "PHP",
    order: 115,
    description: "₱"
  },
  "PKR": {
    name: "PKR",
    value: "PKR",
    label: "Pakistani Rupee",
    abbreviation: "PKR",
    order: 116,
    description: "₨"
  },
  "PLN": {
    name: "PLN",
    value: "PLN",
    label: "Polish Zloty",
    abbreviation: "PLN",
    order: 117,
    description: "zł"
  },
  "PYG": {
    name: "PYG",
    value: "PYG",
    label: "Paraguayan Guarani",
    abbreviation: "PYG",
    order: 118,
    description: "Gs"
  },
  "QAR": {
    name: "QAR",
    value: "QAR",
    label: "Qatari Rial",
    abbreviation: "QAR",
    order: 119,
    description: "﷼"
  },
  "RON": {
    name: "RON",
    value: "RON",
    label: "Romanian Leu",
    abbreviation: "RON",
    order: 120,
    description: "lei"
  },
  "RSD": {
    name: "RSD",
    value: "RSD",
    label: "Serbian Dinar",
    abbreviation: "RSD",
    order: 121,
    description: "Дин."
  },
  "RUB": {
    name: "RUB",
    value: "RUB",
    label: "Russian Ruble",
    abbreviation: "RUB",
    order: 122,
    description: "₽"
  },
  "RWF": {
    name: "RWF",
    value: "RWF",
    label: "Rwandan Franc",
    abbreviation: "RWF",
    order: 123,
    description: "R₣"
  },
  "SAR": {
    name: "SAR",
    value: "SAR",
    label: "Saudi Riyal",
    abbreviation: "SAR",
    order: 124,
    description: "﷼"
  },
  "SBD": {
    name: "SBD",
    value: "SBD",
    label: "Solomon Islands Dollar",
    abbreviation: "SBD",
    order: 125,
    description: "$"
  },
  "SCR": {
    name: "SCR",
    value: "SCR",
    label: "Seychellois Rupee",
    abbreviation: "SCR",
    order: 126,
    description: "₨"
  },
  "SDG": {
    name: "SDG",
    value: "SDG",
    label: "Sudanese Pound",
    abbreviation: "SDG",
    order: 127,
    description: "ج.س."
  },
  "SEK": {
    name: "SEK",
    value: "SEK",
    label: "Swedish Krona",
    abbreviation: "SEK",
    order: 128,
    description: "kr"
  },
  "SGD": {
    name: "SGD",
    value: "SGD",
    label: "Singapore Dollar",
    abbreviation: "SGD",
    order: 129,
    description: "$"
  },
  "SHP": {
    name: "SHP",
    value: "SHP",
    label: "Saint Helena Pound",
    abbreviation: "SHP",
    order: 130,
    description: "£"
  },
  "SLL": {
    name: "SLL",
    value: "SLL",
    label: "Sierra Leonean Leone",
    abbreviation: "SLL",
    order: 131,
    description: "Le"
  },
  "SOS": {
    name: "SOS",
    value: "SOS",
    label: "Somali Shilling",
    abbreviation: "SOS",
    order: 132,
    description: "S"
  },
  "SRD": {
    name: "SRD",
    value: "SRD",
    label: "Surinamese Dollar",
    abbreviation: "SRD",
    order: 133,
    description: "$"
  },
  "SSP": {
    name: "SSP",
    value: "SSP",
    label: "SSP",
    abbreviation: "SSP",
    order: 134,
    description: "£"
  },
  "STD": {
    name: "STD",
    value: "STD",
    label: "São Tomé and Príncipe Dobra",
    abbreviation: "STD",
    order: 135,
    description: "Db"
  },
  "STN": {
    name: "STN",
    value: "STN",
    label: "STN",
    abbreviation: "STN",
    order: 136,
    description: "Db"
  },
  "SVC": {
    name: "SVC",
    value: "SVC",
    label: "Salvadoran Colón",
    abbreviation: "SVC",
    order: 137,
    description: "$"
  },
  "SYP": {
    name: "SYP",
    value: "SYP",
    label: "Syrian Pound",
    abbreviation: "SYP",
    order: 138,
    description: "£"
  },
  "SZL": {
    name: "SZL",
    value: "SZL",
    label: "Swazi Lilangeni",
    abbreviation: "SZL",
    order: 139,
    description: "E"
  },
  "THB": {
    name: "THB",
    value: "THB",
    label: "Thai Baht",
    abbreviation: "THB",
    order: 140,
    description: "฿"
  },
  "TJS": {
    name: "TJS",
    value: "TJS",
    label: "Tajikistani Somoni",
    abbreviation: "TJS",
    order: 141,
    description: "SM"
  },
  "TMT": {
    name: "TMT",
    value: "TMT",
    label: "Turkmenistani Manat",
    abbreviation: "TMT",
    order: 142,
    description: "T"
  },
  "TND": {
    name: "TND",
    value: "TND",
    label: "Tunisian Dinar",
    abbreviation: "TND",
    order: 143,
    description: "د.ت"
  },
  "TOP": {
    name: "TOP",
    value: "TOP",
    label: "Tongan Paʻanga",
    abbreviation: "TOP",
    order: 144,
    description: "T$"
  },
  "TRY": {
    name: "TRY",
    value: "TRY",
    label: "Turkish Lira",
    abbreviation: "TRY",
    order: 145,
    description: "₺"
  },
  "TTD": {
    name: "TTD",
    value: "TTD",
    label: "Trinidad and Tobago Dollar",
    abbreviation: "TTD",
    order: 146,
    description: "TT$"
  },
  "TWD": {
    name: "TWD",
    value: "TWD",
    label: "New Taiwan Dollar",
    abbreviation: "TWD",
    order: 147,
    description: "NT$"
  },
  "TZS": {
    name: "TZS",
    value: "TZS",
    label: "Tanzanian Shilling",
    abbreviation: "TZS",
    order: 148,
    description: "TSh"
  },
  "UAH": {
    name: "UAH",
    value: "UAH",
    label: "Ukrainian Hryvnia",
    abbreviation: "UAH",
    order: 149,
    description: "₴"
  },
  "UGX": {
    name: "UGX",
    value: "UGX",
    label: "Ugandan Shilling",
    abbreviation: "UGX",
    order: 150,
    description: "USh"
  },
  "USD": {
    name: "USD",
    value: "USD",
    label: "United States Dollar",
    abbreviation: "USD",
    order: 151,
    description: "$"
  },
  "UYU": {
    name: "UYU",
    value: "UYU",
    label: "Uruguayan Peso",
    abbreviation: "UYU",
    order: 152,
    description: "$U"
  },
  "UZS": {
    name: "UZS",
    value: "UZS",
    label: "Uzbekistan Som",
    abbreviation: "UZS",
    order: 153,
    description: "лв"
  },
  "VEF": {
    name: "VEF",
    value: "VEF",
    label: "Venezuelan Bolívar Fuerte",
    abbreviation: "VEF",
    order: 154,
    description: "Bs"
  },
  "VND": {
    name: "VND",
    value: "VND",
    label: "Vietnamese Dong",
    abbreviation: "VND",
    order: 155,
    description: "₫"
  },
  "VUV": {
    name: "VUV",
    value: "VUV",
    label: "Vanuatu Vatu",
    abbreviation: "VUV",
    order: 156,
    description: "VT"
  },
  "WST": {
    name: "WST",
    value: "WST",
    label: "Samoan Tala",
    abbreviation: "WST",
    order: 157,
    description: "WS$"
  },
  "XAF": {
    name: "XAF",
    value: "XAF",
    label: "CFA Franc BEAC",
    abbreviation: "XAF",
    order: 158,
    description: "FCFA"
  },
  "XAG": {
    name: "XAG",
    value: "XAG",
    label: "Silver (troy ounce)",
    abbreviation: "XAG",
    order: 159,
    description: "XAG"
  },
  "XAU": {
    name: "XAU",
    value: "XAU",
    label: "Gold (troy ounce)",
    abbreviation: "XAU",
    order: 160,
    description: "XAU"
  },
  "XCD": {
    name: "XCD",
    value: "XCD",
    label: "East Caribbean Dollar",
    abbreviation: "XCD",
    order: 161,
    description: "$"
  },
  "XDR": {
    name: "XDR",
    value: "XDR",
    label: "Special Drawing Rights",
    abbreviation: "XDR",
    order: 162,
    description: "XDR"
  },
  "XOF": {
    name: "XOF",
    value: "XOF",
    label: "CFA Franc BCEAO",
    abbreviation: "XOF",
    order: 163,
    description: "CFA"
  },
  "XPF": {
    name: "XPF",
    value: "XPF",
    label: "CFP Franc",
    abbreviation: "XPF",
    order: 164,
    description: "₣"
  },
  "YER": {
    name: "YER",
    value: "YER",
    label: "Yemeni Rial",
    abbreviation: "YER",
    order: 165,
    description: "﷼"
  },
  "ZAR": {
    name: "ZAR",
    value: "ZAR",
    label: "South African Rand",
    abbreviation: "ZAR",
    order: 166,
    description: "R"
  },
  "ZMK": {
    name: "ZMK",
    value: "ZMK",
    label: "Zambian Kwacha (pre-2013)",
    abbreviation: "ZMK",
    order: 167,
    description: "ZK"
  },
  "ZMW": {
    name: "ZMW",
    value: "ZMW",
    label: "Zambian Kwacha",
    abbreviation: "ZMW",
    order: 168,
    description: "ZK"
  },
  "ZWL": {
    name: "ZWL",
    value: "ZWL",
    label: "Zimbabwean Dollar",
    abbreviation: "ZWL",
    order: 169,
    description: "Z$"
  }
};
export var SecurityAdjustmentTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "reduce": {
      name: "REDUCTION",
      value: "reduce",
      label: "Landlord Refunds",
      abbreviation: "REDUCTION",
      order: 1
    },
    "add": {
      name: "ADDITION",
      value: "add",
      label: "Tenant Pays",
      abbreviation: "ADDITION",
      order: 2
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "REDUCTION": {
    name: "REDUCTION",
    value: "reduce",
    label: "Landlord Refunds",
    abbreviation: "REDUCTION",
    order: 1
  },
  "ADDITION": {
    name: "ADDITION",
    value: "add",
    label: "Tenant Pays",
    abbreviation: "ADDITION",
    order: 2
  }
};
export var TrackSetEnum = {
  values: {
    "market_stats": {
      name: "MARKET_STATS",
      value: "market_stats",
      label: "Market Stats",
      abbreviation: "MARKET_STATS",
      order: 0,
      description: "Used for market analytics"
    },
    "broker_priority": {
      name: "BROKER_PRIORITY",
      value: "broker_priority",
      label: "Broker Priority",
      abbreviation: "BROKER_PRIORITY",
      order: 1,
      description: "Not used for market analytics"
    },
    "not_tracked": {
      name: "NOT_TRACKED",
      value: "not_tracked",
      label: "Not Tracked",
      abbreviation: "NOT_TRACKED",
      order: 2,
      description: "Low priority for updates"
    },
    "no_status": {
      name: "NO_STATUS",
      value: "no_status",
      label: "No Status",
      abbreviation: "NO_STATUS",
      order: 3
    }
  },
  "MARKET_STATS": {
    name: "MARKET_STATS",
    value: "market_stats",
    label: "Market Stats",
    abbreviation: "MARKET_STATS",
    order: 0,
    description: "Used for market analytics"
  },
  "BROKER_PRIORITY": {
    name: "BROKER_PRIORITY",
    value: "broker_priority",
    label: "Broker Priority",
    abbreviation: "BROKER_PRIORITY",
    order: 1,
    description: "Not used for market analytics"
  },
  "NOT_TRACKED": {
    name: "NOT_TRACKED",
    value: "not_tracked",
    label: "Not Tracked",
    abbreviation: "NOT_TRACKED",
    order: 2,
    description: "Low priority for updates"
  },
  "NO_STATUS": {
    name: "NO_STATUS",
    value: "no_status",
    label: "No Status",
    abbreviation: "NO_STATUS",
    order: 3
  }
};
export var ResolutionsEnum = {
  values: {
    "day": {
      name: "DAY",
      value: "day",
      label: "By day",
      abbreviation: "DAY",
      order: 0
    },
    "week": {
      name: "WEEK",
      value: "week",
      label: "By week",
      abbreviation: "WEEK",
      order: 1
    },
    "month": {
      name: "MONTH",
      value: "month",
      label: "By month",
      abbreviation: "MONTH",
      order: 2
    },
    "quarter": {
      name: "QUARTER",
      value: "quarter",
      label: "By quarter",
      abbreviation: "QUARTER",
      order: 3
    },
    "year": {
      name: "YEAR",
      value: "year",
      label: "By year",
      abbreviation: "YEAR",
      order: 4
    }
  },
  "DAY": {
    name: "DAY",
    value: "day",
    label: "By day",
    abbreviation: "DAY",
    order: 0
  },
  "WEEK": {
    name: "WEEK",
    value: "week",
    label: "By week",
    abbreviation: "WEEK",
    order: 1
  },
  "MONTH": {
    name: "MONTH",
    value: "month",
    label: "By month",
    abbreviation: "MONTH",
    order: 2
  },
  "QUARTER": {
    name: "QUARTER",
    value: "quarter",
    label: "By quarter",
    abbreviation: "QUARTER",
    order: 3
  },
  "YEAR": {
    name: "YEAR",
    value: "year",
    label: "By year",
    abbreviation: "YEAR",
    order: 4
  }
};
export var SpaceStatusEnum = {
  values: {
    "active": {
      name: "ACTIVE",
      value: "active",
      label: "Active",
      abbreviation: "ACTIVE",
      order: 0
    },
    "upcoming": {
      name: "UPCOMING",
      value: "upcoming",
      label: "Upcoming",
      abbreviation: "UPCOMING",
      order: 1
    },
    "expired": {
      name: "EXPIRED",
      value: "expired",
      label: "Expired",
      abbreviation: "EXPIRED",
      order: 2
    }
  },
  "ACTIVE": {
    name: "ACTIVE",
    value: "active",
    label: "Active",
    abbreviation: "ACTIVE",
    order: 0
  },
  "UPCOMING": {
    name: "UPCOMING",
    value: "upcoming",
    label: "Upcoming",
    abbreviation: "UPCOMING",
    order: 1
  },
  "EXPIRED": {
    name: "EXPIRED",
    value: "expired",
    label: "Expired",
    abbreviation: "EXPIRED",
    order: 2
  }
};
export var AttendanceTypeEnum = {
  values: {
    "all_attendees": {
      name: "ALL_ATTENDEES",
      value: "all_attendees",
      label: "All Attendees",
      abbreviation: "ALL_ATTENDEES",
      order: 0
    },
    "assigned": {
      name: "ASSIGNED",
      value: "assigned",
      label: "Assigned",
      abbreviation: "ASSIGNED",
      order: 1
    }
  },
  "ALL_ATTENDEES": {
    name: "ALL_ATTENDEES",
    value: "all_attendees",
    label: "All Attendees",
    abbreviation: "ALL_ATTENDEES",
    order: 0
  },
  "ASSIGNED": {
    name: "ASSIGNED",
    value: "assigned",
    label: "Assigned",
    abbreviation: "ASSIGNED",
    order: 1
  }
};
export var WorkDaysEnum = {
  values: {
    "2": {
      name: "MONDAY",
      value: "2",
      label: "Monday",
      abbreviation: "Mon",
      order: 0
    },
    "3": {
      name: "TUESDAY",
      value: "3",
      label: "Tuesday",
      abbreviation: "Tue",
      order: 1
    },
    "4": {
      name: "WEDNESDAY",
      value: "4",
      label: "Wednesday",
      abbreviation: "Wed",
      order: 2
    },
    "5": {
      name: "THURSDAY",
      value: "5",
      label: "Thursday",
      abbreviation: "Thu",
      order: 3
    },
    "6": {
      name: "FRIDAY",
      value: "6",
      label: "Friday",
      abbreviation: "Fri",
      order: 4
    }
  },
  "MONDAY": {
    name: "MONDAY",
    value: "2",
    label: "Monday",
    abbreviation: "Mon",
    order: 0
  },
  "TUESDAY": {
    name: "TUESDAY",
    value: "3",
    label: "Tuesday",
    abbreviation: "Tue",
    order: 1
  },
  "WEDNESDAY": {
    name: "WEDNESDAY",
    value: "4",
    label: "Wednesday",
    abbreviation: "Wed",
    order: 2
  },
  "THURSDAY": {
    name: "THURSDAY",
    value: "5",
    label: "Thursday",
    abbreviation: "Thu",
    order: 3
  },
  "FRIDAY": {
    name: "FRIDAY",
    value: "6",
    label: "Friday",
    abbreviation: "Fri",
    order: 4
  }
};
export var WorkplaceAnalyticsMetricEnum = {
  values: {
    "attendance_by_workplace": {
      name: "ATTENDANCE_BY_WORKPLACE",
      value: "attendance_by_workplace",
      label: "Attendance by Workplace",
      abbreviation: "ATTENDANCE_BY_WORKPLACE",
      order: 0
    },
    "attendance_by_department": {
      name: "ATTENDANCE_BY_DEPARTMENT",
      value: "attendance_by_department",
      label: "Attendance by Department",
      abbreviation: "ATTENDANCE_BY_DEPARTMENT",
      order: 1
    },
    "attendance_by_frequency": {
      name: "ATTENDANCE_BY_FREQUENCY",
      value: "attendance_by_frequency",
      label: "Attendance by Frequency",
      abbreviation: "ATTENDANCE_BY_FREQUENCY",
      order: 2
    },
    "avg_attendance_frequency": {
      name: "AVG_ATTENDANCE_FREQUENCY",
      value: "avg_attendance_frequency",
      label: "Avg Attendance Frequency",
      abbreviation: "AVG_ATTENDANCE_FREQUENCY",
      order: 3
    },
    "peak_attendance_by_day_of_the_week": {
      name: "PEAK_ATTENDANCE_BY_DAY_OF_THE_WEEK",
      value: "peak_attendance_by_day_of_the_week",
      label: "Peak Attendance by DOW",
      abbreviation: "PEAK_ATTENDANCE_BY_DAY_OF_THE_WEEK",
      order: 4
    },
    "avg_attendance_by_day_of_the_week": {
      name: "AVG_ATTENDANCE_BY_DAY_OF_THE_WEEK",
      value: "avg_attendance_by_day_of_the_week",
      label: "Avg Attendance by DOW",
      abbreviation: "AVG_ATTENDANCE_BY_DAY_OF_THE_WEEK",
      order: 5
    },
    "attendance_trend": {
      name: "ATTENDANCE_TREND",
      value: "attendance_trend",
      label: "Attendance Trend",
      abbreviation: "ATTENDANCE_TREND",
      order: 6
    },
    "occupancy": {
      name: "OCCUPANCY",
      value: "occupancy",
      label: "Occupancy",
      abbreviation: "OCCUPANCY",
      order: 7
    },
    "utilization": {
      name: "UTILIZATION",
      value: "utilization",
      label: "Utilization",
      abbreviation: "UTILIZATION",
      order: 8
    }
  },
  "ATTENDANCE_BY_WORKPLACE": {
    name: "ATTENDANCE_BY_WORKPLACE",
    value: "attendance_by_workplace",
    label: "Attendance by Workplace",
    abbreviation: "ATTENDANCE_BY_WORKPLACE",
    order: 0
  },
  "ATTENDANCE_BY_DEPARTMENT": {
    name: "ATTENDANCE_BY_DEPARTMENT",
    value: "attendance_by_department",
    label: "Attendance by Department",
    abbreviation: "ATTENDANCE_BY_DEPARTMENT",
    order: 1
  },
  "ATTENDANCE_BY_FREQUENCY": {
    name: "ATTENDANCE_BY_FREQUENCY",
    value: "attendance_by_frequency",
    label: "Attendance by Frequency",
    abbreviation: "ATTENDANCE_BY_FREQUENCY",
    order: 2
  },
  "AVG_ATTENDANCE_FREQUENCY": {
    name: "AVG_ATTENDANCE_FREQUENCY",
    value: "avg_attendance_frequency",
    label: "Avg Attendance Frequency",
    abbreviation: "AVG_ATTENDANCE_FREQUENCY",
    order: 3
  },
  "PEAK_ATTENDANCE_BY_DAY_OF_THE_WEEK": {
    name: "PEAK_ATTENDANCE_BY_DAY_OF_THE_WEEK",
    value: "peak_attendance_by_day_of_the_week",
    label: "Peak Attendance by DOW",
    abbreviation: "PEAK_ATTENDANCE_BY_DAY_OF_THE_WEEK",
    order: 4
  },
  "AVG_ATTENDANCE_BY_DAY_OF_THE_WEEK": {
    name: "AVG_ATTENDANCE_BY_DAY_OF_THE_WEEK",
    value: "avg_attendance_by_day_of_the_week",
    label: "Avg Attendance by DOW",
    abbreviation: "AVG_ATTENDANCE_BY_DAY_OF_THE_WEEK",
    order: 5
  },
  "ATTENDANCE_TREND": {
    name: "ATTENDANCE_TREND",
    value: "attendance_trend",
    label: "Attendance Trend",
    abbreviation: "ATTENDANCE_TREND",
    order: 6
  },
  "OCCUPANCY": {
    name: "OCCUPANCY",
    value: "occupancy",
    label: "Occupancy",
    abbreviation: "OCCUPANCY",
    order: 7
  },
  "UTILIZATION": {
    name: "UTILIZATION",
    value: "utilization",
    label: "Utilization",
    abbreviation: "UTILIZATION",
    order: 8
  }
};
export var IntegrationServicesEnum = {
  values: {
    "brivo": {
      name: "BRIVO",
      value: "brivo",
      label: "Brivo",
      abbreviation: "BRIVO",
      order: 0
    },
    "openpath": {
      name: "OPENPATH",
      value: "openpath",
      label: "Avigilon Alta formerly Openpath",
      abbreviation: "OPENPATH",
      order: 1
    },
    "rippling": {
      name: "RIPPLING",
      value: "rippling",
      label: "Rippling",
      abbreviation: "RIPPLING",
      order: 2
    },
    "okta": {
      name: "OKTA",
      value: "okta",
      label: "Okta",
      abbreviation: "OKTA",
      order: 3
    },
    "google": {
      name: "GOOGLE",
      value: "google",
      label: "Google",
      abbreviation: "GOOGLE",
      order: 4
    },
    "genetec": {
      name: "GENETEC",
      value: "genetec",
      label: "Genetec",
      abbreviation: "GENETEC",
      order: 5
    },
    "jll": {
      name: "JLL",
      value: "jll",
      label: "JLL",
      abbreviation: "JLL",
      order: 6
    },
    "otp": {
      name: "OTP",
      value: "otp",
      label: "OTP",
      abbreviation: "OTP",
      order: 7
    }
  },
  "BRIVO": {
    name: "BRIVO",
    value: "brivo",
    label: "Brivo",
    abbreviation: "BRIVO",
    order: 0
  },
  "OPENPATH": {
    name: "OPENPATH",
    value: "openpath",
    label: "Avigilon Alta formerly Openpath",
    abbreviation: "OPENPATH",
    order: 1
  },
  "RIPPLING": {
    name: "RIPPLING",
    value: "rippling",
    label: "Rippling",
    abbreviation: "RIPPLING",
    order: 2
  },
  "OKTA": {
    name: "OKTA",
    value: "okta",
    label: "Okta",
    abbreviation: "OKTA",
    order: 3
  },
  "GOOGLE": {
    name: "GOOGLE",
    value: "google",
    label: "Google",
    abbreviation: "GOOGLE",
    order: 4
  },
  "GENETEC": {
    name: "GENETEC",
    value: "genetec",
    label: "Genetec",
    abbreviation: "GENETEC",
    order: 5
  },
  "JLL": {
    name: "JLL",
    value: "jll",
    label: "JLL",
    abbreviation: "JLL",
    order: 6
  },
  "OTP": {
    name: "OTP",
    value: "otp",
    label: "OTP",
    abbreviation: "OTP",
    order: 7
  }
};
export var TiAllowanceUnitTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "cost_per_sqft": {
      name: "COST_PER_SQFT",
      value: "cost_per_sqft",
      label: "/sqft",
      abbreviation: "COST_PER_SQFT",
      order: 1
    },
    "cost_per_sqm": {
      name: "COST_PER_SQM",
      value: "cost_per_sqm",
      label: "/sqm",
      abbreviation: "COST_PER_SQM",
      order: 2
    },
    "total_amount": {
      name: "TOTAL_AMOUNT",
      value: "total_amount",
      label: "Total",
      abbreviation: "TOTAL_AMOUNT",
      order: 3
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "COST_PER_SQFT": {
    name: "COST_PER_SQFT",
    value: "cost_per_sqft",
    label: "/sqft",
    abbreviation: "COST_PER_SQFT",
    order: 1
  },
  "COST_PER_SQM": {
    name: "COST_PER_SQM",
    value: "cost_per_sqm",
    label: "/sqm",
    abbreviation: "COST_PER_SQM",
    order: 2
  },
  "TOTAL_AMOUNT": {
    name: "TOTAL_AMOUNT",
    value: "total_amount",
    label: "Total",
    abbreviation: "TOTAL_AMOUNT",
    order: 3
  }
};
export var WorkplaceOSProductEnum = {
  values: {
    "workplace_analytics": {
      name: "WORKPLACE_ANALYTICS",
      value: "workplace_analytics",
      label: "Workplace Analytics",
      abbreviation: "WORKPLACE_ANALYTICS",
      order: 0
    },
    "active_searches": {
      name: "ACTIVE_SEARCHES",
      value: "active_searches",
      label: "Active Searches",
      abbreviation: "ACTIVE_SEARCHES",
      order: 1
    },
    "portfolio_management": {
      name: "PORTFOLIO_MANAGEMENT",
      value: "portfolio_management",
      label: "Portfolio Management",
      abbreviation: "PORTFOLIO_MANAGEMENT",
      order: 2
    }
  },
  "WORKPLACE_ANALYTICS": {
    name: "WORKPLACE_ANALYTICS",
    value: "workplace_analytics",
    label: "Workplace Analytics",
    abbreviation: "WORKPLACE_ANALYTICS",
    order: 0
  },
  "ACTIVE_SEARCHES": {
    name: "ACTIVE_SEARCHES",
    value: "active_searches",
    label: "Active Searches",
    abbreviation: "ACTIVE_SEARCHES",
    order: 1
  },
  "PORTFOLIO_MANAGEMENT": {
    name: "PORTFOLIO_MANAGEMENT",
    value: "portfolio_management",
    label: "Portfolio Management",
    abbreviation: "PORTFOLIO_MANAGEMENT",
    order: 2
  }
};
export var WorkplaceOSClientRoleEnum = {
  values: {
    "admin": {
      name: "ADMIN",
      value: "admin",
      label: "Admin",
      abbreviation: "ADMIN",
      order: 0
    },
    "viewer": {
      name: "VIEWER",
      value: "viewer",
      label: "Viewer",
      abbreviation: "VIEWER",
      order: 1
    },
    "super_admin": {
      name: "SUPER_ADMIN",
      value: "super_admin",
      label: "Super Admin",
      abbreviation: "SUPER_ADMIN",
      order: 2
    }
  },
  "ADMIN": {
    name: "ADMIN",
    value: "admin",
    label: "Admin",
    abbreviation: "ADMIN",
    order: 0
  },
  "VIEWER": {
    name: "VIEWER",
    value: "viewer",
    label: "Viewer",
    abbreviation: "VIEWER",
    order: 1
  },
  "SUPER_ADMIN": {
    name: "SUPER_ADMIN",
    value: "super_admin",
    label: "Super Admin",
    abbreviation: "SUPER_ADMIN",
    order: 2
  }
};
export var FeatureFlagEnum = {
  values: {
    "new_permissions": {
      name: "NEW_PERMISSIONS",
      value: "new_permissions",
      label: "New Permissions",
      abbreviation: "NEW_PERMISSIONS",
      order: 0
    },
    "settings": {
      name: "SETTINGS",
      value: "settings",
      label: "Settings",
      abbreviation: "SETTINGS",
      order: 1
    },
    "pinot": {
      name: "PINOT",
      value: "pinot",
      label: "Pinot",
      abbreviation: "PINOT",
      order: 2
    },
    "optimized_images": {
      name: "OPTIMIZED_IMAGES",
      value: "optimized_images",
      label: "Optimized Images",
      abbreviation: "OPTIMIZED_IMAGES",
      order: 3
    },
    "jll_login": {
      name: "JLL_LOGIN",
      value: "jll_login",
      label: "JLL Login",
      abbreviation: "JLL_LOGIN",
      order: 4
    },
    "jll_markets": {
      name: "JLL_MARKETS",
      value: "jll_markets",
      label: "JLL_MARKETS",
      abbreviation: "JLL_MARKETS",
      order: 5
    },
    "broker_permissions": {
      name: "BROKER_PERMISSIONS",
      value: "broker_permissions",
      label: "Broker Permissions",
      abbreviation: "BROKER_PERMISSIONS",
      order: 6
    },
    "building_listings": {
      name: "BUILDING_LISTINGS",
      value: "building_listings",
      label: "Building Listings Broker",
      abbreviation: "BUILDING_LISTINGS",
      order: 7
    },
    "building_listings_client": {
      name: "BUILDING_LISTINGS_CLIENT",
      value: "building_listings_client",
      label: "Building Listings Client",
      abbreviation: "BUILDING_LISTINGS_CLIENT",
      order: 8
    },
    "notification_services": {
      name: "NOTIFICATION_SERVICES",
      value: "notification_services",
      label: "Notification Services",
      abbreviation: "NOTIFICATION_SERVICES",
      order: 9
    },
    "notification_services_dev": {
      name: "NOTIFICATION_SERVICE_DEV",
      value: "notification_services_dev",
      label: "Notification Services Development",
      abbreviation: "NOTIFICATION_SERVICE_DEV",
      order: 10
    },
    "first_viewed_active_search_email_notification": {
      name: "FIRST_VIEWED_ACTIVE_SEARCH_EMAIL_NOTIFICATION",
      value: "first_viewed_active_search_email_notification",
      label: "First Viewed Active Search Email Notification",
      abbreviation: "FIRST_VIEWED_ACTIVE_SEARCH_EMAIL_NOTIFICATION",
      order: 11
    },
    "workplace_analytics_v2": {
      name: "WPA_V2",
      value: "workplace_analytics_v2",
      label: "Workplace Analytics Version 2.0",
      abbreviation: "WPA_V2",
      order: 12
    },
    "tourbook": {
      name: "TOURBOOK",
      value: "tourbook",
      label: "Tourbook",
      abbreviation: "TOURBOOK",
      order: 13
    },
    "tourbook_internal": {
      name: "TOURBOOK_INTERNAL",
      value: "tourbook_internal",
      label: "Tourbook Internal",
      abbreviation: "TOURBOOK_INTERNAL",
      order: 14
    }
  },
  "NEW_PERMISSIONS": {
    name: "NEW_PERMISSIONS",
    value: "new_permissions",
    label: "New Permissions",
    abbreviation: "NEW_PERMISSIONS",
    order: 0
  },
  "SETTINGS": {
    name: "SETTINGS",
    value: "settings",
    label: "Settings",
    abbreviation: "SETTINGS",
    order: 1
  },
  "PINOT": {
    name: "PINOT",
    value: "pinot",
    label: "Pinot",
    abbreviation: "PINOT",
    order: 2
  },
  "OPTIMIZED_IMAGES": {
    name: "OPTIMIZED_IMAGES",
    value: "optimized_images",
    label: "Optimized Images",
    abbreviation: "OPTIMIZED_IMAGES",
    order: 3
  },
  "JLL_LOGIN": {
    name: "JLL_LOGIN",
    value: "jll_login",
    label: "JLL Login",
    abbreviation: "JLL_LOGIN",
    order: 4
  },
  "JLL_MARKETS": {
    name: "JLL_MARKETS",
    value: "jll_markets",
    label: "JLL_MARKETS",
    abbreviation: "JLL_MARKETS",
    order: 5
  },
  "BROKER_PERMISSIONS": {
    name: "BROKER_PERMISSIONS",
    value: "broker_permissions",
    label: "Broker Permissions",
    abbreviation: "BROKER_PERMISSIONS",
    order: 6
  },
  "BUILDING_LISTINGS": {
    name: "BUILDING_LISTINGS",
    value: "building_listings",
    label: "Building Listings Broker",
    abbreviation: "BUILDING_LISTINGS",
    order: 7
  },
  "BUILDING_LISTINGS_CLIENT": {
    name: "BUILDING_LISTINGS_CLIENT",
    value: "building_listings_client",
    label: "Building Listings Client",
    abbreviation: "BUILDING_LISTINGS_CLIENT",
    order: 8
  },
  "NOTIFICATION_SERVICES": {
    name: "NOTIFICATION_SERVICES",
    value: "notification_services",
    label: "Notification Services",
    abbreviation: "NOTIFICATION_SERVICES",
    order: 9
  },
  "NOTIFICATION_SERVICE_DEV": {
    name: "NOTIFICATION_SERVICE_DEV",
    value: "notification_services_dev",
    label: "Notification Services Development",
    abbreviation: "NOTIFICATION_SERVICE_DEV",
    order: 10
  },
  "FIRST_VIEWED_ACTIVE_SEARCH_EMAIL_NOTIFICATION": {
    name: "FIRST_VIEWED_ACTIVE_SEARCH_EMAIL_NOTIFICATION",
    value: "first_viewed_active_search_email_notification",
    label: "First Viewed Active Search Email Notification",
    abbreviation: "FIRST_VIEWED_ACTIVE_SEARCH_EMAIL_NOTIFICATION",
    order: 11
  },
  "WPA_V2": {
    name: "WPA_V2",
    value: "workplace_analytics_v2",
    label: "Workplace Analytics Version 2.0",
    abbreviation: "WPA_V2",
    order: 12
  },
  "TOURBOOK": {
    name: "TOURBOOK",
    value: "tourbook",
    label: "Tourbook",
    abbreviation: "TOURBOOK",
    order: 13
  },
  "TOURBOOK_INTERNAL": {
    name: "TOURBOOK_INTERNAL",
    value: "tourbook_internal",
    label: "Tourbook Internal",
    abbreviation: "TOURBOOK_INTERNAL",
    order: 14
  }
};
export var ExpenseStatusEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "estimate": {
      name: "ESTIMATE",
      value: "estimate",
      label: "Estimate",
      abbreviation: "ESTIMATE",
      order: 1
    },
    "actual": {
      name: "ACTUAL",
      value: "actual",
      label: "Actual",
      abbreviation: "ACTUAL",
      order: 2
    },
    "reconciled": {
      name: "RECONCILED",
      value: "reconciled",
      label: "Reconciled",
      abbreviation: "RECONCILED",
      order: 3
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "ESTIMATE": {
    name: "ESTIMATE",
    value: "estimate",
    label: "Estimate",
    abbreviation: "ESTIMATE",
    order: 1
  },
  "ACTUAL": {
    name: "ACTUAL",
    value: "actual",
    label: "Actual",
    abbreviation: "ACTUAL",
    order: 2
  },
  "RECONCILED": {
    name: "RECONCILED",
    value: "reconciled",
    label: "Reconciled",
    abbreviation: "RECONCILED",
    order: 3
  }
};
export var ExpenseDescriptionEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "NNN": {
      name: "NNN",
      value: "NNN",
      label: "NNN",
      abbreviation: "NNN",
      order: 1
    },
    "electricity_and_janitorial": {
      name: "ELECTRICITY_AND_JANITORIAL",
      value: "electricity_and_janitorial",
      label: "Electricity and Janitorial",
      abbreviation: "ELECTRICITY_AND_JANITORIAL",
      order: 2
    },
    "electricity": {
      name: "ELECTRICITY",
      value: "electricity",
      label: "Electricity",
      abbreviation: "ELECTRICITY",
      order: 3
    },
    "janitorial": {
      name: "JANITORIAL",
      value: "janitorial",
      label: "Janitorial",
      abbreviation: "JANITORIAL",
      order: 4
    },
    "overages": {
      name: "OVERAGES",
      value: "overages",
      label: "Overages",
      abbreviation: "OVERAGES",
      order: 5
    },
    "tax": {
      name: "TAX",
      value: "tax",
      label: "Tax",
      abbreviation: "TAX",
      order: 6
    },
    "other": {
      name: "OTHER",
      value: "other",
      label: "Other",
      abbreviation: "OTHER",
      order: 7
    },
    "custom": {
      name: "CUSTOM",
      value: "custom",
      label: "Custom",
      abbreviation: "CUSTOM",
      order: 8
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "NNN": {
    name: "NNN",
    value: "NNN",
    label: "NNN",
    abbreviation: "NNN",
    order: 1
  },
  "ELECTRICITY_AND_JANITORIAL": {
    name: "ELECTRICITY_AND_JANITORIAL",
    value: "electricity_and_janitorial",
    label: "Electricity and Janitorial",
    abbreviation: "ELECTRICITY_AND_JANITORIAL",
    order: 2
  },
  "ELECTRICITY": {
    name: "ELECTRICITY",
    value: "electricity",
    label: "Electricity",
    abbreviation: "ELECTRICITY",
    order: 3
  },
  "JANITORIAL": {
    name: "JANITORIAL",
    value: "janitorial",
    label: "Janitorial",
    abbreviation: "JANITORIAL",
    order: 4
  },
  "OVERAGES": {
    name: "OVERAGES",
    value: "overages",
    label: "Overages",
    abbreviation: "OVERAGES",
    order: 5
  },
  "TAX": {
    name: "TAX",
    value: "tax",
    label: "Tax",
    abbreviation: "TAX",
    order: 6
  },
  "OTHER": {
    name: "OTHER",
    value: "other",
    label: "Other",
    abbreviation: "OTHER",
    order: 7
  },
  "CUSTOM": {
    name: "CUSTOM",
    value: "custom",
    label: "Custom",
    abbreviation: "CUSTOM",
    order: 8
  }
};
export var ExpenseUnitTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "sqft_yr": {
      name: "SQFT_YR",
      value: "sqft_yr",
      label: "sf/yr",
      abbreviation: "SQFT_YR",
      order: 1
    },
    "sqft_mo": {
      name: "SQFT_MO",
      value: "sqft_mo",
      label: "sf/mo",
      abbreviation: "SQFT_MO",
      order: 2
    },
    "yearly": {
      name: "YEARLY",
      value: "yearly",
      label: "yr",
      abbreviation: "YEARLY",
      order: 3
    },
    "monthly": {
      name: "MONTHLY",
      value: "monthly",
      label: "mo",
      abbreviation: "MONTHLY",
      order: 4
    },
    "quarterly": {
      name: "QUARTERLY",
      value: "quarterly",
      label: "quarter",
      abbreviation: "QUARTERLY",
      order: 5
    },
    "percent_base_rent": {
      name: "PERCENT_BASE_RENT",
      value: "percent_base_rent",
      label: "Percent of Base Rent",
      abbreviation: "PERCENT_BASE_RENT",
      order: 6
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "SQFT_YR": {
    name: "SQFT_YR",
    value: "sqft_yr",
    label: "sf/yr",
    abbreviation: "SQFT_YR",
    order: 1
  },
  "SQFT_MO": {
    name: "SQFT_MO",
    value: "sqft_mo",
    label: "sf/mo",
    abbreviation: "SQFT_MO",
    order: 2
  },
  "YEARLY": {
    name: "YEARLY",
    value: "yearly",
    label: "yr",
    abbreviation: "YEARLY",
    order: 3
  },
  "MONTHLY": {
    name: "MONTHLY",
    value: "monthly",
    label: "mo",
    abbreviation: "MONTHLY",
    order: 4
  },
  "QUARTERLY": {
    name: "QUARTERLY",
    value: "quarterly",
    label: "quarter",
    abbreviation: "QUARTERLY",
    order: 5
  },
  "PERCENT_BASE_RENT": {
    name: "PERCENT_BASE_RENT",
    value: "percent_base_rent",
    label: "Percent of Base Rent",
    abbreviation: "PERCENT_BASE_RENT",
    order: 6
  }
};
export var IntegrationCategoriesEnum = {
  values: {
    "sso": {
      name: "SSO",
      value: "sso",
      label: "Single Sign-On (SSO)",
      abbreviation: "SSO",
      order: 0
    },
    "hris": {
      name: "HRIS",
      value: "hris",
      label: "Directory/HRIS",
      abbreviation: "HRIS",
      order: 1
    },
    "badge": {
      name: "BADGE",
      value: "badge",
      label: "Access Control",
      abbreviation: "BADGE",
      order: 2
    }
  },
  "SSO": {
    name: "SSO",
    value: "sso",
    label: "Single Sign-On (SSO)",
    abbreviation: "SSO",
    order: 0
  },
  "HRIS": {
    name: "HRIS",
    value: "hris",
    label: "Directory/HRIS",
    abbreviation: "HRIS",
    order: 1
  },
  "BADGE": {
    name: "BADGE",
    value: "badge",
    label: "Access Control",
    abbreviation: "BADGE",
    order: 2
  }
};
export var SupportedMergeIntegrationEnum = {
  values: {
    "okta": {
      name: "OKTA",
      value: "okta",
      label: "Okta",
      abbreviation: "OKTA",
      order: 0
    }
  },
  "OKTA": {
    name: "OKTA",
    value: "okta",
    label: "Okta",
    abbreviation: "OKTA",
    order: 0
  }
};
export var RentTypeEnum = {
  values: {
    "": {
      name: "BLANK",
      value: "",
      label: "",
      abbreviation: "",
      order: 0
    },
    "base_rent": {
      name: "BASE_RENT",
      value: "base_rent",
      label: "Base Rent",
      abbreviation: "BASE_RENT",
      order: 1
    },
    "free_rent": {
      name: "FREE_RENT",
      value: "free_rent",
      label: "Free Rent",
      abbreviation: "FREE_RENT",
      order: 2
    },
    "discounted": {
      name: "DISCOUNTED",
      value: "discounted",
      label: "Discounted Rent",
      abbreviation: "DISCOUNTED",
      order: 3
    }
  },
  "BLANK": {
    name: "BLANK",
    value: "",
    label: "",
    abbreviation: "",
    order: 0
  },
  "BASE_RENT": {
    name: "BASE_RENT",
    value: "base_rent",
    label: "Base Rent",
    abbreviation: "BASE_RENT",
    order: 1
  },
  "FREE_RENT": {
    name: "FREE_RENT",
    value: "free_rent",
    label: "Free Rent",
    abbreviation: "FREE_RENT",
    order: 2
  },
  "DISCOUNTED": {
    name: "DISCOUNTED",
    value: "discounted",
    label: "Discounted Rent",
    abbreviation: "DISCOUNTED",
    order: 3
  }
};
export var OptimizedImageViewEnum = {
  values: {
    "detail": {
      name: "DETAIL",
      value: "detail",
      label: "Detail",
      abbreviation: "DETAIL",
      order: 0
    },
    "thumbnail": {
      name: "THUMBNAIL",
      value: "thumbnail",
      label: "Thumbnail",
      abbreviation: "THUMBNAIL",
      order: 1
    },
    "carousel": {
      name: "CAROUSEL",
      value: "carousel",
      label: "Carousel",
      abbreviation: "CAROUSEL",
      order: 2
    },
    "gallery": {
      name: "GALLERY",
      value: "gallery",
      label: "Gallery",
      abbreviation: "GALLERY",
      order: 3
    }
  },
  "DETAIL": {
    name: "DETAIL",
    value: "detail",
    label: "Detail",
    abbreviation: "DETAIL",
    order: 0
  },
  "THUMBNAIL": {
    name: "THUMBNAIL",
    value: "thumbnail",
    label: "Thumbnail",
    abbreviation: "THUMBNAIL",
    order: 1
  },
  "CAROUSEL": {
    name: "CAROUSEL",
    value: "carousel",
    label: "Carousel",
    abbreviation: "CAROUSEL",
    order: 2
  },
  "GALLERY": {
    name: "GALLERY",
    value: "gallery",
    label: "Gallery",
    abbreviation: "GALLERY",
    order: 3
  }
};
export var NotificationEventTypeEnum = {
  values: {
    "tour_requested": {
      name: "TOUR_REQUESTED",
      value: "tour_requested",
      label: "Tours requested",
      abbreviation: "TOUR_REQUESTED",
      order: 0
    },
    "liked_disliked": {
      name: "LIKED_DISLIKED",
      value: "liked_disliked",
      label: "Likes and dislikes",
      abbreviation: "LIKED_DISLIKED",
      order: 1
    },
    "liked": {
      name: "LIKED",
      value: "liked",
      label: "Liked",
      abbreviation: "LIKED",
      order: 2
    },
    "disliked": {
      name: "DISLIKED",
      value: "disliked",
      label: "Disliked",
      abbreviation: "DISLIKED",
      order: 3
    },
    "comment": {
      name: "COMMENT",
      value: "comment",
      label: "Comments",
      abbreviation: "COMMENT",
      order: 4
    },
    "critical_dates": {
      name: "CRITICAL_DATES",
      value: "critical_dates",
      label: "Critical dates",
      abbreviation: "CRITICAL_DATES",
      order: 5
    },
    "first_viewed_active_search": {
      name: "FIRST_VIEWED_ACTIVE_SEARCH",
      value: "first_viewed_active_search",
      label: "New client login",
      abbreviation: "FIRST_VIEWED_ACTIVE_SEARCH",
      order: 6
    },
    "new_transaction_note": {
      name: "NEW_TRANSACTION_NOTE",
      value: "new_transaction_note",
      label: "Transaction notes",
      abbreviation: "NEW_TRANSACTION_NOTE",
      order: 7
    },
    "uploaded_document": {
      name: "UPLOADED_DOCUMENT",
      value: "uploaded_document",
      label: "Uploaded document",
      abbreviation: "UPLOADED_DOCUMENT",
      order: 8
    },
    "weekly_digest": {
      name: "WEEKLY_DIGEST",
      value: "weekly_digest",
      label: "Weekly digest",
      abbreviation: "WEEKLY_DIGEST",
      order: 9
    },
    "added_to_transaction": {
      name: "ADDED_TO_TRANSACTION",
      value: "added_to_transaction",
      label: "Added to transaction",
      abbreviation: "ADDED_TO_TRANSACTION",
      order: 10
    },
    "lease_summary_ready": {
      name: "LEASE_SUMMARY_READY",
      value: "lease_summary_ready",
      label: "Lease summary ready",
      abbreviation: "LEASE_SUMMARY_READY",
      order: 11
    }
  },
  "TOUR_REQUESTED": {
    name: "TOUR_REQUESTED",
    value: "tour_requested",
    label: "Tours requested",
    abbreviation: "TOUR_REQUESTED",
    order: 0
  },
  "LIKED_DISLIKED": {
    name: "LIKED_DISLIKED",
    value: "liked_disliked",
    label: "Likes and dislikes",
    abbreviation: "LIKED_DISLIKED",
    order: 1
  },
  "LIKED": {
    name: "LIKED",
    value: "liked",
    label: "Liked",
    abbreviation: "LIKED",
    order: 2
  },
  "DISLIKED": {
    name: "DISLIKED",
    value: "disliked",
    label: "Disliked",
    abbreviation: "DISLIKED",
    order: 3
  },
  "COMMENT": {
    name: "COMMENT",
    value: "comment",
    label: "Comments",
    abbreviation: "COMMENT",
    order: 4
  },
  "CRITICAL_DATES": {
    name: "CRITICAL_DATES",
    value: "critical_dates",
    label: "Critical dates",
    abbreviation: "CRITICAL_DATES",
    order: 5
  },
  "FIRST_VIEWED_ACTIVE_SEARCH": {
    name: "FIRST_VIEWED_ACTIVE_SEARCH",
    value: "first_viewed_active_search",
    label: "New client login",
    abbreviation: "FIRST_VIEWED_ACTIVE_SEARCH",
    order: 6
  },
  "NEW_TRANSACTION_NOTE": {
    name: "NEW_TRANSACTION_NOTE",
    value: "new_transaction_note",
    label: "Transaction notes",
    abbreviation: "NEW_TRANSACTION_NOTE",
    order: 7
  },
  "UPLOADED_DOCUMENT": {
    name: "UPLOADED_DOCUMENT",
    value: "uploaded_document",
    label: "Uploaded document",
    abbreviation: "UPLOADED_DOCUMENT",
    order: 8
  },
  "WEEKLY_DIGEST": {
    name: "WEEKLY_DIGEST",
    value: "weekly_digest",
    label: "Weekly digest",
    abbreviation: "WEEKLY_DIGEST",
    order: 9
  },
  "ADDED_TO_TRANSACTION": {
    name: "ADDED_TO_TRANSACTION",
    value: "added_to_transaction",
    label: "Added to transaction",
    abbreviation: "ADDED_TO_TRANSACTION",
    order: 10
  },
  "LEASE_SUMMARY_READY": {
    name: "LEASE_SUMMARY_READY",
    value: "lease_summary_ready",
    label: "Lease summary ready",
    abbreviation: "LEASE_SUMMARY_READY",
    order: 11
  }
};
export var NotificationChannelEnum = {
  values: {
    "email": {
      name: "EMAIL",
      value: "email",
      label: "Email",
      abbreviation: "EMAIL",
      order: 0
    },
    "mobile_push": {
      name: "MOBILE_PUSH",
      value: "mobile_push",
      label: "Mobile Push",
      abbreviation: "MOBILE_PUSH",
      order: 1
    }
  },
  "EMAIL": {
    name: "EMAIL",
    value: "email",
    label: "Email",
    abbreviation: "EMAIL",
    order: 0
  },
  "MOBILE_PUSH": {
    name: "MOBILE_PUSH",
    value: "mobile_push",
    label: "Mobile Push",
    abbreviation: "MOBILE_PUSH",
    order: 1
  }
};
export var NotificationProductEnum = {
  values: {
    "active_search": {
      name: "ACTIVE_SEARCH",
      value: "active_search",
      label: "Transactions",
      abbreviation: "ACTIVE_SEARCH",
      order: 0
    },
    "portfolio_management": {
      name: "PORTFOLIO_MANAGEMENT",
      value: "portfolio_management",
      label: "Portfolio Management",
      abbreviation: "PORTFOLIO_MANAGEMENT",
      order: 1
    },
    "workplace_analytics": {
      name: "WORKPLACE_ANALYTICS",
      value: "workplace_analytics",
      label: "Workplace Analytics",
      abbreviation: "WORKPLACE_ANALYTICS",
      order: 2
    }
  },
  "ACTIVE_SEARCH": {
    name: "ACTIVE_SEARCH",
    value: "active_search",
    label: "Transactions",
    abbreviation: "ACTIVE_SEARCH",
    order: 0
  },
  "PORTFOLIO_MANAGEMENT": {
    name: "PORTFOLIO_MANAGEMENT",
    value: "portfolio_management",
    label: "Portfolio Management",
    abbreviation: "PORTFOLIO_MANAGEMENT",
    order: 1
  },
  "WORKPLACE_ANALYTICS": {
    name: "WORKPLACE_ANALYTICS",
    value: "workplace_analytics",
    label: "Workplace Analytics",
    abbreviation: "WORKPLACE_ANALYTICS",
    order: 2
  }
};
export var IntegrationLoginViews = {
  values: {
    "check_email": {
      name: "CHECK_EMAIL",
      value: "check_email",
      label: "check_email",
      abbreviation: "CHECK_EMAIL",
      order: 0
    },
    "alternate_login": {
      name: "ALTERNATE_LOGIN",
      value: "alternate_login",
      label: "alternate_login",
      abbreviation: "ALTERNATE_LOGIN",
      order: 1
    },
    "basic_login": {
      name: "BASIC_LOGIN",
      value: "basic_login",
      label: "basic_login",
      abbreviation: "BASIC_LOGIN",
      order: 2
    },
    "otp_with_password": {
      name: "OTP_WITH_PASSWORD",
      value: "otp_with_password",
      label: "otp_with_password",
      abbreviation: "OTP_WITH_PASSWORD",
      order: 3
    },
    "otp_without_password": {
      name: "OTP_WITHOUT_PASSWORD",
      value: "otp_without_password",
      label: "otp_without_password",
      abbreviation: "OTP_WITHOUT_PASSWORD",
      order: 4
    }
  },
  "CHECK_EMAIL": {
    name: "CHECK_EMAIL",
    value: "check_email",
    label: "check_email",
    abbreviation: "CHECK_EMAIL",
    order: 0
  },
  "ALTERNATE_LOGIN": {
    name: "ALTERNATE_LOGIN",
    value: "alternate_login",
    label: "alternate_login",
    abbreviation: "ALTERNATE_LOGIN",
    order: 1
  },
  "BASIC_LOGIN": {
    name: "BASIC_LOGIN",
    value: "basic_login",
    label: "basic_login",
    abbreviation: "BASIC_LOGIN",
    order: 2
  },
  "OTP_WITH_PASSWORD": {
    name: "OTP_WITH_PASSWORD",
    value: "otp_with_password",
    label: "otp_with_password",
    abbreviation: "OTP_WITH_PASSWORD",
    order: 3
  },
  "OTP_WITHOUT_PASSWORD": {
    name: "OTP_WITHOUT_PASSWORD",
    value: "otp_without_password",
    label: "otp_without_password",
    abbreviation: "OTP_WITHOUT_PASSWORD",
    order: 4
  }
};
export var OTPErrorCodeEnum = {
  values: {
    "invalid_email": {
      name: "INVALID_EMAIL",
      value: "invalid_email",
      label: "Enter a valid email address",
      abbreviation: "INVALID_EMAIL",
      order: 0
    },
    "invalid_request_data": {
      name: "INVALID_REQUEST_DATA",
      value: "invalid_request_data",
      label: "Invalid request data.",
      abbreviation: "INVALID_REQUEST_DATA",
      order: 1
    },
    "invalid_request_method": {
      name: "INVALID_REQUEST_METHOD",
      value: "invalid_request_method",
      label: "Invalid request method.",
      abbreviation: "INVALID_REQUEST_METHOD",
      order: 2
    },
    "rate_limit_exceeded": {
      name: "RATE_LIMIT_EXCEEDED",
      value: "rate_limit_exceeded",
      label: "You've exceeded the number of requests. For security purposes, please try again in 1 hour.",
      abbreviation: "RATE_LIMIT_EXCEEDED",
      order: 3
    },
    "user_authentication_failed": {
      name: "USER_AUTHENTICATION_FAILED",
      value: "user_authentication_failed",
      label: "Unable to login, please check email",
      abbreviation: "USER_AUTHENTICATION_FAILED",
      order: 4
    },
    "no_otp_found": {
      name: "NO_OTP_FOUND",
      value: "no_otp_found",
      label: "No OTP code found. Please request a new code.",
      abbreviation: "NO_OTP_FOUND",
      order: 5
    },
    "otp_already_used": {
      name: "OTP_ALREADY_USED",
      value: "otp_already_used",
      label: "This OTP code has already been used. Please request a new code.",
      abbreviation: "OTP_ALREADY_USED",
      order: 6
    },
    "otp_expired": {
      name: "OTP_EXPIRED",
      value: "otp_expired",
      label: "OTP code has expired. Please request a new code.",
      abbreviation: "OTP_EXPIRED",
      order: 7
    },
    "max_attempts_exceeded": {
      name: "MAX_ATTEMPTS_EXCEEDED",
      value: "max_attempts_exceeded",
      label: "Maximum verification attempts exceeded. Please request a new code.",
      abbreviation: "MAX_ATTEMPTS_EXCEEDED",
      order: 8
    },
    "invalid_otp_code": {
      name: "INVALID_OTP_CODE",
      value: "invalid_otp_code",
      label: "Invalid OTP code. Please check the code and try again, or request a new one.",
      abbreviation: "INVALID_OTP_CODE",
      order: 9
    },
    "general_error": {
      name: "GENERAL_ERROR",
      value: "general_error",
      label: "An error occurred. Please try again later.",
      abbreviation: "GENERAL_ERROR",
      order: 10
    }
  },
  "INVALID_EMAIL": {
    name: "INVALID_EMAIL",
    value: "invalid_email",
    label: "Enter a valid email address",
    abbreviation: "INVALID_EMAIL",
    order: 0
  },
  "INVALID_REQUEST_DATA": {
    name: "INVALID_REQUEST_DATA",
    value: "invalid_request_data",
    label: "Invalid request data.",
    abbreviation: "INVALID_REQUEST_DATA",
    order: 1
  },
  "INVALID_REQUEST_METHOD": {
    name: "INVALID_REQUEST_METHOD",
    value: "invalid_request_method",
    label: "Invalid request method.",
    abbreviation: "INVALID_REQUEST_METHOD",
    order: 2
  },
  "RATE_LIMIT_EXCEEDED": {
    name: "RATE_LIMIT_EXCEEDED",
    value: "rate_limit_exceeded",
    label: "You've exceeded the number of requests. For security purposes, please try again in 1 hour.",
    abbreviation: "RATE_LIMIT_EXCEEDED",
    order: 3
  },
  "USER_AUTHENTICATION_FAILED": {
    name: "USER_AUTHENTICATION_FAILED",
    value: "user_authentication_failed",
    label: "Unable to login, please check email",
    abbreviation: "USER_AUTHENTICATION_FAILED",
    order: 4
  },
  "NO_OTP_FOUND": {
    name: "NO_OTP_FOUND",
    value: "no_otp_found",
    label: "No OTP code found. Please request a new code.",
    abbreviation: "NO_OTP_FOUND",
    order: 5
  },
  "OTP_ALREADY_USED": {
    name: "OTP_ALREADY_USED",
    value: "otp_already_used",
    label: "This OTP code has already been used. Please request a new code.",
    abbreviation: "OTP_ALREADY_USED",
    order: 6
  },
  "OTP_EXPIRED": {
    name: "OTP_EXPIRED",
    value: "otp_expired",
    label: "OTP code has expired. Please request a new code.",
    abbreviation: "OTP_EXPIRED",
    order: 7
  },
  "MAX_ATTEMPTS_EXCEEDED": {
    name: "MAX_ATTEMPTS_EXCEEDED",
    value: "max_attempts_exceeded",
    label: "Maximum verification attempts exceeded. Please request a new code.",
    abbreviation: "MAX_ATTEMPTS_EXCEEDED",
    order: 8
  },
  "INVALID_OTP_CODE": {
    name: "INVALID_OTP_CODE",
    value: "invalid_otp_code",
    label: "Invalid OTP code. Please check the code and try again, or request a new one.",
    abbreviation: "INVALID_OTP_CODE",
    order: 9
  },
  "GENERAL_ERROR": {
    name: "GENERAL_ERROR",
    value: "general_error",
    label: "An error occurred. Please try again later.",
    abbreviation: "GENERAL_ERROR",
    order: 10
  }
};
export var StaticSortableBuildingColumnsEnum = {
  values: {
    "building_address": {
      name: "BUILDING_ADDRESS",
      value: "building_address",
      label: "Address",
      abbreviation: "BUILDING_ADDRESS",
      order: 0,
      link: "buildingAddress"
    },
    "size": {
      name: "SIZE",
      value: "size",
      label: "Size",
      abbreviation: "SIZE",
      order: 1
    },
    "rate": {
      name: "RATE",
      value: "rate",
      label: "Rate",
      abbreviation: "RATE",
      order: 2
    },
    "desk_no": {
      name: "DESK_NO",
      value: "desk_no",
      label: "Desk no.",
      abbreviation: "DESK_NO",
      order: 3
    },
    "building_class": {
      name: "BUILDING_CLASS",
      value: "building_class",
      label: "Building Class",
      abbreviation: "BUILDING_CLASS",
      order: 4,
      link: "buildingClass"
    },
    "city_zip": {
      name: "CITY_ZIP",
      value: "city_zip",
      label: "City/Zip",
      abbreviation: "CITY_ZIP",
      order: 5,
      link: "cityZip"
    },
    "avg_floor_size": {
      name: "AVG_FLOOR_SIZE",
      value: "avg_floor_size",
      label: "Floor Size",
      abbreviation: "AVG_FLOOR_SIZE",
      order: 6,
      link: "avgFloorSize"
    },
    "num_floors": {
      name: "NUM_FLOORS",
      value: "num_floors",
      label: "Floors",
      abbreviation: "NUM_FLOORS",
      order: 7,
      link: "numFloors"
    },
    "freight_elevator": {
      name: "FREIGHT_ELEVATOR",
      value: "freight_elevator",
      label: "Has Freight Elevator",
      abbreviation: "FREIGHT_ELEVATOR",
      order: 8,
      link: "freightElevator"
    },
    "landlord__name": {
      name: "LANDLORD_NAME",
      value: "landlord__name",
      label: "Landlord Name",
      abbreviation: "LANDLORD_NAME",
      order: 9,
      link: "landlordName"
    },
    "loading_zone": {
      name: "LOADING_ZONE",
      value: "loading_zone",
      label: "Loading Zone",
      abbreviation: "LOADING_ZONE",
      order: 10,
      link: "loadingZone"
    },
    "parking_available": {
      name: "PARKING_AVAILABLE",
      value: "parking_available",
      label: "Onsite Parking",
      abbreviation: "PARKING_AVAILABLE",
      order: 11,
      link: "parkingAvailable"
    },
    "construction_status": {
      name: "CONSTRUCTION_STATUS",
      value: "construction_status",
      label: "Status",
      abbreviation: "CONSTRUCTION_STATUS",
      order: 12,
      link: "constructionStatus"
    },
    "submarket": {
      name: "SUB_MARKET",
      value: "submarket",
      label: "Submarket",
      abbreviation: "SUB_MARKET",
      order: 13,
      link: "submarket"
    },
    "total_sqft": {
      name: "TOTAL_SQFT",
      value: "total_sqft",
      label: "Total Sf",
      abbreviation: "TOTAL_SQFT",
      order: 14,
      link: "totalSqft"
    },
    "year_built": {
      name: "YEAR_BUILT",
      value: "year_built",
      label: "Year Built",
      abbreviation: "YEAR_BUILT",
      order: 15,
      link: "yearBuilt"
    },
    "year_rennovated": {
      name: "YEAR_RENNOVATED",
      value: "year_rennovated",
      label: "Year Renovated",
      abbreviation: "YEAR_RENNOVATED",
      order: 16,
      link: "yearRennovated"
    },
    "zoning": {
      name: "ZONING",
      value: "zoning",
      label: "Zoning",
      abbreviation: "ZONING",
      order: 17,
      link: "zoning"
    }
  },
  "BUILDING_ADDRESS": {
    name: "BUILDING_ADDRESS",
    value: "building_address",
    label: "Address",
    abbreviation: "BUILDING_ADDRESS",
    order: 0,
    link: "buildingAddress"
  },
  "SIZE": {
    name: "SIZE",
    value: "size",
    label: "Size",
    abbreviation: "SIZE",
    order: 1
  },
  "RATE": {
    name: "RATE",
    value: "rate",
    label: "Rate",
    abbreviation: "RATE",
    order: 2
  },
  "DESK_NO": {
    name: "DESK_NO",
    value: "desk_no",
    label: "Desk no.",
    abbreviation: "DESK_NO",
    order: 3
  },
  "BUILDING_CLASS": {
    name: "BUILDING_CLASS",
    value: "building_class",
    label: "Building Class",
    abbreviation: "BUILDING_CLASS",
    order: 4,
    link: "buildingClass"
  },
  "CITY_ZIP": {
    name: "CITY_ZIP",
    value: "city_zip",
    label: "City/Zip",
    abbreviation: "CITY_ZIP",
    order: 5,
    link: "cityZip"
  },
  "AVG_FLOOR_SIZE": {
    name: "AVG_FLOOR_SIZE",
    value: "avg_floor_size",
    label: "Floor Size",
    abbreviation: "AVG_FLOOR_SIZE",
    order: 6,
    link: "avgFloorSize"
  },
  "NUM_FLOORS": {
    name: "NUM_FLOORS",
    value: "num_floors",
    label: "Floors",
    abbreviation: "NUM_FLOORS",
    order: 7,
    link: "numFloors"
  },
  "FREIGHT_ELEVATOR": {
    name: "FREIGHT_ELEVATOR",
    value: "freight_elevator",
    label: "Has Freight Elevator",
    abbreviation: "FREIGHT_ELEVATOR",
    order: 8,
    link: "freightElevator"
  },
  "LANDLORD_NAME": {
    name: "LANDLORD_NAME",
    value: "landlord__name",
    label: "Landlord Name",
    abbreviation: "LANDLORD_NAME",
    order: 9,
    link: "landlordName"
  },
  "LOADING_ZONE": {
    name: "LOADING_ZONE",
    value: "loading_zone",
    label: "Loading Zone",
    abbreviation: "LOADING_ZONE",
    order: 10,
    link: "loadingZone"
  },
  "PARKING_AVAILABLE": {
    name: "PARKING_AVAILABLE",
    value: "parking_available",
    label: "Onsite Parking",
    abbreviation: "PARKING_AVAILABLE",
    order: 11,
    link: "parkingAvailable"
  },
  "CONSTRUCTION_STATUS": {
    name: "CONSTRUCTION_STATUS",
    value: "construction_status",
    label: "Status",
    abbreviation: "CONSTRUCTION_STATUS",
    order: 12,
    link: "constructionStatus"
  },
  "SUB_MARKET": {
    name: "SUB_MARKET",
    value: "submarket",
    label: "Submarket",
    abbreviation: "SUB_MARKET",
    order: 13,
    link: "submarket"
  },
  "TOTAL_SQFT": {
    name: "TOTAL_SQFT",
    value: "total_sqft",
    label: "Total Sf",
    abbreviation: "TOTAL_SQFT",
    order: 14,
    link: "totalSqft"
  },
  "YEAR_BUILT": {
    name: "YEAR_BUILT",
    value: "year_built",
    label: "Year Built",
    abbreviation: "YEAR_BUILT",
    order: 15,
    link: "yearBuilt"
  },
  "YEAR_RENNOVATED": {
    name: "YEAR_RENNOVATED",
    value: "year_rennovated",
    label: "Year Renovated",
    abbreviation: "YEAR_RENNOVATED",
    order: 16,
    link: "yearRennovated"
  },
  "ZONING": {
    name: "ZONING",
    value: "zoning",
    label: "Zoning",
    abbreviation: "ZONING",
    order: 17,
    link: "zoning"
  }
};
export var StaticSortableListingColumnsEnum = {
  values: {
    "display_address_with_floor": {
      name: "DISPLAY_ADDRESS_WITH_FLOOR",
      value: "display_address_with_floor",
      label: "Building Address",
      abbreviation: "DISPLAY_ADDRESS_WITH_FLOOR",
      order: 0,
      link: "displayAddressWithFloor"
    },
    "building_name": {
      name: "BUILDING_NAME",
      value: "building_name",
      label: "Building Name",
      abbreviation: "BUILDING_NAME",
      order: 1
    },
    "added_to_dealroom_date": {
      name: "ADDED_TO_DEALROOM_DATE",
      value: "added_to_dealroom_date",
      label: "Date Added",
      abbreviation: "ADDED_TO_DEALROOM_DATE",
      order: 2,
      link: "addedToDealroomDate"
    },
    "files": {
      name: "FILES",
      value: "files",
      label: "Files",
      abbreviation: "FILES",
      order: 3
    },
    "sqft": {
      name: "SQFT",
      value: "sqft",
      label: "Size",
      abbreviation: "SQFT",
      order: 4,
      link: "sqft"
    },
    "all_inclusive_rent": {
      name: "ALL_INCLUSIVE_RENT",
      value: "all_inclusive_rent",
      label: "Total Rent",
      abbreviation: "ALL_INCLUSIVE_RENT",
      order: 5,
      link: "allInclusiveRent"
    },
    "term_display": {
      name: "TERM_DISPLAY",
      value: "term_display",
      label: "Term",
      abbreviation: "TERM_DISPLAY",
      order: 6,
      link: "termDisplay"
    },
    "occupancy_date": {
      name: "OCCUPANCY_DATE",
      value: "occupancy_date",
      label: "Available",
      abbreviation: "OCCUPANCY_DATE",
      order: 7,
      link: "occupancyDisplay"
    },
    "lease_type": {
      name: "LEASE_TYPE",
      value: "lease_type",
      label: "Lease Type",
      abbreviation: "LEASE_TYPE",
      order: 8,
      link: "leaseType"
    },
    "listing_state": {
      name: "LISTING_STATE",
      value: "listing_state",
      label: "Status",
      abbreviation: "LISTING_STATE",
      order: 9,
      link: "listingState"
    },
    "number_of_callrooms": {
      name: "NUMBER_OF_CALLROOMS",
      value: "number_of_callrooms",
      label: "Callrooms",
      abbreviation: "NUMBER_OF_CALLROOMS",
      order: 10,
      link: "numberOfCallrooms"
    },
    "number_of_conference_rooms": {
      name: "NUMBER_OF_CONFERENCE_ROOMS",
      value: "number_of_conference_rooms",
      label: "Conference Rooms",
      abbreviation: "NUMBER_OF_CONFERENCE_ROOMS",
      order: 11,
      link: "numberOfConferenceRooms"
    },
    "desk_monthly_rate": {
      name: "DESK_MONTHLY_RATE",
      value: "desk_monthly_rate",
      label: "Cost/Month",
      abbreviation: "DESK_MONTHLY_RATE",
      order: 12,
      link: "deskMonthlyRate"
    },
    "oldest_ml_created_date": {
      name: "CREATED_DATE",
      value: "oldest_ml_created_date",
      label: "Created Date",
      abbreviation: "CREATED_DATE",
      order: 13,
      link: "oldestMlCreatedDate"
    },
    "date_available": {
      name: "DATE_AVAILABLE",
      value: "date_available",
      label: "Date On Market",
      abbreviation: "DATE_AVAILABLE",
      order: 14,
      link: "dateAvailable"
    },
    "asking_rate": {
      name: "ASKING_RATE",
      value: "asking_rate",
      label: "Base Rent",
      abbreviation: "ASKING_RATE",
      order: 15,
      link: "askingRate"
    },
    "expense_type": {
      name: "EXPENSE_TYPE",
      value: "expense_type",
      label: "Expense Type",
      abbreviation: "EXPENSE_TYPE",
      order: 16,
      link: "expenseType"
    },
    "expenses": {
      name: "EXPENSES",
      value: "expenses",
      label: "Expenses",
      abbreviation: "EXPENSES",
      order: 17,
      link: "expenses"
    },
    "floor_type": {
      name: "FLOOR_TYPE",
      value: "floor_type",
      label: "Floor Type",
      abbreviation: "FLOOR_TYPE",
      order: 18,
      link: "floorTypeDisplay"
    },
    "it_room": {
      name: "IT_ROOM",
      value: "it_room",
      label: "IT Room",
      abbreviation: "IT_ROOM",
      order: 19,
      link: "itRoom"
    },
    "kitchen": {
      name: "KITCHEN",
      value: "kitchen",
      label: "Kitchen",
      abbreviation: "KITCHEN",
      order: 20,
      link: "kitchen"
    },
    "lease_end": {
      name: "LEASE_END",
      value: "lease_end",
      label: "Lease End",
      abbreviation: "LEASE_END",
      order: 21,
      link: "leaseEnd"
    },
    "monthly_rent": {
      name: "MONTHLY_RENT",
      value: "monthly_rent",
      label: "Monthly Rent",
      abbreviation: "MONTHLY_RENT",
      order: 22,
      link: "monthlyRent"
    },
    "number_of_offices": {
      name: "NUMBER_OF_OFFICES",
      value: "number_of_offices",
      label: "Offices",
      abbreviation: "NUMBER_OF_OFFICES",
      order: 23,
      link: "numberOfOffices"
    },
    "outdoor_deck": {
      name: "OUTDOOR_DECK",
      value: "outdoor_deck",
      label: "Outdoor Deck",
      abbreviation: "OUTDOOR_DECK",
      order: 24,
      link: "outdoorDeck"
    },
    "reception": {
      name: "RECEPTION",
      value: "reception",
      label: "Reception",
      abbreviation: "RECEPTION",
      order: 25,
      link: "reception"
    },
    "storage_room": {
      name: "STORAGE_ROOM",
      value: "storage_room",
      label: "Storage Room",
      abbreviation: "STORAGE_ROOM",
      order: 26,
      link: "storageRoom"
    },
    "display_rate_type": {
      name: "DISPLAY_RATE_TYPE",
      value: "display_rate_type",
      label: "Units",
      abbreviation: "DISPLAY_RATE_TYPE",
      order: 27,
      link: "displayRateType"
    },
    "number_work_stations": {
      name: "NUMBER_WORK_STATIONS",
      value: "number_work_stations",
      label: "Work stations",
      abbreviation: "NUMBER_WORK_STATIONS",
      order: 28,
      link: "numberWorkStations"
    },
    "yearly_rent": {
      name: "YEARLY_RENT",
      value: "yearly_rent",
      label: "Yearly Rent",
      abbreviation: "YEARLY_RENT",
      order: 29,
      link: "yearlyRent"
    },
    "desk_count_display": {
      name: "DESK_COUNT_DISPLAY",
      value: "desk_count_display",
      label: "Desk No.",
      abbreviation: "DESK_COUNT_DISPLAY",
      order: 30,
      link: "deskCountDisplay"
    }
  },
  "DISPLAY_ADDRESS_WITH_FLOOR": {
    name: "DISPLAY_ADDRESS_WITH_FLOOR",
    value: "display_address_with_floor",
    label: "Building Address",
    abbreviation: "DISPLAY_ADDRESS_WITH_FLOOR",
    order: 0,
    link: "displayAddressWithFloor"
  },
  "BUILDING_NAME": {
    name: "BUILDING_NAME",
    value: "building_name",
    label: "Building Name",
    abbreviation: "BUILDING_NAME",
    order: 1
  },
  "ADDED_TO_DEALROOM_DATE": {
    name: "ADDED_TO_DEALROOM_DATE",
    value: "added_to_dealroom_date",
    label: "Date Added",
    abbreviation: "ADDED_TO_DEALROOM_DATE",
    order: 2,
    link: "addedToDealroomDate"
  },
  "FILES": {
    name: "FILES",
    value: "files",
    label: "Files",
    abbreviation: "FILES",
    order: 3
  },
  "SQFT": {
    name: "SQFT",
    value: "sqft",
    label: "Size",
    abbreviation: "SQFT",
    order: 4,
    link: "sqft"
  },
  "ALL_INCLUSIVE_RENT": {
    name: "ALL_INCLUSIVE_RENT",
    value: "all_inclusive_rent",
    label: "Total Rent",
    abbreviation: "ALL_INCLUSIVE_RENT",
    order: 5,
    link: "allInclusiveRent"
  },
  "TERM_DISPLAY": {
    name: "TERM_DISPLAY",
    value: "term_display",
    label: "Term",
    abbreviation: "TERM_DISPLAY",
    order: 6,
    link: "termDisplay"
  },
  "OCCUPANCY_DATE": {
    name: "OCCUPANCY_DATE",
    value: "occupancy_date",
    label: "Available",
    abbreviation: "OCCUPANCY_DATE",
    order: 7,
    link: "occupancyDisplay"
  },
  "LEASE_TYPE": {
    name: "LEASE_TYPE",
    value: "lease_type",
    label: "Lease Type",
    abbreviation: "LEASE_TYPE",
    order: 8,
    link: "leaseType"
  },
  "LISTING_STATE": {
    name: "LISTING_STATE",
    value: "listing_state",
    label: "Status",
    abbreviation: "LISTING_STATE",
    order: 9,
    link: "listingState"
  },
  "NUMBER_OF_CALLROOMS": {
    name: "NUMBER_OF_CALLROOMS",
    value: "number_of_callrooms",
    label: "Callrooms",
    abbreviation: "NUMBER_OF_CALLROOMS",
    order: 10,
    link: "numberOfCallrooms"
  },
  "NUMBER_OF_CONFERENCE_ROOMS": {
    name: "NUMBER_OF_CONFERENCE_ROOMS",
    value: "number_of_conference_rooms",
    label: "Conference Rooms",
    abbreviation: "NUMBER_OF_CONFERENCE_ROOMS",
    order: 11,
    link: "numberOfConferenceRooms"
  },
  "DESK_MONTHLY_RATE": {
    name: "DESK_MONTHLY_RATE",
    value: "desk_monthly_rate",
    label: "Cost/Month",
    abbreviation: "DESK_MONTHLY_RATE",
    order: 12,
    link: "deskMonthlyRate"
  },
  "CREATED_DATE": {
    name: "CREATED_DATE",
    value: "oldest_ml_created_date",
    label: "Created Date",
    abbreviation: "CREATED_DATE",
    order: 13,
    link: "oldestMlCreatedDate"
  },
  "DATE_AVAILABLE": {
    name: "DATE_AVAILABLE",
    value: "date_available",
    label: "Date On Market",
    abbreviation: "DATE_AVAILABLE",
    order: 14,
    link: "dateAvailable"
  },
  "ASKING_RATE": {
    name: "ASKING_RATE",
    value: "asking_rate",
    label: "Base Rent",
    abbreviation: "ASKING_RATE",
    order: 15,
    link: "askingRate"
  },
  "EXPENSE_TYPE": {
    name: "EXPENSE_TYPE",
    value: "expense_type",
    label: "Expense Type",
    abbreviation: "EXPENSE_TYPE",
    order: 16,
    link: "expenseType"
  },
  "EXPENSES": {
    name: "EXPENSES",
    value: "expenses",
    label: "Expenses",
    abbreviation: "EXPENSES",
    order: 17,
    link: "expenses"
  },
  "FLOOR_TYPE": {
    name: "FLOOR_TYPE",
    value: "floor_type",
    label: "Floor Type",
    abbreviation: "FLOOR_TYPE",
    order: 18,
    link: "floorTypeDisplay"
  },
  "IT_ROOM": {
    name: "IT_ROOM",
    value: "it_room",
    label: "IT Room",
    abbreviation: "IT_ROOM",
    order: 19,
    link: "itRoom"
  },
  "KITCHEN": {
    name: "KITCHEN",
    value: "kitchen",
    label: "Kitchen",
    abbreviation: "KITCHEN",
    order: 20,
    link: "kitchen"
  },
  "LEASE_END": {
    name: "LEASE_END",
    value: "lease_end",
    label: "Lease End",
    abbreviation: "LEASE_END",
    order: 21,
    link: "leaseEnd"
  },
  "MONTHLY_RENT": {
    name: "MONTHLY_RENT",
    value: "monthly_rent",
    label: "Monthly Rent",
    abbreviation: "MONTHLY_RENT",
    order: 22,
    link: "monthlyRent"
  },
  "NUMBER_OF_OFFICES": {
    name: "NUMBER_OF_OFFICES",
    value: "number_of_offices",
    label: "Offices",
    abbreviation: "NUMBER_OF_OFFICES",
    order: 23,
    link: "numberOfOffices"
  },
  "OUTDOOR_DECK": {
    name: "OUTDOOR_DECK",
    value: "outdoor_deck",
    label: "Outdoor Deck",
    abbreviation: "OUTDOOR_DECK",
    order: 24,
    link: "outdoorDeck"
  },
  "RECEPTION": {
    name: "RECEPTION",
    value: "reception",
    label: "Reception",
    abbreviation: "RECEPTION",
    order: 25,
    link: "reception"
  },
  "STORAGE_ROOM": {
    name: "STORAGE_ROOM",
    value: "storage_room",
    label: "Storage Room",
    abbreviation: "STORAGE_ROOM",
    order: 26,
    link: "storageRoom"
  },
  "DISPLAY_RATE_TYPE": {
    name: "DISPLAY_RATE_TYPE",
    value: "display_rate_type",
    label: "Units",
    abbreviation: "DISPLAY_RATE_TYPE",
    order: 27,
    link: "displayRateType"
  },
  "NUMBER_WORK_STATIONS": {
    name: "NUMBER_WORK_STATIONS",
    value: "number_work_stations",
    label: "Work stations",
    abbreviation: "NUMBER_WORK_STATIONS",
    order: 28,
    link: "numberWorkStations"
  },
  "YEARLY_RENT": {
    name: "YEARLY_RENT",
    value: "yearly_rent",
    label: "Yearly Rent",
    abbreviation: "YEARLY_RENT",
    order: 29,
    link: "yearlyRent"
  },
  "DESK_COUNT_DISPLAY": {
    name: "DESK_COUNT_DISPLAY",
    value: "desk_count_display",
    label: "Desk No.",
    abbreviation: "DESK_COUNT_DISPLAY",
    order: 30,
    link: "deskCountDisplay"
  }
};
export var SurveyStatusEnum = {
  values: {
    "": {
      name: "INVALID",
      value: "",
      label: "INVALID",
      abbreviation: "",
      order: 0
    },
    "in_progress": {
      name: "IN_PROGRESS",
      value: "in_progress",
      label: "In Progress",
      abbreviation: "IN_PROGRESS",
      order: 1
    },
    "processed": {
      name: "PROCESSED",
      value: "processed",
      label: "Processed",
      abbreviation: "PROCESSED",
      order: 2
    },
    "error": {
      name: "ERROR",
      value: "error",
      label: "Error",
      abbreviation: "ERROR",
      order: 3
    }
  },
  "INVALID": {
    name: "INVALID",
    value: "",
    label: "INVALID",
    abbreviation: "",
    order: 0
  },
  "IN_PROGRESS": {
    name: "IN_PROGRESS",
    value: "in_progress",
    label: "In Progress",
    abbreviation: "IN_PROGRESS",
    order: 1
  },
  "PROCESSED": {
    name: "PROCESSED",
    value: "processed",
    label: "Processed",
    abbreviation: "PROCESSED",
    order: 2
  },
  "ERROR": {
    name: "ERROR",
    value: "error",
    label: "Error",
    abbreviation: "ERROR",
    order: 3
  }
};
export var SurveyErrorStatusEnum = {
  values: {
    "new": {
      name: "NEW",
      value: "new",
      label: "New",
      abbreviation: "NEW",
      order: 0
    },
    "dismissed": {
      name: "DISMISSED",
      value: "dismissed",
      label: "Dismissed",
      abbreviation: "DISMISSED",
      order: 1
    }
  },
  "NEW": {
    name: "NEW",
    value: "new",
    label: "New",
    abbreviation: "NEW",
    order: 0
  },
  "DISMISSED": {
    name: "DISMISSED",
    value: "dismissed",
    label: "Dismissed",
    abbreviation: "DISMISSED",
    order: 1
  }
};
export var SurveyErrorTypeEnum = {
  values: {
    "": {
      name: "INVALID",
      value: "",
      label: "INVALID",
      abbreviation: "",
      order: 0
    },
    "parse_error": {
      name: "PARSE_ERROR",
      value: "parse_error",
      label: "Parse Error",
      abbreviation: "PARSE_ERROR",
      order: 1
    },
    "address_error": {
      name: "ADDRESS_ERROR",
      value: "address_error",
      label: "Address Error",
      abbreviation: "ADDRESS_ERROR",
      order: 2
    },
    "ms_system_error": {
      name: "MS_SYSTEM_ERROR",
      value: "ms_system_error",
      label: "System Error",
      abbreviation: "MS_SYSTEM_ERROR",
      order: 3
    },
    "los_system_error": {
      name: "LOS_SYSTEM_ERROR",
      value: "los_system_error",
      label: "System Error",
      abbreviation: "LOS_SYSTEM_ERROR",
      order: 4
    }
  },
  "INVALID": {
    name: "INVALID",
    value: "",
    label: "INVALID",
    abbreviation: "",
    order: 0
  },
  "PARSE_ERROR": {
    name: "PARSE_ERROR",
    value: "parse_error",
    label: "Parse Error",
    abbreviation: "PARSE_ERROR",
    order: 1
  },
  "ADDRESS_ERROR": {
    name: "ADDRESS_ERROR",
    value: "address_error",
    label: "Address Error",
    abbreviation: "ADDRESS_ERROR",
    order: 2
  },
  "MS_SYSTEM_ERROR": {
    name: "MS_SYSTEM_ERROR",
    value: "ms_system_error",
    label: "System Error",
    abbreviation: "MS_SYSTEM_ERROR",
    order: 3
  },
  "LOS_SYSTEM_ERROR": {
    name: "LOS_SYSTEM_ERROR",
    value: "los_system_error",
    label: "System Error",
    abbreviation: "LOS_SYSTEM_ERROR",
    order: 4
  }
};
export var OnboardingStatusEnum = {
  values: {
    "ready_to_invite": {
      name: "READY_TO_INVITE",
      value: "ready_to_invite",
      label: "Ready to Invite",
      abbreviation: "READY_TO_INVITE",
      order: 0
    },
    "invited": {
      name: "INVITED",
      value: "invited",
      label: "Invited",
      abbreviation: "INVITED",
      order: 1
    },
    "accepted": {
      name: "ACCEPTED",
      value: "accepted",
      label: "Accepted",
      abbreviation: "ACCEPTED",
      order: 2
    },
    "deactivated": {
      name: "DEACTIVATED",
      value: "deactivated",
      label: "Deactivated",
      abbreviation: "DEACTIVATED",
      order: 3
    }
  },
  "READY_TO_INVITE": {
    name: "READY_TO_INVITE",
    value: "ready_to_invite",
    label: "Ready to Invite",
    abbreviation: "READY_TO_INVITE",
    order: 0
  },
  "INVITED": {
    name: "INVITED",
    value: "invited",
    label: "Invited",
    abbreviation: "INVITED",
    order: 1
  },
  "ACCEPTED": {
    name: "ACCEPTED",
    value: "accepted",
    label: "Accepted",
    abbreviation: "ACCEPTED",
    order: 2
  },
  "DEACTIVATED": {
    name: "DEACTIVATED",
    value: "deactivated",
    label: "Deactivated",
    abbreviation: "DEACTIVATED",
    order: 3
  }
};
export var TagKeyEnum = {
  values: {
    "city": {
      name: "CITY",
      value: "city",
      label: "City",
      abbreviation: "CITY",
      order: 0
    }
  },
  "CITY": {
    name: "CITY",
    value: "city",
    label: "City",
    abbreviation: "CITY",
    order: 0
  }
};
export var DealroomTeamRoleEnum = {
  values: {
    "unknown": {
      name: "UNKNOWN",
      value: "unknown",
      label: "Unknown",
      abbreviation: "UNKNOWN",
      order: 0
    },
    "lead_broker": {
      name: "LEAD_BROKER",
      value: "lead_broker",
      label: "Lead Broker",
      abbreviation: "LEAD_BROKER",
      order: 1
    },
    "supporting_broker": {
      name: "SUPPORTING_BROKER",
      value: "supporting_broker",
      label: "Supporting Broker",
      abbreviation: "SUPPORTING_BROKER",
      order: 2
    },
    "sales_coordinator": {
      name: "SALES_COORDINATOR",
      value: "sales_coordinator",
      label: "Sales Coordinator",
      abbreviation: "SALES_COORDINATOR",
      order: 3
    }
  },
  "UNKNOWN": {
    name: "UNKNOWN",
    value: "unknown",
    label: "Unknown",
    abbreviation: "UNKNOWN",
    order: 0
  },
  "LEAD_BROKER": {
    name: "LEAD_BROKER",
    value: "lead_broker",
    label: "Lead Broker",
    abbreviation: "LEAD_BROKER",
    order: 1
  },
  "SUPPORTING_BROKER": {
    name: "SUPPORTING_BROKER",
    value: "supporting_broker",
    label: "Supporting Broker",
    abbreviation: "SUPPORTING_BROKER",
    order: 2
  },
  "SALES_COORDINATOR": {
    name: "SALES_COORDINATOR",
    value: "sales_coordinator",
    label: "Sales Coordinator",
    abbreviation: "SALES_COORDINATOR",
    order: 3
  }
};
export var TourbookState = {
  values: {
    "inprogress": {
      name: "INPROGRESS",
      value: "inprogress",
      label: "In Progress",
      abbreviation: "INPROGRESS",
      order: 0
    },
    "completed": {
      name: "COMPLETED",
      value: "completed",
      label: "Completed",
      abbreviation: "COMPLETED",
      order: 1
    },
    "failed": {
      name: "FAILED",
      value: "failed",
      label: "failed",
      abbreviation: "FAILED",
      order: 2
    }
  },
  "INPROGRESS": {
    name: "INPROGRESS",
    value: "inprogress",
    label: "In Progress",
    abbreviation: "INPROGRESS",
    order: 0
  },
  "COMPLETED": {
    name: "COMPLETED",
    value: "completed",
    label: "Completed",
    abbreviation: "COMPLETED",
    order: 1
  },
  "FAILED": {
    name: "FAILED",
    value: "failed",
    label: "failed",
    abbreviation: "FAILED",
    order: 2
  }
};
export var FlyerImportState = {
  values: {
    "inprogress": {
      name: "INPROGRESS",
      value: "inprogress",
      label: "In Progress",
      abbreviation: "INPROGRESS",
      order: 0
    },
    "completed": {
      name: "COMPLETED",
      value: "completed",
      label: "Completed",
      abbreviation: "COMPLETED",
      order: 1
    },
    "failed": {
      name: "FAILED",
      value: "failed",
      label: "failed",
      abbreviation: "FAILED",
      order: 2
    },
    "dismissed": {
      name: "DISMISSED",
      value: "dismissed",
      label: "Dismissed",
      abbreviation: "DISMISSED",
      order: 3
    }
  },
  "INPROGRESS": {
    name: "INPROGRESS",
    value: "inprogress",
    label: "In Progress",
    abbreviation: "INPROGRESS",
    order: 0
  },
  "COMPLETED": {
    name: "COMPLETED",
    value: "completed",
    label: "Completed",
    abbreviation: "COMPLETED",
    order: 1
  },
  "FAILED": {
    name: "FAILED",
    value: "failed",
    label: "failed",
    abbreviation: "FAILED",
    order: 2
  },
  "DISMISSED": {
    name: "DISMISSED",
    value: "dismissed",
    label: "Dismissed",
    abbreviation: "DISMISSED",
    order: 3
  }
};
export var DealroomsColumnDefinitionEnum = {
  values: {
    "client_access": {
      name: "CLIENT_ACCESS",
      value: "client_access",
      label: "Client Access",
      abbreviation: "CLIENT_ACCESS",
      order: 0
    },
    "shared_with": {
      name: "SHARED_WITH",
      value: "shared_with",
      label: "Shared With",
      abbreviation: "SHARED_WITH",
      order: 1
    },
    "client_transaction_name": {
      name: "CLIENT_TRANSACTION_NAME",
      value: "client_transaction_name",
      label: "Client Transaction Name",
      abbreviation: "CLIENT_TRANSACTION_NAME",
      order: 2
    },
    "stage": {
      name: "STAGE",
      value: "stage",
      label: "Stage",
      abbreviation: "STAGE",
      order: 3
    },
    "city": {
      name: "CITY",
      value: "city",
      label: "City(s)",
      abbreviation: "CITY",
      order: 4
    },
    "size": {
      name: "SIZE",
      value: "size",
      label: "Target Size",
      abbreviation: "SIZE",
      order: 5
    },
    "target_move_date": {
      name: "TARGET_MOVE_DATE",
      value: "target_move_date",
      label: "Target Move Date",
      abbreviation: "TARGET_MOVE_DATE",
      order: 6
    },
    "market": {
      name: "MARKET",
      value: "market",
      label: "Market",
      abbreviation: "MARKET",
      order: 7
    },
    "current_location_name": {
      name: "CURRENT_LOCATION_NAME",
      value: "current_location_name",
      label: "Current Location Name",
      abbreviation: "CURRENT_LOCATION_NAME",
      order: 8
    },
    "current_address": {
      name: "CURRENT_ADDRESS",
      value: "current_address",
      label: "Current Address",
      abbreviation: "CURRENT_ADDRESS",
      order: 9
    },
    "current_lease_exp": {
      name: "CURRENT_LEASE_EXP",
      value: "current_lease_exp",
      label: "Current Lease Exp",
      abbreviation: "CURRENT_LEASE_EXP",
      order: 10
    },
    "renewal_notice": {
      name: "RENEWAL_NOTICE",
      value: "renewal_notice",
      label: "Renewal Notice",
      abbreviation: "RENEWAL_NOTICE",
      order: 11
    },
    "expansion_notice": {
      name: "EXPANSION_NOTICE",
      value: "expansion_notice",
      label: "Expansion Notice",
      abbreviation: "EXPANSION_NOTICE",
      order: 12
    },
    "term": {
      name: "TERM",
      value: "term",
      label: "Term",
      abbreviation: "TERM",
      order: 13
    },
    "transaction_notes": {
      name: "TRANSACTION_NOTES",
      value: "transaction_notes",
      label: "Transaction Notes",
      abbreviation: "TRANSACTION_NOTES",
      order: 14
    },
    "days_in_stage": {
      name: "DAYS_IN_STAGE",
      value: "days_in_stage",
      label: "Days in Stage",
      abbreviation: "DAYS_IN_STAGE",
      order: 15
    },
    "days_active": {
      name: "DAYS_ACTIVE",
      value: "days_active",
      label: "Days Active",
      abbreviation: "DAYS_ACTIVE",
      order: 16
    }
  },
  "CLIENT_ACCESS": {
    name: "CLIENT_ACCESS",
    value: "client_access",
    label: "Client Access",
    abbreviation: "CLIENT_ACCESS",
    order: 0
  },
  "SHARED_WITH": {
    name: "SHARED_WITH",
    value: "shared_with",
    label: "Shared With",
    abbreviation: "SHARED_WITH",
    order: 1
  },
  "CLIENT_TRANSACTION_NAME": {
    name: "CLIENT_TRANSACTION_NAME",
    value: "client_transaction_name",
    label: "Client Transaction Name",
    abbreviation: "CLIENT_TRANSACTION_NAME",
    order: 2
  },
  "STAGE": {
    name: "STAGE",
    value: "stage",
    label: "Stage",
    abbreviation: "STAGE",
    order: 3
  },
  "CITY": {
    name: "CITY",
    value: "city",
    label: "City(s)",
    abbreviation: "CITY",
    order: 4
  },
  "SIZE": {
    name: "SIZE",
    value: "size",
    label: "Target Size",
    abbreviation: "SIZE",
    order: 5
  },
  "TARGET_MOVE_DATE": {
    name: "TARGET_MOVE_DATE",
    value: "target_move_date",
    label: "Target Move Date",
    abbreviation: "TARGET_MOVE_DATE",
    order: 6
  },
  "MARKET": {
    name: "MARKET",
    value: "market",
    label: "Market",
    abbreviation: "MARKET",
    order: 7
  },
  "CURRENT_LOCATION_NAME": {
    name: "CURRENT_LOCATION_NAME",
    value: "current_location_name",
    label: "Current Location Name",
    abbreviation: "CURRENT_LOCATION_NAME",
    order: 8
  },
  "CURRENT_ADDRESS": {
    name: "CURRENT_ADDRESS",
    value: "current_address",
    label: "Current Address",
    abbreviation: "CURRENT_ADDRESS",
    order: 9
  },
  "CURRENT_LEASE_EXP": {
    name: "CURRENT_LEASE_EXP",
    value: "current_lease_exp",
    label: "Current Lease Exp",
    abbreviation: "CURRENT_LEASE_EXP",
    order: 10
  },
  "RENEWAL_NOTICE": {
    name: "RENEWAL_NOTICE",
    value: "renewal_notice",
    label: "Renewal Notice",
    abbreviation: "RENEWAL_NOTICE",
    order: 11
  },
  "EXPANSION_NOTICE": {
    name: "EXPANSION_NOTICE",
    value: "expansion_notice",
    label: "Expansion Notice",
    abbreviation: "EXPANSION_NOTICE",
    order: 12
  },
  "TERM": {
    name: "TERM",
    value: "term",
    label: "Term",
    abbreviation: "TERM",
    order: 13
  },
  "TRANSACTION_NOTES": {
    name: "TRANSACTION_NOTES",
    value: "transaction_notes",
    label: "Transaction Notes",
    abbreviation: "TRANSACTION_NOTES",
    order: 14
  },
  "DAYS_IN_STAGE": {
    name: "DAYS_IN_STAGE",
    value: "days_in_stage",
    label: "Days in Stage",
    abbreviation: "DAYS_IN_STAGE",
    order: 15
  },
  "DAYS_ACTIVE": {
    name: "DAYS_ACTIVE",
    value: "days_active",
    label: "Days Active",
    abbreviation: "DAYS_ACTIVE",
    order: 16
  }
};
export var CustomFieldTypeEnum = {
  values: {
    "dropdown": {
      name: "DROPDOWN",
      value: "dropdown",
      label: "Dropdown",
      abbreviation: "DROPDOWN",
      order: 0
    },
    "date": {
      name: "DATE",
      value: "date",
      label: "Date",
      abbreviation: "DATE",
      order: 1
    },
    "string": {
      name: "STRING",
      value: "string",
      label: "Short Text",
      abbreviation: "STRING",
      order: 2
    },
    "number": {
      name: "NUMBER",
      value: "number",
      label: "Number",
      abbreviation: "NUMBER",
      order: 3
    }
  },
  "DROPDOWN": {
    name: "DROPDOWN",
    value: "dropdown",
    label: "Dropdown",
    abbreviation: "DROPDOWN",
    order: 0
  },
  "DATE": {
    name: "DATE",
    value: "date",
    label: "Date",
    abbreviation: "DATE",
    order: 1
  },
  "STRING": {
    name: "STRING",
    value: "string",
    label: "Short Text",
    abbreviation: "STRING",
    order: 2
  },
  "NUMBER": {
    name: "NUMBER",
    value: "number",
    label: "Number",
    abbreviation: "NUMBER",
    order: 3
  }
};
export var FeatureFlag = {
  values: {
    "flyer-parser": {
      name: "FLYER_PARSER",
      value: "flyer-parser",
      label: "Flyer Parser",
      abbreviation: "FLYER_PARSER",
      order: 0
    },
    "client-weekly-digest": {
      name: "CLIENT_WEEKLY_DIGEST",
      value: "client-weekly-digest",
      label: "Client Weekly Digest",
      abbreviation: "CLIENT_WEEKLY_DIGEST",
      order: 1
    },
    "broker-weekly-digest": {
      name: "BROKER_WEEKLY_DIGEST",
      value: "broker-weekly-digest",
      label: "Broker Weekly Digest",
      abbreviation: "BROKER_WEEKLY_DIGEST",
      order: 2
    },
    "use-otp-login": {
      name: "USE_OTP_LOGIN",
      value: "use-otp-login",
      label: "Use OTP Login",
      abbreviation: "USE_OTP_LOGIN",
      order: 3
    },
    "use-drs-notification-lambda": {
      name: "USE_DRS_NOTIFICATION_LAMBDA",
      value: "use-drs-notification-lambda",
      label: "Use DRS Notification Lambda",
      abbreviation: "USE_DRS_NOTIFICATION_LAMBDA",
      order: 4
    },
    "drs-workplace-analytics": {
      name: "USE_DRS_WPA",
      value: "drs-workplace-analytics",
      label: "Use DRS DocumentDb for Workplace Analytics",
      abbreviation: "USE_DRS_WPA",
      order: 5
    },
    "listing-details-ui-revamp": {
      name: "LISTING_DETAILS_UI_REVAMP",
      value: "listing-details-ui-revamp",
      label: "Listing Details UI Revamp",
      abbreviation: "LISTING_DETAILS_UI_REVAMP",
      order: 6
    },
    "use-drs-tourbook-lambda": {
      name: "USE_DRS_TOURBOOK",
      value: "use-drs-tourbook-lambda",
      label: "Use DRS Tourbook Lambda",
      abbreviation: "USE_DRS_TOURBOOK",
      order: 7
    },
    "s3-direct-upload": {
      name: "S3_DIRECT_UPLOAD",
      value: "s3-direct-upload",
      label: "S3 Direct Upload for Listings/Building/Documents",
      abbreviation: "S3_DIRECT_UPLOAD",
      order: 8
    },
    "closeout-package": {
      name: "CLOSEOUT_PACKAGE",
      value: "closeout-package",
      label: "Closeout Package",
      abbreviation: "CLOSEOUT_PACKAGE",
      order: 9
    },
    "closeout-package-for-clients": {
      name: "CLOSEOUT_PACKAGE_FOR_CLIENTS",
      value: "closeout-package-for-clients",
      label: "Closeout Package for Clients",
      abbreviation: "CLOSEOUT_PACKAGE_FOR_CLIENTS",
      order: 10
    },
    "graphql-statsd-metrics": {
      name: "GRAPHQL_STATSD_METRICS",
      value: "graphql-statsd-metrics",
      label: "GraphQL StatsD Metrics",
      abbreviation: "GRAPHQL_STATSD_METRICS",
      order: 11
    },
    "e2e-seed": {
      name: "E2E_SEED",
      value: "e2e-seed",
      label: "E2E Seed Endpoints",
      abbreviation: "E2E_SEED",
      order: 12
    },
    "use-alize-pages": {
      name: "USE_ALIZE_PAGES",
      value: "use-alize-pages",
      label: "Use Alize Pages",
      abbreviation: "USE_ALIZE_PAGES",
      order: 13
    },
    "use-costar-merged-listings": {
      name: "USE_COSTAR_MERGED_LISTINGS",
      value: "use-costar-merged-listings",
      label: "Use CoStar Merged Listings",
      abbreviation: "USE_COSTAR_MERGED_LISTINGS",
      order: 14
    },
    "mock-costar-test-failed-imports": {
      name: "MOCK_COSTAR_TEST_FAILED_IMPORTS",
      value: "mock-costar-test-failed-imports",
      label: "CoStar Mock Import Failure",
      abbreviation: "MOCK_COSTAR_TEST_FAILED_IMPORTS",
      order: 15
    }
  },
  "FLYER_PARSER": {
    name: "FLYER_PARSER",
    value: "flyer-parser",
    label: "Flyer Parser",
    abbreviation: "FLYER_PARSER",
    order: 0
  },
  "CLIENT_WEEKLY_DIGEST": {
    name: "CLIENT_WEEKLY_DIGEST",
    value: "client-weekly-digest",
    label: "Client Weekly Digest",
    abbreviation: "CLIENT_WEEKLY_DIGEST",
    order: 1
  },
  "BROKER_WEEKLY_DIGEST": {
    name: "BROKER_WEEKLY_DIGEST",
    value: "broker-weekly-digest",
    label: "Broker Weekly Digest",
    abbreviation: "BROKER_WEEKLY_DIGEST",
    order: 2
  },
  "USE_OTP_LOGIN": {
    name: "USE_OTP_LOGIN",
    value: "use-otp-login",
    label: "Use OTP Login",
    abbreviation: "USE_OTP_LOGIN",
    order: 3
  },
  "USE_DRS_NOTIFICATION_LAMBDA": {
    name: "USE_DRS_NOTIFICATION_LAMBDA",
    value: "use-drs-notification-lambda",
    label: "Use DRS Notification Lambda",
    abbreviation: "USE_DRS_NOTIFICATION_LAMBDA",
    order: 4
  },
  "USE_DRS_WPA": {
    name: "USE_DRS_WPA",
    value: "drs-workplace-analytics",
    label: "Use DRS DocumentDb for Workplace Analytics",
    abbreviation: "USE_DRS_WPA",
    order: 5
  },
  "LISTING_DETAILS_UI_REVAMP": {
    name: "LISTING_DETAILS_UI_REVAMP",
    value: "listing-details-ui-revamp",
    label: "Listing Details UI Revamp",
    abbreviation: "LISTING_DETAILS_UI_REVAMP",
    order: 6
  },
  "USE_DRS_TOURBOOK": {
    name: "USE_DRS_TOURBOOK",
    value: "use-drs-tourbook-lambda",
    label: "Use DRS Tourbook Lambda",
    abbreviation: "USE_DRS_TOURBOOK",
    order: 7
  },
  "S3_DIRECT_UPLOAD": {
    name: "S3_DIRECT_UPLOAD",
    value: "s3-direct-upload",
    label: "S3 Direct Upload for Listings/Building/Documents",
    abbreviation: "S3_DIRECT_UPLOAD",
    order: 8
  },
  "CLOSEOUT_PACKAGE": {
    name: "CLOSEOUT_PACKAGE",
    value: "closeout-package",
    label: "Closeout Package",
    abbreviation: "CLOSEOUT_PACKAGE",
    order: 9
  },
  "CLOSEOUT_PACKAGE_FOR_CLIENTS": {
    name: "CLOSEOUT_PACKAGE_FOR_CLIENTS",
    value: "closeout-package-for-clients",
    label: "Closeout Package for Clients",
    abbreviation: "CLOSEOUT_PACKAGE_FOR_CLIENTS",
    order: 10
  },
  "GRAPHQL_STATSD_METRICS": {
    name: "GRAPHQL_STATSD_METRICS",
    value: "graphql-statsd-metrics",
    label: "GraphQL StatsD Metrics",
    abbreviation: "GRAPHQL_STATSD_METRICS",
    order: 11
  },
  "E2E_SEED": {
    name: "E2E_SEED",
    value: "e2e-seed",
    label: "E2E Seed Endpoints",
    abbreviation: "E2E_SEED",
    order: 12
  },
  "USE_ALIZE_PAGES": {
    name: "USE_ALIZE_PAGES",
    value: "use-alize-pages",
    label: "Use Alize Pages",
    abbreviation: "USE_ALIZE_PAGES",
    order: 13
  },
  "USE_COSTAR_MERGED_LISTINGS": {
    name: "USE_COSTAR_MERGED_LISTINGS",
    value: "use-costar-merged-listings",
    label: "Use CoStar Merged Listings",
    abbreviation: "USE_COSTAR_MERGED_LISTINGS",
    order: 14
  },
  "MOCK_COSTAR_TEST_FAILED_IMPORTS": {
    name: "MOCK_COSTAR_TEST_FAILED_IMPORTS",
    value: "mock-costar-test-failed-imports",
    label: "CoStar Mock Import Failure",
    abbreviation: "MOCK_COSTAR_TEST_FAILED_IMPORTS",
    order: 15
  }
};
export var ContextKind = {
  values: {
    "organization": {
      name: "ORGANIZATION",
      value: "organization",
      label: "Organization",
      abbreviation: "ORGANIZATION",
      order: 0
    },
    "user": {
      name: "USER",
      value: "user",
      label: "User",
      abbreviation: "USER",
      order: 1
    }
  },
  "ORGANIZATION": {
    name: "ORGANIZATION",
    value: "organization",
    label: "Organization",
    abbreviation: "ORGANIZATION",
    order: 0
  },
  "USER": {
    name: "USER",
    value: "user",
    label: "User",
    abbreviation: "USER",
    order: 1
  }
};
export var ContactAccessLogActionEnum = {
  values: {
    "added": {
      name: "ADDED",
      value: "added",
      label: "Added",
      abbreviation: "ADDED",
      order: 0
    },
    "removed": {
      name: "REMOVED",
      value: "removed",
      label: "Removed",
      abbreviation: "REMOVED",
      order: 1
    }
  },
  "ADDED": {
    name: "ADDED",
    value: "added",
    label: "Added",
    abbreviation: "ADDED",
    order: 0
  },
  "REMOVED": {
    name: "REMOVED",
    value: "removed",
    label: "Removed",
    abbreviation: "REMOVED",
    order: 1
  }
};
export var TransactionLayoutsEnum = {
  values: {
    "table": {
      name: "TABLE",
      value: "table",
      label: "Table",
      abbreviation: "TABLE",
      order: 0
    },
    "card": {
      name: "CARD",
      value: "card",
      label: "Card",
      abbreviation: "CARD",
      order: 1
    },
    "map": {
      name: "MAP",
      value: "map",
      label: "Map",
      abbreviation: "MAP",
      order: 2
    }
  },
  "TABLE": {
    name: "TABLE",
    value: "table",
    label: "Table",
    abbreviation: "TABLE",
    order: 0
  },
  "CARD": {
    name: "CARD",
    value: "card",
    label: "Card",
    abbreviation: "CARD",
    order: 1
  },
  "MAP": {
    name: "MAP",
    value: "map",
    label: "Map",
    abbreviation: "MAP",
    order: 2
  }
};
export var TransactionViewsEnum = {
  values: {
    "building": {
      name: "BUILDING",
      value: "building",
      label: "Building",
      abbreviation: "BUILDING",
      order: 0
    },
    "listing": {
      name: "LISTING",
      value: "listing",
      label: "Listing",
      abbreviation: "LISTING",
      order: 1
    }
  },
  "BUILDING": {
    name: "BUILDING",
    value: "building",
    label: "Building",
    abbreviation: "BUILDING",
    order: 0
  },
  "LISTING": {
    name: "LISTING",
    value: "listing",
    label: "Listing",
    abbreviation: "LISTING",
    order: 1
  }
};
export var AllowedFileTypeEnum = {
  values: {
    "application/acad": {
      name: "ACAD",
      value: "application/acad",
      label: "ACAD",
      abbreviation: "ACAD",
      order: 0
    },
    "text/csv": {
      name: "CSV",
      value: "text/csv",
      label: "CSV",
      abbreviation: "CSV",
      order: 1
    },
    "application/msword": {
      name: "DOC",
      value: "application/msword",
      label: "DOC",
      abbreviation: "DOC",
      order: 2
    },
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
      name: "DOCX",
      value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      label: "DOCX",
      abbreviation: "DOCX",
      order: 3
    },
    ".dwg": {
      name: "DWG",
      value: ".dwg",
      label: "DWG",
      abbreviation: "DWG",
      order: 4
    },
    "image/gif": {
      name: "GIF",
      value: "image/gif",
      label: "GIF",
      abbreviation: "GIF",
      order: 5
    },
    "image/jpeg": {
      name: "JPEG",
      value: "image/jpeg",
      label: "JPEG",
      abbreviation: "JPEG",
      order: 6
    },
    "application/pdf": {
      name: "PDF",
      value: "application/pdf",
      label: "PDF",
      abbreviation: "PDF",
      order: 7
    },
    "image/png": {
      name: "PNG",
      value: "image/png",
      label: "PNG",
      abbreviation: "PNG",
      order: 8
    },
    "application/vnd.ms-powerpoint": {
      name: "PPT",
      value: "application/vnd.ms-powerpoint",
      label: "PPT",
      abbreviation: "PPT",
      order: 9
    },
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
      name: "PPTX",
      value: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      label: "PPTX",
      abbreviation: "PPTX",
      order: 10
    },
    "text/plain": {
      name: "TXT",
      value: "text/plain",
      label: "TXT",
      abbreviation: "TXT",
      order: 11
    },
    "image/webp": {
      name: "WEBP",
      value: "image/webp",
      label: "WEBP",
      abbreviation: "WEBP",
      order: 12
    },
    "application/vnd.ms-excel": {
      name: "XLS",
      value: "application/vnd.ms-excel",
      label: "XLS",
      abbreviation: "XLS",
      order: 13
    },
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
      name: "XLSX",
      value: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      label: "XLSX",
      abbreviation: "XLSX",
      order: 14
    }
  },
  "ACAD": {
    name: "ACAD",
    value: "application/acad",
    label: "ACAD",
    abbreviation: "ACAD",
    order: 0
  },
  "CSV": {
    name: "CSV",
    value: "text/csv",
    label: "CSV",
    abbreviation: "CSV",
    order: 1
  },
  "DOC": {
    name: "DOC",
    value: "application/msword",
    label: "DOC",
    abbreviation: "DOC",
    order: 2
  },
  "DOCX": {
    name: "DOCX",
    value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    label: "DOCX",
    abbreviation: "DOCX",
    order: 3
  },
  "DWG": {
    name: "DWG",
    value: ".dwg",
    label: "DWG",
    abbreviation: "DWG",
    order: 4
  },
  "GIF": {
    name: "GIF",
    value: "image/gif",
    label: "GIF",
    abbreviation: "GIF",
    order: 5
  },
  "JPEG": {
    name: "JPEG",
    value: "image/jpeg",
    label: "JPEG",
    abbreviation: "JPEG",
    order: 6
  },
  "PDF": {
    name: "PDF",
    value: "application/pdf",
    label: "PDF",
    abbreviation: "PDF",
    order: 7
  },
  "PNG": {
    name: "PNG",
    value: "image/png",
    label: "PNG",
    abbreviation: "PNG",
    order: 8
  },
  "PPT": {
    name: "PPT",
    value: "application/vnd.ms-powerpoint",
    label: "PPT",
    abbreviation: "PPT",
    order: 9
  },
  "PPTX": {
    name: "PPTX",
    value: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    label: "PPTX",
    abbreviation: "PPTX",
    order: 10
  },
  "TXT": {
    name: "TXT",
    value: "text/plain",
    label: "TXT",
    abbreviation: "TXT",
    order: 11
  },
  "WEBP": {
    name: "WEBP",
    value: "image/webp",
    label: "WEBP",
    abbreviation: "WEBP",
    order: 12
  },
  "XLS": {
    name: "XLS",
    value: "application/vnd.ms-excel",
    label: "XLS",
    abbreviation: "XLS",
    order: 13
  },
  "XLSX": {
    name: "XLSX",
    value: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    label: "XLSX",
    abbreviation: "XLSX",
    order: 14
  }
};
export var CloseoutPackageStatusEnum = {
  values: {
    "PENDING": {
      name: "PENDING",
      value: "PENDING",
      label: "PENDING",
      abbreviation: "PENDING",
      order: 0
    },
    "PROCESSING": {
      name: "PROCESSING",
      value: "PROCESSING",
      label: "PROCESSING",
      abbreviation: "PROCESSING",
      order: 1
    },
    "COMPLETED": {
      name: "COMPLETED",
      value: "COMPLETED",
      label: "COMPLETED",
      abbreviation: "COMPLETED",
      order: 2
    },
    "FAILED": {
      name: "FAILED",
      value: "FAILED",
      label: "FAILED",
      abbreviation: "FAILED",
      order: 3
    }
  },
  "PENDING": {
    name: "PENDING",
    value: "PENDING",
    label: "PENDING",
    abbreviation: "PENDING",
    order: 0
  },
  "PROCESSING": {
    name: "PROCESSING",
    value: "PROCESSING",
    label: "PROCESSING",
    abbreviation: "PROCESSING",
    order: 1
  },
  "COMPLETED": {
    name: "COMPLETED",
    value: "COMPLETED",
    label: "COMPLETED",
    abbreviation: "COMPLETED",
    order: 2
  },
  "FAILED": {
    name: "FAILED",
    value: "FAILED",
    label: "FAILED",
    abbreviation: "FAILED",
    order: 3
  }
};
export var CostarSurveyStatusEnum = {
  values: {
    "queued": {
      name: "QUEUED",
      value: "queued",
      label: "Queued",
      abbreviation: "QUEUED",
      order: 0
    },
    "in_progress": {
      name: "IN_PROGRESS",
      value: "in_progress",
      label: "In Progress",
      abbreviation: "IN_PROGRESS",
      order: 1
    },
    "completed": {
      name: "COMPLETED",
      value: "completed",
      label: "Completed",
      abbreviation: "COMPLETED",
      order: 2
    },
    "failed": {
      name: "FAILED",
      value: "failed",
      label: "Failed",
      abbreviation: "FAILED",
      order: 3
    }
  },
  "QUEUED": {
    name: "QUEUED",
    value: "queued",
    label: "Queued",
    abbreviation: "QUEUED",
    order: 0
  },
  "IN_PROGRESS": {
    name: "IN_PROGRESS",
    value: "in_progress",
    label: "In Progress",
    abbreviation: "IN_PROGRESS",
    order: 1
  },
  "COMPLETED": {
    name: "COMPLETED",
    value: "completed",
    label: "Completed",
    abbreviation: "COMPLETED",
    order: 2
  },
  "FAILED": {
    name: "FAILED",
    value: "failed",
    label: "Failed",
    abbreviation: "FAILED",
    order: 3
  }
};
export var CostarErrorCodeEnum = {
  values: {
    "COSTAR_AUTH_REQUIRED": {
      name: "COSTAR_AUTH_REQUIRED",
      value: "COSTAR_AUTH_REQUIRED",
      label: "CoStar authorization required",
      abbreviation: "COSTAR_AUTH_REQUIRED",
      order: 0
    },
    "COSTAR_AUTH_EXPIRED": {
      name: "COSTAR_AUTH_EXPIRED",
      value: "COSTAR_AUTH_EXPIRED",
      label: "CoStar session expired",
      abbreviation: "COSTAR_AUTH_EXPIRED",
      order: 1
    },
    "COSTAR_API_ERROR": {
      name: "COSTAR_API_ERROR",
      value: "COSTAR_API_ERROR",
      label: "CoStar API error",
      abbreviation: "COSTAR_API_ERROR",
      order: 2
    },
    "COSTAR_IMPORT_ENQUEUE_FAILED": {
      name: "COSTAR_IMPORT_ENQUEUE_FAILED",
      value: "COSTAR_IMPORT_ENQUEUE_FAILED",
      label: "Failed to enqueue CoStar import",
      abbreviation: "COSTAR_IMPORT_ENQUEUE_FAILED",
      order: 3
    },
    "COSTAR_INTERNAL_ERROR": {
      name: "COSTAR_INTERNAL_ERROR",
      value: "COSTAR_INTERNAL_ERROR",
      label: "CoStar internal error",
      abbreviation: "COSTAR_INTERNAL_ERROR",
      order: 4
    }
  },
  "COSTAR_AUTH_REQUIRED": {
    name: "COSTAR_AUTH_REQUIRED",
    value: "COSTAR_AUTH_REQUIRED",
    label: "CoStar authorization required",
    abbreviation: "COSTAR_AUTH_REQUIRED",
    order: 0
  },
  "COSTAR_AUTH_EXPIRED": {
    name: "COSTAR_AUTH_EXPIRED",
    value: "COSTAR_AUTH_EXPIRED",
    label: "CoStar session expired",
    abbreviation: "COSTAR_AUTH_EXPIRED",
    order: 1
  },
  "COSTAR_API_ERROR": {
    name: "COSTAR_API_ERROR",
    value: "COSTAR_API_ERROR",
    label: "CoStar API error",
    abbreviation: "COSTAR_API_ERROR",
    order: 2
  },
  "COSTAR_IMPORT_ENQUEUE_FAILED": {
    name: "COSTAR_IMPORT_ENQUEUE_FAILED",
    value: "COSTAR_IMPORT_ENQUEUE_FAILED",
    label: "Failed to enqueue CoStar import",
    abbreviation: "COSTAR_IMPORT_ENQUEUE_FAILED",
    order: 3
  },
  "COSTAR_INTERNAL_ERROR": {
    name: "COSTAR_INTERNAL_ERROR",
    value: "COSTAR_INTERNAL_ERROR",
    label: "CoStar internal error",
    abbreviation: "COSTAR_INTERNAL_ERROR",
    order: 4
  }
};